(() => {
  'use strict';

  if (window.__HARDRIP_V2050__) return;
  window.__HARDRIP_V2050__ = true;

  const ROOT = document.documentElement;
  const clean = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();
  const normalizedPath = location.pathname.replace(/^\/en(?=\/|$)/i, '') || '/';
  const locale = clean(window.Shopify?.locale || ROOT.lang || '').toLowerCase();
  const EN = /^en(?:-|$)/.test(locale) || /^\/en(?:\/|$)/i.test(location.pathname);
  const POLICY_URL = window.__HARDRIP_POLICY_PAGES_V2050_URL__ || window.__HARDRIP_POLICY_PAGES_V2027_URL__ || window.__HARDRIP_POLICY_PAGES_V2026_URL__ || window.__HARDRIP_POLICY_PAGES_V2025_URL__ || window.__HARDRIP_POLICY_PAGES_V2024_URL__ || '';
  let policyCache = null;
  let scheduled = false;

  const EXACT = new Map(Object.entries({
    'SPEDIZIONE GRATUITA SU TUTTI GLI ORDINI': 'FREE SHIPPING ON ALL ORDERS',
    'Spedizione gratuita su tutti gli ordini': 'Free shipping on all orders',
    'SCOPRI LE NOVITÀ': 'SHOP NEW ARRIVALS',
    'Scopri le novità': 'Shop new arrivals',
    'Discover the news': 'Shop new arrivals',
    'DISCOVER THE NEWS': 'SHOP NEW ARRIVALS',
    'Discover new arrivals': 'Shop new arrivals',
    'DISCOVER NEW ARRIVALS': 'SHOP NEW ARRIVALS',
    'SEGUICI SU INSTAGRAM': 'FOLLOW US ON INSTAGRAM',
    'Seguici su Instagram': 'Follow us on Instagram',
    'RECENSIONI REALI': 'REAL REVIEWS',
    'Recensioni reali': 'Real reviews',
    'COSA DICONO DI NOI': 'WHAT OUR CUSTOMERS SAY',
    'Cosa dicono di noi': 'What our customers say',
    'Esperienze reali di chi ha scelto HARDRIP.': 'Real experiences from customers who chose HARDRIP.',
    'Scopri altre recensioni': 'See more reviews',
    'SCOPRI ALTRE RECENSIONI': 'SEE MORE REVIEWS',
    'Caricamento recensioni…': 'Loading reviews…',
    'Aggiornamento recensioni…': 'Updating reviews…',
    'Nessuna recensione corrisponde al filtro selezionato.': 'No reviews match the selected filter.',
    'Più convincenti': 'Most helpful',
    'Più recenti': 'Most recent',
    'Valutazione più alta': 'Highest rating',
    'Valutazione più bassa': 'Lowest rating',
    'Prima foto e video': 'Photos and videos first',
    'Con foto o video': 'With photos or videos',
    '5 stelle': '5 stars',
    '4 stelle': '4 stars',
    '3 stelle o meno': '3 stars or fewer',
    '1481 recensioni reali': '1481 real reviews',
    'recensioni reali': 'real reviews',
    'Chi siamo?': 'About us',
    'CHI SIAMO?': 'ABOUT US',
    'Link rapidi': 'Quick links',
    'LINK RAPIDI': 'QUICK LINKS',
    'Gioielli dal design luxury per chi vuole distinguersi davvero.': 'Luxury-designed jewelry for those who truly want to stand out.',
    'Dalle collezioni iconiche alle creazioni personalizzate su richiesta, ogni pezzo nasce per unire stile, brillantezza e cura dei dettagli, offrendo la massima qualità al miglior prezzo.': 'From iconic collections to custom creations on request, every piece is designed to combine style, brilliance and attention to detail, offering the highest quality at the best price.',
    'Dalle collezioni iconiche alle': 'From iconic collections to',
    'creazioni personalizzate su richiesta': 'custom creations on request',
    ', ogni pezzo nasce per unire stile, brillantezza e cura dei dettagli, offrendo': ', every piece is designed to combine style, brilliance and attention to detail, offering',
    'la massima qualità al miglior prezzo.': 'the highest quality at the best price.',
    'Iscriviti per rimanere aggiornato sulle novità, rilascio di nuovi prodotti e sconti.': 'Subscribe for new releases, product drops and exclusive discounts.',
    'Indirizzo email': 'Email address',
    'Paese/Area geografica': 'Country/region',
    'Lingua': 'Language',
    'Tutti i Prodotti': 'All products',
    'Argento 925 & VVS Moissanite': '925 Sterling Silver & VVS Moissanite',
    'Collane': 'Necklaces',
    'Bracciali': 'Bracelets',
    'Anelli': 'Rings',
    'Orecchini': 'Earrings',
    'Ciondoli': 'Pendants',
    'Guida Alle Taglie': 'Size Guide',
    'Traccia Il Tuo Ordine': 'Track Your Order',
    'Domande Frequenti': 'Frequently Asked Questions',
    'Contattaci': 'Contact us',
    'Modulo Di Recesso': 'Right of Withdrawal Form',
    'Modulo di recesso': 'Withdrawal form',
    'INFORMAZIONI IMPORTANTI': 'IMPORTANT INFORMATION',
    'Informazioni importanti': 'Important information',
    'PRIMA DI INVIARE LA RICHIESTA': 'BEFORE SENDING THE REQUEST',
    'Prima di inviare la richiesta': 'Before sending the request',
    'Richiesta entro 14 giorni': 'Request within 14 days',
    'Condizioni del prodotto': 'Product conditions',
    'Prodotti personalizzati': 'Custom products',
    'Costi di reso': 'Return costs',
    'Attendi le istruzioni prima di spedire': 'Wait for instructions before shipping',
    'Consulta l’informativa completa sui rimborsi': 'Read the full refund policy',
    "Consulta l'informativa completa sui rimborsi": 'Read the full refund policy',
    'Informativa sui rimborsi': 'Refund policy',
    'Informativa sulla privacy': 'Privacy policy',
    'Termini e condizioni del servizio': 'Terms of service',
    'Informativa sulle spedizioni': 'Shipping policy',
    'Recapiti': 'Contact information',
    'Informativa legale': 'Legal notice',
    'Cerca': 'Search',
    'Colore': 'Color',
    'Colore:': 'Color:',
    'Lunghezza': 'Length',
    'Lunghezza:': 'Length:',
    'Misura': 'Size',
    'Misura:': 'Size:',
    'Quantità': 'Quantity',
    'Aggiungi al carrello': 'Add to cart',
    'Imposte incluse.': 'Taxes included.',
    'In offerta': 'Sale',
    'Ciao 👋': 'Hello 👋',
    'Ciao': 'Hello',
    'Come possiamo aiutarti?': 'How can we help you?',
    'Siamo online': 'We are online',
    'TRACCIAMENTO DELL’ORDINE': 'ORDER TRACKING',
    "TRACCIAMENTO DELL'ORDINE": 'ORDER TRACKING',
    'Tracciamento dell’ordine': 'Order tracking',
    "Tracciamento dell'ordine": 'Order tracking',
    'Tieni traccia dei tuoi ordini': 'Track your orders',
    'Cerca aiuto': 'Search for help',
    'Aiuto': 'Help',
    'Categorie': 'Categories',
    'Mostra tutto': 'Show all',
    'Articolo': 'Article',
    'Articoli': 'Articles',
    'Indirizzo e-mail': 'Email address',
    'Indirizzo E-mail': 'Email address',
    'E-mail': 'Email',
    'Traccia': 'Track',
    'Numero di tracciamento': 'Tracking number',
    'numero di tracciamento': 'Tracking number',
    'Numero tracciamento': 'Tracking number',
    'numero tracciamento': 'Tracking number',
    'Ad esempio 1001': 'For example 1001',
    'ad esempio 1001': 'For example 1001',
    'Ad esempio 10001': 'For example 10001',
    'ad esempio 10001': 'For example 10001',
    'Numero ordine': 'Order number',
    'numero ordine': 'Order number',
    'Numero di telefono': 'Telephone number',
    'numero di telefono': 'Telephone number',
    'Messaggio': 'Message',
    'Il tuo messaggio': 'Your message',
    'Nome': 'Name',
    'Il tuo nome': 'Your name',
    'Invia': 'Send',
    'Ottieni uno sconto del 15% sul tuo prossimo ordine': 'Get 15% discount on your next order',
    'Iscriviti e sblocca subito il tuo sconto': 'Sign up and unlock your discount now',
    'Ottieni lo sconto': 'Get the discount',
    'No, grazie': 'No, thanks',
    'No grazie': 'No, thanks',
    'Ti stai iscrivendo per ricevere comunicazioni via email e puoi annullare l’iscrizione in qualsiasi momento.': 'You are signing up to receive email communications and you can unsubscribe at any time.',
    "Ti stai iscrivendo per ricevere comunicazioni via email e puoi annullare l'iscrizione in qualsiasi momento.": 'You are signing up to receive email communications and you can unsubscribe at any time.',
    'Questo sito web utilizza i cookie per assicurarti la migliore esperienza con noi.': 'This website uses cookies to ensure you get the best experience with us.',
    'Questo sito utilizza i cookie per assicurarti la migliore esperienza con noi.': 'This website uses cookies to ensure you get the best experience with us.',
    'Politica sulla riservatezza': 'Privacy policy',
    'Rifiuta': 'Reject',
    'Accetta': 'Accept',
    'Accetta tutto': 'Accept all',
    'Pagamento Sicuro Con': 'Secure payment with',
    'PAGAMENTO SICURO CON': 'SECURE PAYMENT WITH',
    'Color Argento': 'Silver',
    'Color Argento e Verde': 'Silver and Green',
    'Color Argento e Rosso': 'Silver and Red',
    'Color Argento e Blu': 'Silver and Blue',
    'Color Argento e Rosa': 'Silver and Pink',
    'Silver Color e Verde': 'Silver and Green',
    'Silver Color e Rosso': 'Silver and Red',
    'Silver Color e Blu': 'Silver and Blue',
    'Silver Color e Rosa': 'Silver and Pink',
    'Powered by Shopify': ''
  }));

  const EXACT_CI = new Map([...EXACT.entries()].map(([key, value]) => [key.toLocaleLowerCase('it'), value]));

  const REVIEW_EXACT = new Map(Object.entries({
    'Pazzesco, davvero molto molto bello': 'Amazing, really very, very beautiful.',
    'Ottima qualità, questo è il mio secondo ordine': 'Excellent quality, this is my second order.',
    "Questo è l'articolo che mi piace di più. La qualità che offre è impressionante, i colori sono bellissimi e ha un certo peso, il che dimostra che non è plastica. Il livello di dettagli è notevole e le pietre brillano come se fosse un gioiello molto costoso. Davvero, è un articolo unico, il venditore è stato molto disponibile, mi ha inviato foto dei prodotti in ogni momento e la spedizione è arrivata abbastanza velocemente.": 'This is the piece I like the most. The quality is impressive, the colors are beautiful and it has a solid weight, which shows that it is not plastic. The level of detail is remarkable and the stones shine like a very expensive jewel. It is truly a unique piece; the seller was extremely helpful, kept sending me product photos throughout the process, and shipping was quite fast.',
    'Proprio come in foto, qualità 10/10, brilla intensamente e qualità perfetta, senza esitazioni comprerò di nuovo.': 'Exactly as shown in the photos: 10/10 quality, an intense shine and a perfect finish. I will definitely buy again.',
    'Ciondolo bellissimo e brillante': 'A beautiful, brilliant pendant.',
    "Eccellente qualità del prodotto. È arrivato esattamente come l'avevo ordinato e come lo immaginavo, la personalizzazione era corretta così come il colore (Oro Rosa). Sicuramente farò di nuovo acquisti in questo negozio, molto soddisfatta. Anche il servizio di chat/assistenza è molto buono.": 'Excellent product quality. It arrived exactly as I ordered and imagined it; the customization and the rose-gold color were both correct. I am very satisfied and will definitely shop here again. The chat and customer-support service is also very good.',
    'Entrambi i pendenti sono davvero belli, di buona qualità e di buon peso! Il venditore è stato molto reattivo e disponibile, è stato facile comunicare con loro. Sono riusciti a realizzare i ciondoli velocemente e anche la spedizione è stata rapida! Consiglio vivamente questo prodotto e hardrip in generale!': 'Both pendants are genuinely beautiful, well made and have a good weight. The seller was very responsive and helpful, and communication was easy. They made the pendants quickly and shipping was fast as well. I highly recommend this product and HARDRIP in general.',
    'Adoro il ciondolo. Era imballato con cura ed è arrivato puntuale. ne comprerò sicuramente altri.': 'I love the pendant. It was carefully packaged and arrived on time. I will definitely buy more.',
    'Sono bellissimi, sono arrivati in 8 giorni dalla produzione, anche il servizio clienti è stato eccezionale. Grazie mille ragazzi.': 'They are beautiful. They arrived eight days after production, and the customer service was exceptional too. Thank you so much, guys.',
    'Top‼️ La qualità è davvero alta 👍 👍': 'Top quality‼️ The standard is genuinely high 👍 👍',
    'Uno dei best seller per gioielli del genere, la qualità è molto migliore rispetto quella che ho avuto da altri. Le incastonature delle pietre sono vicine tra loro e brillano da pazzi': 'One of the best sellers for this kind of jewelry. The quality is much better than pieces I have bought elsewhere; the stones are set close together and shine like crazy.',
    'Incredibile': 'Incredible.',
    'bellissimo': 'Beautiful.',
    'Ne voglio un altra al più presto': 'I want another one as soon as possible.'
  }));

  const PREFIX_TRANSLATIONS = [
    [/^Colore\s*:/i, 'Color:'],
    [/^Lunghezza\s*:/i, 'Length:'],
    [/^Misura\s*:/i, 'Size:'],
    [/^Taglia\s*:/i, 'Size:'],
    [/^Materiale\s*:/i, 'Material:']
  ];

  const COLOR_TERMS = new Map([
    ['argento', 'Silver'],
    ['silver color', 'Silver'],
    ['verde', 'Green'],
    ['rosso', 'Red'],
    ['blu', 'Blue'],
    ['azzurro', 'Light Blue'],
    ['rosa', 'Pink'],
    ['viola', 'Purple'],
    ['giallo', 'Yellow'],
    ['nero', 'Black'],
    ['bianco', 'White'],
    ['oro rosa', 'Rose Gold'],
    ['oro', 'Gold']
  ]);

  function translateVariantValue(value) {
    let result = clean(value);
    if (!result || result.length > 140) return result;
    const colorContext = /(?:colore|color|argento|silver|verde|green|rosso|red|blu|blue|azzurro|rosa|pink|viola|purple|giallo|yellow|nero|black|bianco|white|oro|gold)/i.test(result);
    if (!colorContext) return result;

    result = result
      .replace(/\b(?:Colore|Color)\s+Oro\s+Rosa\b/gi, 'Rose Gold')
      .replace(/\b(?:Colore|Color)\s+Argento\b/gi, 'Silver')
      .replace(/\bSilver\s+Color\b/gi, 'Silver')
      .replace(/\b(?:Colore|Color)\s+Oro\b/gi, 'Gold');

    const orderedTerms = [...COLOR_TERMS.entries()].sort((a, b) => b[0].length - a[0].length);
    for (const [italian, english] of orderedTerms) {
      result = result.replace(new RegExp(`\\b${italian.replace(/\s+/g, '\\s+')}\\b`, 'gi'), english);
    }
    result = result.replace(/\s+e\s+(?=(?:Green|Red|Blue|Light Blue|Pink|Purple|Yellow|Black|White|Rose Gold|Gold|Silver)\b)/gi, ' and ');
    result = result.replace(/\s{2,}/g, ' ').trim();
    return result;
  }

  function matchCase(match, lower, title, upper) {
    if (match === match.toUpperCase()) return upper;
    if (match[0] === match[0].toUpperCase()) return title;
    return lower;
  }

  function replaceCharmWithPendant(value) {
    return clean(value)
      .replace(/\bcharms\b/gi, (match) => matchCase(match, 'pendants', 'Pendants', 'PENDANTS'))
      .replace(/\bcharm\b/gi, (match) => matchCase(match, 'pendant', 'Pendant', 'PENDANT'));
  }

  function translated(value) {
    const source = clean(value);
    if (!source) return source;
    const exact = REVIEW_EXACT.get(source) ?? EXACT.get(source) ?? EXACT_CI.get(source.toLocaleLowerCase('it'));
    let result = exact !== undefined ? exact : source;
    if (EN) {
      const exampleValue = result.match(/^(?:ad|per)\s+esempio\s+(.+)$/i);
      if (exampleValue) result = `For example ${exampleValue[1]}`;
      const articleCount = result.match(/^(\d+)\s+Articol(?:o|i)$/i);
      if (articleCount) result = `${articleCount[1]} ${Number(articleCount[1]) === 1 ? 'Article' : 'Articles'}`;
      for (const [pattern, replacement] of PREFIX_TRANSLATIONS) {
        if (pattern.test(result)) result = result.replace(pattern, replacement);
      }
      result = translateVariantValue(result);
      result = replaceCharmWithPendant(result);
    }
    return result;
  }

  function replaceVisibleText(root = document) {
    if (!EN || !root) return;
    const ownerDocument = root.nodeType === Node.DOCUMENT_NODE ? root : (root.ownerDocument || document);
    const walker = ownerDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || parent.closest('script,style,noscript,textarea,code,pre,svg,[contenteditable="true"],[data-hardrip-no-translate]')) return;
      const raw = node.nodeValue || '';
      const source = clean(raw);
      if (!source) return;
      const result = translated(source);
      if (result !== source) node.nodeValue = raw.replace(source, result);
    });
    root.querySelectorAll?.('[aria-label],[placeholder],[title]').forEach((element) => {
      for (const attr of ['aria-label', 'placeholder', 'title']) {
        const source = clean(element.getAttribute(attr));
        if (!source) continue;
        const result = translated(source);
        if (result !== source) element.setAttribute(attr, result);
      }
    });
  }

  const chattyRoots = new WeakSet();
  let chattyScanQueued = false;

  function translateChattyContext(root) {
    if (!EN || !root) return;
    replaceVisibleText(root);
    root.querySelectorAll?.('input[value],button[value]').forEach((element) => {
      const source = clean(element.value);
      const result = translated(source);
      if (source && result !== source) element.value = result;
    });
  }

  function observeChattyContext(root) {
    if (!EN || !root || chattyRoots.has(root)) return;
    chattyRoots.add(root);
    translateChattyContext(root);
    try {
      const observer = new MutationObserver(() => {
        translateChattyContext(root);
        queueChattyScan();
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-label', 'placeholder', 'title', 'value']
      });
    } catch (_) {}
  }

  function scanChattyContexts(root = document) {
    if (!EN || !root) return;
    translateChattyContext(root);
    root.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) observeChattyContext(element.shadowRoot);
      if (element.tagName === 'IFRAME') {
        const wire = () => {
          try {
            if (element.contentDocument) observeChattyContext(element.contentDocument);
          } catch (_) {}
        };
        if (!element.dataset.hardripChattyFrameV2050) {
          element.dataset.hardripChattyFrameV2050 = 'true';
          element.addEventListener('load', wire, { passive: true });
        }
        wire();
      }
    });
  }

  function queueChattyScan() {
    if (!EN || chattyScanQueued) return;
    chattyScanQueued = true;
    requestAnimationFrame(() => {
      chattyScanQueued = false;
      scanChattyContexts(document);
    });
  }

  function wireChattyEnglish() {
    if (!EN || ROOT.dataset.hardripChattyEnglishV2050) return;
    ROOT.dataset.hardripChattyEnglishV2050 = 'true';
    scanChattyContexts(document);
    window.setTimeout(queueChattyScan, 500);
    window.setTimeout(queueChattyScan, 1500);
    window.setTimeout(queueChattyScan, 3500);
  }

  function closeDisclosure(button) {
    if (!button) return;
    const controls = button.getAttribute('aria-controls');
    const panel = controls ? document.getElementById(controls) : button.nextElementSibling;
    button.setAttribute('aria-expanded', 'false');
    if (panel?.classList?.contains('disclosure__list-wrapper')) panel.hidden = true;
  }

  function resetDrawerLocalization(scope = document) {
    scope.querySelectorAll?.('.menu-drawer__localization .localization-form__select[aria-expanded="true"]').forEach(closeDisclosure);
    scope.querySelectorAll?.('.menu-drawer__localization .disclosure__list-wrapper:not([hidden])').forEach((panel) => { panel.hidden = true; });
  }

  function restoreNativeLocalization(root = document) {
    root.querySelectorAll?.('[data-hardrip-v2025-localization-panel],[data-hardrip-v2025-country-panel],[data-hardrip-v2025-language-panel],[data-hardrip-v2025-country-overlay]').forEach((panel) => {
      panel.removeAttribute('data-hardrip-v2025-localization-panel');
      panel.removeAttribute('data-hardrip-v2025-country-panel');
      panel.removeAttribute('data-hardrip-v2025-language-panel');
      panel.removeAttribute('data-hardrip-v2025-country-overlay');
      for (const property of [
        '--hardrip-v2025-panel-left', '--hardrip-v2025-panel-top', '--hardrip-v2025-panel-width', '--hardrip-v2025-panel-max-height',
        '--hardrip-v2025-country-left', '--hardrip-v2025-country-top', '--hardrip-v2025-country-width', '--hardrip-v2025-country-height'
      ]) panel.style.removeProperty(property);
    });
  }

  function markFooterLocalization(root = document) {
    root.querySelectorAll?.('.footer__localization localization-form, .footer__localization .localization-form').forEach((host) => {
      const form = host.matches?.('form') ? host : host.querySelector?.('form') || host;
      const country = form.querySelector?.('input[name="country_code"]');
      const language = form.querySelector?.('input[name="language_code"]');
      if (country) host.setAttribute('data-hardrip-footer-country', 'true');
      if (language) host.setAttribute('data-hardrip-footer-language', 'true');
    });

    root.querySelectorAll?.('.footer__localization .country-selector__overlay').forEach((overlay) => {
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('data-hardrip-country-overlay-disabled', 'true');
    });
  }

  function forceImportant(element, property, value) {
    if (element) element.style.setProperty(property, value, 'important');
  }

  function disclosureForLocalizationHost(host, kind) {
    if (!host?.querySelector) return null;
    const inputName = kind === 'language' ? 'language_code' : 'country_code';
    const input = host.querySelector(`input[name="${inputName}"]`);
    if (!input) return null;
    const form = input.closest('form') || host.querySelector('form') || host;
    const buttons = [...form.querySelectorAll('button.localization-form__select,summary.localization-form__select,.localization-form__select[aria-controls]')];
    let button = buttons.find((candidate) => {
      const controls = clean(candidate.getAttribute('aria-controls'));
      return controls && document.getElementById(controls)?.closest('localization-form,.localization-form,form') === host;
    }) || buttons[0] || null;
    if (!button) return null;
    const controls = clean(button.getAttribute('aria-controls'));
    const panel = (controls && document.getElementById(controls)) || form.querySelector('.disclosure__list-wrapper,[role="listbox"]');
    return panel ? { panel, button, host, form, input } : null;
  }

  function localizationHosts(root = document, kind = 'language') {
    const inputName = kind === 'language' ? 'language_code' : 'country_code';
    const inputs = [...(root.querySelectorAll?.(`.footer__localization input[name="${inputName}"],.menu-drawer__localization input[name="${inputName}"]`) || [])];
    const seen = new Set();
    return inputs.map((input) => input.closest('localization-form,.localization-form') || input.closest('form')).filter((host) => host && !seen.has(host) && seen.add(host));
  }

  function languageDisclosures(root = document) {
    const results = [];
    const seen = new Set();
    const containers = [...(root.querySelectorAll?.('.footer__localization,.menu-drawer__localization') || [])];

    containers.forEach((container) => {
      const buttons = [...container.querySelectorAll('button.localization-form__select,summary.localization-form__select,.localization-form__select[aria-controls]')];
      buttons.forEach((button) => {
        const controls = clean(button.getAttribute('aria-controls'));
        const panel = controls ? document.getElementById(controls) : null;
        if (!panel || seen.has(panel)) return;

        const host = button.closest('localization-form,.localization-form') || button.closest('form') || container;
        const form = button.closest('form') || host.querySelector?.('form') || host;
        const options = [...panel.querySelectorAll('a,button,[role="option"],.disclosure__link')]
          .filter((option) => clean(option.textContent));
        const optionTexts = options.map((option) => clean(option.textContent).toLocaleLowerCase('it'));
        const buttonText = clean(button.textContent).toLocaleLowerCase('it');
        const languageNames = /^(?:italiano|english|italian|inglese|deutsch|français|español|português|nederlands)$/i;
        const languageMatches = optionTexts.filter((text) => languageNames.test(text)).length;
        const hasHrefLang = options.some((option) => option.hasAttribute('hreflang') || option.hasAttribute('lang'));
        const hasLanguageInput = !!host.querySelector?.('input[name="language_code"]');
        const countrySignals = panel.matches?.('.country-selector') || !!panel.querySelector('.country-filter,.countries,.popular-countries') || options.length > 18 || /(?:EUR|€|USD|GBP|£|CHF)/i.test(buttonText);
        const languageSignals = hasHrefLang || languageMatches >= 2 || languageNames.test(buttonText) || (hasLanguageInput && options.length > 0 && options.length <= 12);

        if (!languageSignals || countrySignals) return;
        seen.add(panel);
        results.push({ panel, button, host, form, input: host.querySelector?.('input[name="language_code"]') || null });
      });
    });

    return results;
  }

  function countryDisclosures(root = document) {
    return localizationHosts(root, 'country').map((host) => disclosureForLocalizationHost(host, 'country')).filter(Boolean);
  }

  function clearLocalizationMarkers(panel) {
    if (!panel) return;
    for (const name of [...panel.getAttributeNames()]) {
      if (/^data-hardrip-(?:language|country)-(?:panel|list|item|link|current)/i.test(name)) panel.removeAttribute(name);
    }
    panel.querySelectorAll('[data-hardrip-language-item-v2034],[data-hardrip-language-link-v2034],[data-hardrip-language-current-item-v2034],[data-hardrip-language-current-link-v2034],[data-hardrip-language-item-v2036],[data-hardrip-language-link-v2036],[data-hardrip-language-current-item-v2036],[data-hardrip-language-current-link-v2036],[data-hardrip-language-item-v2061],[data-hardrip-language-link-v2061],[data-hardrip-language-current-item-v2061],[data-hardrip-language-current-link-v2061]').forEach((element) => {
      for (const name of [...element.getAttributeNames()]) if (/^data-hardrip-language-/i.test(name)) element.removeAttribute(name);
    });
  }

  function fixCountryPopoverLayout(root = document) {
    countryDisclosures(root).forEach(({ panel, button, host }) => {
      clearLocalizationMarkers(panel);
      host.setAttribute('data-hardrip-footer-country', 'true');
      panel.setAttribute('data-hardrip-country-panel-v2061', 'true');

      const viewportWidth = Math.max(280, Math.round(window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth || 320));
      const targetWidth = Math.min(380, viewportWidth - 24);
      const maxPanelHeight = Math.max(260, Math.min(560, Math.round((window.visualViewport?.height || window.innerHeight || 720) * 0.68)));
      host.style.setProperty('--hardrip-v2061-country-popover-width', `${targetWidth}px`);
      host.style.setProperty('--hardrip-v2061-country-popover-height', `${maxPanelHeight}px`);

      for (const [property, value] of Object.entries({
        width: `${targetWidth}px`, 'min-width': `${targetWidth}px`, 'max-width': `${targetWidth}px`,
        'inline-size': `${targetWidth}px`, 'min-inline-size': `${targetWidth}px`, 'max-inline-size': `${targetWidth}px`,
        'max-height': `${maxPanelHeight}px`, left: '0', right: 'auto', margin: '0', padding: '0',
        overflow: 'hidden', 'box-sizing': 'border-box'
      })) forceImportant(panel, property, value);

      const list = panel.querySelector('.disclosure__list,.countries,.country-selector__list,ul,ol,[role="list"],[role="listbox"]');
      if (list) {
        list.setAttribute('data-hardrip-country-list-v2061', 'true');
        for (const [property, value] of Object.entries({
          display: 'block', width: '100%', 'min-width': '0', 'max-width': '100%', margin: '0', padding: '4px',
          'max-height': `${Math.max(180, maxPanelHeight - 72)}px`, overflow: 'auto', 'overflow-x': 'hidden',
          'overflow-y': 'auto', 'overscroll-behavior': 'contain', '-webkit-overflow-scrolling': 'touch',
          'touch-action': 'pan-y', 'box-sizing': 'border-box'
        })) forceImportant(list, property, value);
        if (!list.dataset.hardripCountryScrollV2050) {
          list.dataset.hardripCountryScrollV2050 = 'true';
          list.addEventListener('wheel', (event) => {
            if (list.scrollHeight > list.clientHeight) event.stopPropagation();
          }, { passive: true });
          list.addEventListener('touchmove', (event) => {
            if (list.scrollHeight > list.clientHeight) event.stopPropagation();
          }, { passive: true });
        }
      }

      panel.querySelectorAll('li,[role="option"],.disclosure__item,.country').forEach((item) => {
        item.setAttribute('data-hardrip-country-item-v2061', 'true');
        for (const [property, value] of Object.entries({
          display: 'block', width: '100%', 'min-width': '0', 'max-width': '100%', margin: '0', padding: '0', 'box-sizing': 'border-box'
        })) forceImportant(item, property, value);
      });

      panel.querySelectorAll('a,button,.disclosure__link,.country').forEach((option) => {
        if (option.closest('.country-filter')) return;
        option.setAttribute('data-hardrip-country-link-v2061', 'true');
        for (const [property, value] of Object.entries({
          display: 'flex', 'align-items': 'center', 'justify-content': 'space-between', width: '100%',
          'min-width': '0', 'max-width': '100%', margin: '0', padding: '9px 12px', 'white-space': 'normal',
          'overflow-wrap': 'normal', 'word-break': 'normal', 'box-sizing': 'border-box'
        })) forceImportant(option, property, value);
      });

      panel.querySelectorAll('.country-filter,.country-filter .field,.country-filter__input').forEach((element) => {
        forceImportant(element, 'width', '100%');
        forceImportant(element, 'min-width', '0');
        forceImportant(element, 'max-width', '100%');
        forceImportant(element, 'box-sizing', 'border-box');
        forceImportant(element, 'flex', '0 0 auto');
      });

      const buttonRect = button.getBoundingClientRect();
      const viewportRight = window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth || 320;
      if (buttonRect.left + targetWidth > viewportRight - 12) {
        forceImportant(panel, 'left', 'auto');
        forceImportant(panel, 'right', '0');
      }
    });
  }

  function fixLanguagePopoverLayout(root = document) {
    languageDisclosures(root).forEach(({ panel, button, host }) => {
      clearLocalizationMarkers(panel);
      host.setAttribute('data-hardrip-footer-language', 'true');
      panel.setAttribute('data-hardrip-language-panel-v2061', 'true');

      const viewportWidth = Math.max(280, Math.round(window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth || 320));
      const buttonWidth = Math.max(104, Math.ceil(button.getBoundingClientRect().width || button.offsetWidth || 0));
      const panelRect = panel.getBoundingClientRect();
      const panelVisible = !panel.hidden && panelRect.width > 0 && panelRect.height > 0;
      const naturalWidth = panelVisible ? Math.ceil(Math.max(panelRect.width, panel.scrollWidth || 0)) : 0;
      const targetWidth = Math.min(viewportWidth - 24, Math.max(190, buttonWidth, naturalWidth));

      if (panelVisible) {
        host.style.setProperty('--hardrip-v2061-language-popover-width', `${targetWidth}px`);
        for (const [property, value] of Object.entries({
          display: 'grid', 'grid-template-columns': 'minmax(0, 1fr)', width: `${targetWidth}px`, 'min-width': `${targetWidth}px`, 'max-width': `${targetWidth}px`,
          'inline-size': `${targetWidth}px`, 'min-inline-size': `${targetWidth}px`, 'max-inline-size': `${targetWidth}px`,
          left: 'auto', right: '0', margin: '0', padding: '0', overflow: 'hidden', 'box-sizing': 'border-box'
        })) forceImportant(panel, property, value);
      }

      [...panel.children].forEach((child) => {
        forceImportant(child, 'width', '100%');
        forceImportant(child, 'min-width', '0');
        forceImportant(child, 'max-width', '100%');
        forceImportant(child, 'box-sizing', 'border-box');
      });

      const list = panel.querySelector('.disclosure__list,ul,ol,[role="list"],[role="listbox"]') || panel.firstElementChild;
      if (list) {
        list.setAttribute('data-hardrip-language-list-v2061', 'true');
        for (const [property, value] of Object.entries({
          display: 'grid', 'grid-template-columns': 'minmax(0, 1fr)', gap: '4px', width: '100%', 'min-width': '0',
          'max-width': '100%', margin: '0', padding: '6px', overflow: 'hidden', 'box-sizing': 'border-box'
        })) forceImportant(list, property, value);
      }

      const currentText = clean(button.textContent).toLocaleLowerCase('it');
      const options = [...panel.querySelectorAll('a[hreflang],a[lang],.disclosure__link,button[role="option"],[role="option"]')]
        .filter((option) => clean(option.textContent));

      options.forEach((option) => {
        const item = option.closest('li,[role="option"],.disclosure__item') || option.parentElement || option;
        item.setAttribute('data-hardrip-language-item-v2061', 'true');
        option.setAttribute('data-hardrip-language-link-v2061', 'true');
        [item, option].forEach((element) => {
          forceImportant(element, 'width', '100%');
          forceImportant(element, 'min-width', '0');
          forceImportant(element, 'max-width', '100%');
          forceImportant(element, 'inline-size', '100%');
          forceImportant(element, 'margin', '0');
          forceImportant(element, 'box-sizing', 'border-box');
        });
        forceImportant(item, 'display', 'block');
        forceImportant(item, 'padding', '0');
        forceImportant(item, 'border-radius', '.9rem');
        forceImportant(item, 'overflow', 'hidden');
        forceImportant(option, 'display', 'flex');
        forceImportant(option, 'flex', '1 1 auto');
        forceImportant(option, 'align-items', 'center');
        forceImportant(option, 'min-height', '44px');
        forceImportant(option, 'padding', '10px 12px');
        forceImportant(option, 'border-radius', '.9rem');

        const optionText = clean(option.textContent).toLocaleLowerCase('it');
        const active = option.getAttribute('aria-current') === 'true' || option.getAttribute('aria-current') === 'page' || option.getAttribute('aria-selected') === 'true' || option.classList.contains('disclosure__link--active') || optionText === currentText;
        item.toggleAttribute('data-hardrip-language-current-item-v2061', active);
        option.toggleAttribute('data-hardrip-language-current-link-v2061', active);
        forceImportant(item, 'background', active ? 'rgba(95, 60, 150, .72)' : 'transparent');
        forceImportant(option, 'background', 'transparent');
      });
    });
  }

  function wireLanguagePopover() {
    if (ROOT.dataset.hardripLanguagePopoverV2050) return;
    ROOT.dataset.hardripLanguagePopoverV2050 = 'true';
    let queued = false;
    const refreshLayout = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        fixCountryPopoverLayout(document);
        fixLanguagePopoverLayout(document);
      });
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('localization-form,.localization-form,.footer__localization,.menu-drawer__localization')) {
        refreshLayout();
        window.setTimeout(refreshLayout, 40);
        window.setTimeout(refreshLayout, 180);
      }
    }, true);
    document.addEventListener('toggle', refreshLayout, true);
    const observer = new MutationObserver(refreshLayout);
    observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'aria-expanded', 'aria-current', 'aria-selected'] });
    window.addEventListener('resize', refreshLayout, { passive: true });
    window.visualViewport?.addEventListener('resize', refreshLayout, { passive: true });
  }

  function drawerDetails() {
    return document.getElementById('Details-menu-drawer-container') || document.querySelector('header-drawer > details.menu-drawer-container, menu-drawer > details.menu-drawer-container');
  }

  function syncDrawer(opening = false) {
    const details = drawerDetails();
    document.querySelectorAll('[data-hardrip-v2061-active-drawer-header]').forEach((node) => {
      if (!details?.open || !node.contains(details)) node.removeAttribute('data-hardrip-v2061-active-drawer-header');
    });
    if (!details?.open) {
      ROOT.classList.remove('hardrip-drawer-open-v2061');
      ROOT.style.removeProperty('--hardrip-v2061-drawer-top');
      return;
    }
    const headerSection = details.closest('.shopify-section-header, .shopify-section-group-header-group, .shopify-section') || details.closest('sticky-header, .header-wrapper, header') || details.parentElement;
    if (headerSection) headerSection.setAttribute('data-hardrip-v2061-active-drawer-header', 'true');
    ROOT.classList.add('hardrip-drawer-open-v2061');
    const rect = (headerSection || details).getBoundingClientRect();
    const top = Math.max(0, Math.round(rect.height || rect.bottom || 0));
    ROOT.style.setProperty('--hardrip-v2061-drawer-top', `${top}px`);
    const drawer = details.querySelector('#menu-drawer, .menu-drawer');
    if (opening && drawer) {
      resetDrawerLocalization(drawer);
      const scroller = drawer.querySelector('.menu-drawer__navigation-container, .menu-drawer__inner-container');
      if (scroller) scroller.scrollTop = 0;
    }
  }

  function wireDrawer() {
    const details = drawerDetails();
    if (!details || details.dataset.hardripV2050Wired) return;
    details.dataset.hardripV2050Wired = 'true';
    details.addEventListener('toggle', () => syncDrawer(details.open));
    window.addEventListener('resize', () => syncDrawer(false), { passive: true });
    window.visualViewport?.addEventListener('resize', () => syncDrawer(false), { passive: true });
    if (details.open) syncDrawer(true);
  }

  function fixEnglishTrackLinks(root = document) {
    if (!EN || !root) return;
    root.querySelectorAll?.('a[href]').forEach((anchor) => {
      const label = clean(anchor.textContent || anchor.getAttribute('aria-label') || anchor.getAttribute('title'));
      const rawHref = anchor.getAttribute('href') || '';
      let url = null;
      try { url = new URL(rawHref, location.origin); } catch (_) {}
      const normalizedHost = (value) => clean(value).toLowerCase().replace(/^www\./, '');
      const sameShop = url && normalizedHost(url.hostname) === normalizedHost(location.hostname);
      const trackingPath = url && /^\/(?:en\/)?tools\/tracking\/?$/i.test(url.pathname);
      const trackingLabel = /^(?:Traccia Il Tuo Ordine|Track Your Order)$/i.test(label);
      if (!trackingPath && !trackingLabel) return;
      if (url && !sameShop && !trackingLabel) return;
      const search = url?.search || '';
      const hash = url?.hash || '';
      anchor.setAttribute('href', `/en/tools/tracking${search}${hash}`);
      anchor.setAttribute('data-hardrip-english-tracking-link-v2061', 'true');
    });
  }

  function wireEnglishTrackNavigation() {
    if (!EN || ROOT.dataset.hardripEnglishTrackNavigationV2050) return;
    ROOT.dataset.hardripEnglishTrackNavigationV2050 = 'true';
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest?.('a[data-hardrip-english-tracking-link-v2061="true"]');
      if (!anchor || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      window.location.assign(anchor.getAttribute('href') || '/en/tools/tracking');
    }, true);
  }

  function removePoweredBy(root = document) {
    root.querySelectorAll?.('a[href*="shopify.com"][rel*="nofollow"], .powered-by-shopify, [class*="powered-by-shopify" i]').forEach((element) => {
      if (/powered\s+by\s+shopify/i.test(clean(element.textContent)) || element.matches('.powered-by-shopify,[class*="powered-by-shopify" i]')) element.remove();
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (/powered\s+by\s+shopify/i.test(clean(node.nodeValue))) {
        const parent = node.parentElement;
        if (parent && clean(parent.textContent).toLowerCase() === clean(node.nodeValue).toLowerCase()) parent.remove();
        else node.nodeValue = node.nodeValue.replace(/powered\s+by\s+shopify/ig, '');
      }
    });
  }

  async function getPolicyData() {
    if (policyCache) return policyCache;
    const inline = document.getElementById('HardripPolicyPagesV2024');
    if (inline?.textContent) {
      try {
        policyCache = JSON.parse(inline.textContent);
        return policyCache;
      } catch (error) {
        console.warn('[HARDRIP V20.61] Invalid inline policy data:', error);
      }
    }
    if (!POLICY_URL) return null;
    const response = await fetch(POLICY_URL, { credentials: 'omit', cache: 'no-store' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    policyCache = await response.json();
    return policyCache;
  }

  async function applyEnglishPolicy() {
    if (!EN || !/^\/policies\//.test(normalizedPath)) return;
    try {
      const data = await getPolicyData();
      const page = data?.pages?.[normalizedPath];
      if (!page?.html) return;
      const currentWhatsApp = document.querySelector('a[href*="wa.me"],a[href*="api.whatsapp.com"]')?.href || '';
      const body = document.querySelector('.shopify-policy__body, .shopify-policy__container .rte');
      const heading = document.querySelector('.shopify-policy__title h1, .shopify-policy__container h1');
      if (!body) return;
      if (heading && page.title) heading.textContent = page.title;
      if (body.dataset.hardripPolicyVersion !== '20.35') {
        body.innerHTML = page.html;
        body.dataset.hardripPolicyVersion = '20.35';
      }
      if (currentWhatsApp) body.querySelectorAll('[data-hardrip-copy-whatsapp]').forEach((link) => { link.href = currentWhatsApp; });
      replaceVisibleText(body);
    } catch (error) {
      console.warn('[HARDRIP V20.61] Policy asset unavailable:', error);
    }
  }

  function initialsFromName(name) {
    const parts = clean(name).replace(/[^\p{L}\p{N}\s'’-]/gu, ' ').split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
  }

  function judgeNameFromCard(card, author) {
    const direct = clean(author?.textContent || author?.getAttribute?.('aria-label') || author?.getAttribute?.('title'));
    if (direct) return direct;
    for (const element of [card, ...card.querySelectorAll('[data-reviewer-name],[data-author],[data-author-name],[data-name]')]) {
      for (const attribute of ['data-reviewer-name', 'data-author-name', 'data-author', 'data-name']) {
        const value = clean(element.getAttribute?.(attribute));
        if (value) return value;
      }
    }
    return '';
  }

  function fixJudgeMe(root = document) {
    root.querySelectorAll?.('.jdgm-rev, [data-verified-buyer] .jdgm-rev__header').forEach((candidate) => {
      const card = candidate.classList?.contains('jdgm-rev') ? candidate : candidate.closest('.jdgm-rev') || candidate.parentElement;
      if (!card) return;
      const author = card.querySelector('.jdgm-rev__author, [class*="reviewer-name" i], [class*="author-name" i]');
      const avatar = card.querySelector('.jdgm-rev__icon, [class*="reviewer-avatar" i], [class*="author-avatar" i]');
      const name = judgeNameFromCard(card, author);
      if (author) {
        author.setAttribute('data-hardrip-judge-author', 'true');
        if (!clean(author.textContent) && name) author.textContent = name;
      }
      if (avatar) {
        avatar.setAttribute('data-hardrip-judge-avatar', 'true');
        const initials = initialsFromName(name);
        if (initials) {
          avatar.setAttribute('data-hardrip-initials', initials);
          if (!clean(avatar.textContent) && !avatar.querySelector('img,svg')) avatar.textContent = initials;
          if (!avatar.getAttribute('aria-label')) avatar.setAttribute('aria-label', name);
        }
      }
    });
  }

  function reviewText(card) {
    const candidates = [...card.querySelectorAll('[data-review-text],.hr-reviews__text,.hr-review__text,[class*="review-body" i],[class*="review-text" i],[class*="review-content" i],p')];
    return candidates.map((node) => clean(node.textContent)).filter((text) => text.length > 8).sort((a, b) => b.length - a.length)[0] || '';
  }

  function reviewScore(card) {
    const text = reviewText(card);
    const media = card.querySelectorAll('img,video').length;
    const rating = Number(card.getAttribute('data-rating') || (clean(card.textContent).match(/([1-5](?:\.\d)?)/) || [,'5'])[1]) || 5;
    return (text ? Math.min(text.length, 700) : -1200) + media * 180 + rating * 40;
  }

  function exactTextElements(scope, pattern) {
    return [...scope.querySelectorAll('*')]
      .filter((element) => pattern.test(clean(element.textContent)) && [...element.children].every((child) => !pattern.test(clean(child.textContent))))
      .sort((a, b) => clean(a.textContent).length - clean(b.textContent).length);
  }

  function smallestSummary(scope) {
    const direct = scope.querySelector('[data-hardrip-review-summary],.hr-reviews__summary,.hr-reviews__summary-card,[class*="reviews__summary" i],[class*="review-summary" i]');
    if (direct && /4[.,]9/.test(clean(direct.textContent)) && /1481/.test(clean(direct.textContent))) return direct;
    return [...scope.querySelectorAll('div,aside')]
      .filter((element) => /4[.,]9/.test(clean(element.textContent)) && /1481\s+(recensioni reali|real reviews)/i.test(clean(element.textContent)))
      .sort((a, b) => clean(a.textContent).length - clean(b.textContent).length)[0] || null;
  }

  function commonAncestor(elements, boundary) {
    if (!elements.length) return null;
    let node = elements[0].parentElement;
    while (node && node !== boundary.parentElement) {
      if (elements.every((element) => node.contains(element))) return node;
      node = node.parentElement;
    }
    return null;
  }

  function stripCloneIds(root) {
    if (root.id) root.removeAttribute('id');
    root.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
  }

  function findHomeReviewScopes(root = document) {
    const scopes = new Set(root.querySelectorAll?.('[id^="HardripReviews-"], .hr-reviews') || []);
    root.querySelectorAll?.('h1,h2,h3,h4,[role="heading"]').forEach((heading) => {
      if (!/cosa dicono di noi|what our customers say/i.test(clean(heading.textContent))) return;
      const scope = heading.closest('section,[id^="shopify-section"],.shopify-section,[class*="reviews" i]') || heading.parentElement;
      if (scope) scopes.add(scope);
    });
    return [...scopes];
  }

  function ensureMobileReviewSummary(scope, toolbar, placeholder) {
    let summary = scope.querySelector('[data-hardrip-home-review-summary-mobile="true"]');
    if (!summary) {
      summary = document.createElement('div');
      summary.setAttribute('data-hardrip-home-review-summary-mobile', 'true');
      summary.setAttribute('role', 'group');
      summary.setAttribute('aria-label', EN ? '4.9 out of 5, 1481 real reviews' : '4.9 su 5, 1481 recensioni reali');
      summary.innerHTML = `
        <strong class="hardrip-review-summary__score">4.9</strong>
        <span class="hardrip-review-summary__details">
          <span class="hardrip-review-summary__stars" aria-hidden="true">★★★★★</span>
          <span class="hardrip-review-summary__count">${EN ? '1481 real reviews' : '1481 recensioni reali'}</span>
        </span>`;
    } else {
      const count = summary.querySelector('.hardrip-review-summary__count');
      const expectedCount = EN ? '1481 real reviews' : '1481 recensioni reali';
      if (count && clean(count.textContent) !== expectedCount) count.textContent = expectedCount;
    }

    if (placeholder?.parentElement && placeholder !== summary) placeholder.replaceWith(summary);
    else if (toolbar && summary.parentElement !== toolbar) toolbar.insertBefore(summary, toolbar.firstChild);
    return summary;
  }

  function organizeHomeReviews(root = document) {
    findHomeReviewScopes(root).forEach((scope) => {
      if (!/cosa dicono di noi|what our customers say|1481\s+(recensioni reali|real reviews)/i.test(clean(scope.textContent))) return;
      scope.setAttribute('data-hardrip-home-reviews', 'true');

      const count = scope.querySelector('[data-hardrip-review-count],.hr-reviews__summary-count');
      const expectedCount = EN ? '1481 real reviews' : '1481 recensioni reali';
      if (count && clean(count.textContent) !== expectedCount) count.textContent = expectedCount;

      const featuredPattern = /^\s*\d+\s+(?:in evidenza|featured)\s*$/i;
      const featured = exactTextElements(scope, featuredPattern);
      scope.querySelectorAll('[data-hardrip-review-featured-v213],[data-hardrip-review-featured-v218],.hr-reviews__toolbar-copy,[data-hardrip-home-review-featured]').forEach((node) => {
        if (featuredPattern.test(clean(node.textContent))) featured.push(node);
      });
      const uniqueFeatured = [...new Set(featured)];
      uniqueFeatured.forEach((node) => node.setAttribute('data-hardrip-home-review-featured', 'true'));

      const originalSummary = smallestSummary(scope);
      if (originalSummary && !originalSummary.hasAttribute('data-hardrip-home-review-summary-mobile')) {
        originalSummary.setAttribute('data-hardrip-home-review-summary-original', 'true');
      }

      const buttons = [...scope.querySelectorAll('button,[role="button"]')].filter((button) => {
        const value = clean(`${button.getAttribute('aria-label') || ''} ${button.getAttribute('title') || ''} ${button.textContent || ''}`);
        const className = String(button.className || '');
        return /filter|filtr|sort|ordina|ordine/i.test(value) || /filter|sort/i.test(className);
      });
      let toolbar = scope.querySelector('.hr-reviews__toolbar,.hr-reviews__toolbar-row,[data-hardrip-review-toolbar],[class*="reviews__toolbar" i]');
      if (!toolbar && buttons.length) toolbar = commonAncestor(buttons.slice(0, 2), scope) || buttons[0].parentElement;
      if (!toolbar && uniqueFeatured[0]?.parentElement) toolbar = uniqueFeatured[0].parentElement;
      if (toolbar) {
        toolbar.setAttribute('data-hardrip-home-review-toolbar', 'true');
        ensureMobileReviewSummary(scope, toolbar, uniqueFeatured[0] || null);
      }

      uniqueFeatured.slice(1).forEach((node) => node.remove());

      const heading = [...scope.querySelectorAll('h1,h2,h3,h4,[role="heading"]')].find((node) => /cosa dicono di noi|what our customers say/i.test(clean(node.textContent)));
      if (heading) {
        let copy = heading.parentElement;
        while (copy && copy !== scope && !/recensioni reali|real reviews/i.test(clean(copy.textContent))) copy = copy.parentElement;
        (copy && copy !== scope ? copy : heading.parentElement)?.setAttribute('data-hardrip-home-review-copy', 'true');
      }

      const cards = [...scope.querySelectorAll('.hr-reviews__card,.hr-review-card,.hr-reviews__item,.hr-review-item,[class*="review-card" i],[class*="review-item" i],[data-review-id],article[class*="review" i],li[class*="review" i]')];
      const groups = new Map();
      cards.forEach((card) => {
        const parent = card.parentElement;
        if (!parent) return;
        if (!groups.has(parent)) groups.set(parent, []);
        groups.get(parent).push(card);
      });
      groups.forEach((items, parent) => {
        const ordered = [...items].sort((a, b) => reviewScore(b) - reviewScore(a));
        if (ordered.some((card, index) => card !== items[index])) ordered.forEach((card) => parent.appendChild(card));
      });

      if (EN) replaceVisibleText(scope);
    });
  }

  function restoreNativeSwatches(root = document) {
    document.querySelectorAll('[id^=\"HardripSwatchTooltipV20\"],[id^=\"HardripSwatchLayerV20\"]').forEach((element) => element.remove());
    root.querySelectorAll?.('[data-hardrip-v2061-tooltip-managed],[data-hardrip-v2061-tooltip-host],[data-hardrip-suppressed-swatch-tooltip-v2061],[data-hardrip-v2035-tooltip-managed],[data-hardrip-v2035-tooltip-host],[data-hardrip-suppressed-swatch-tooltip-v2035]').forEach((element) => {
      [...element.getAttributeNames()].forEach((name) => {
        if (/^data-hardrip-(?:v20(?:35|36)-tooltip|suppressed-swatch-tooltip)/i.test(name)) element.removeAttribute(name);
      });
      element.style.removeProperty('display');
      element.style.removeProperty('visibility');
      element.style.removeProperty('opacity');
      element.style.removeProperty('pointer-events');
    });
  }

  let customImageRestorationStarted = false;

  function customCollectionDescription(root = document) {
    const main = root.querySelector?.('main#MainContent,main') || root;
    const selectors = '.collection-hero__description,.collection__description,.collection-description,[data-collection-description],.rte';
    const candidates = [...(main?.querySelectorAll?.(selectors) || [])].filter((element) => !element.closest('header,footer,card-product,.card-wrapper,.product-grid'));
    return candidates.find((element) => element.closest('.collection-hero,[class*="collection" i]')) || candidates[0] || null;
  }

  function customProcessImageSource(root = document) {
    const main = root.querySelector?.('main#MainContent,main') || root;
    const description = customCollectionDescription(root);
    const images = [...(description?.querySelectorAll?.('img') || []), ...(main?.querySelectorAll?.('img') || [])];
    return images.find((image) => {
      if (image.closest('header,footer,nav,card-product,.card-wrapper,.product-grid,[class*="product-card" i]')) return false;
      const context = clean(`${image.alt || ''} ${image.title || ''} ${image.closest('figure,picture,.rte,section,div')?.textContent || ''}`);
      return /process|processo|creazione|creation|custom|personalizz|from scratch|da zero/i.test(context);
    }) || images.find((image) => description?.contains(image)) || null;
  }

  function directChildContaining(container, element) {
    let current = element;
    while (current?.parentElement && current.parentElement !== container) current = current.parentElement;
    return current?.parentElement === container ? current : element;
  }

  function absolutizeMedia(element) {
    element.querySelectorAll?.('img,source').forEach((media) => {
      for (const attribute of ['src', 'data-src']) {
        const value = media.getAttribute(attribute);
        if (value) {
          try { media.setAttribute(attribute, new URL(value, location.origin).href); } catch (_) {}
        }
      }
      for (const attribute of ['srcset', 'data-srcset']) {
        const value = media.getAttribute(attribute);
        if (!value) continue;
        const absolute = value.split(',').map((candidate) => {
          const parts = candidate.trim().split(/\s+/);
          try { parts[0] = new URL(parts[0], location.origin).href; } catch (_) {}
          return parts.join(' ');
        }).join(', ');
        media.setAttribute(attribute, absolute);
      }
    });
  }

  async function restoreEnglishCustomCollectionImage() {
    if (!EN || customImageRestorationStarted || !/^\/collections\/custom(?:\/|$)/i.test(normalizedPath)) return;
    customImageRestorationStarted = true;
    const target = customCollectionDescription(document);
    if (!target) return;

    try {
      const response = await fetch(normalizedPath, { credentials: 'same-origin', headers: { 'X-Requested-With': 'HARDRIP-V20.61' } });
      if (!response.ok) return;
      const italianDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sourceDescription = customCollectionDescription(italianDocument);
      const sourceImage = customProcessImageSource(italianDocument);
      if (!sourceDescription || !sourceImage) return;

      const sourceBlock = directChildContaining(sourceDescription, sourceImage);
      const sourceURL = new URL(clean(sourceImage.getAttribute('src') || sourceImage.getAttribute('data-src')), location.origin).href;
      const mediaMatches = [...target.querySelectorAll('img')].filter((image) => {
        const raw = clean(image.getAttribute('src') || image.getAttribute('data-src'));
        if (!raw) return false;
        try { return new URL(raw, location.origin).href === sourceURL; } catch (_) { return raw === sourceURL; }
      });

      let block = mediaMatches.length ? directChildContaining(target, mediaMatches[0]) : sourceBlock.cloneNode(true);
      if (!mediaMatches.length) absolutizeMedia(block);
      block.setAttribute?.('data-hardrip-restored-custom-process-v2061', 'true');
      block.classList?.add('hardrip-custom-process-image-v2061');

      mediaMatches.slice(1).forEach((image) => {
        const duplicate = directChildContaining(target, image);
        if (duplicate !== block) duplicate.remove();
      });

      const anchorText = /the image below illustrates the creative process behind a fully custom piece/i;
      const anchorNode = [...target.querySelectorAll('p,div,span,h2,h3,h4')].find((node) => anchorText.test(clean(node.textContent)));
      const anchorBlock = anchorNode ? directChildContaining(target, anchorNode) : null;
      const reference = anchorBlock?.nextSibling || null;
      if (block.parentNode !== target || block !== reference) target.insertBefore(block, reference);
    } catch (_) {}
  }

  function faqContexts() {
    const contexts = [document];
    const add = (context) => {
      if (context && typeof context.querySelectorAll === 'function' && !contexts.includes(context)) contexts.push(context);
    };

    document.querySelectorAll('*').forEach((element) => add(element.shadowRoot));
    document.querySelectorAll('iframe').forEach((frame) => {
      try { add(frame.contentDocument); } catch (_) {}
    });
    return contexts;
  }

  function fixAvadaFaqCategorySpacing(root = document) {
    if (!/^\/pages\/(?:faqs?|domande-frequenti)(?:\/|$)/i.test(normalizedPath)) return;
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('.Avada-Faq_CategoryList').forEach((list) => {
      const items = [...list.children].filter((child) => child.matches?.('.Avada-Faq_CategoryItem'));
      if (items.length < 2) return;

      const first = items[0];
      const firstTitle = clean(first.querySelector('.Avada-Faq_CategoryItem-title')?.textContent);
      if (!/^(?:tutto|all)$/i.test(firstTitle)) return;

      /* Avada uses two different layouts with the same class names:
         - desktop: categories in a vertical column;
         - mobile: categories in one horizontal scroll row.
         We detect the REAL layout from element geometry, so a narrow Mac
         window is never treated as the iPhone layout. */
      const firstRect = first.getBoundingClientRect();
      const secondRect = items[1].getBoundingClientRect();
      const sameRowTolerance = Math.max(8, Math.min(firstRect.height, secondRect.height) * 0.35);
      const horizontalMobileLayout =
        Math.abs(secondRect.top - firstRect.top) <= sameRowTolerance &&
        secondRect.left > firstRect.left;

      if (!horizontalMobileLayout) {
        list.removeAttribute('data-hardrip-avada-faq-mobile-v2061');
        list.style.removeProperty('--hardrip-avada-faq-leading-gap');
        list.style.removeProperty('inset-inline-start');
        list.style.removeProperty('width');
        list.style.removeProperty('max-width');
        list.style.removeProperty('box-sizing');
        return;
      }

      /* Measure Avada's own gap between the first two chips. The entire
         horizontal scroll container is then moved inward by that amount.
         Because the space lives OUTSIDE the scrollable content, Avada's
         scrollIntoView cannot consume it. */
      const measuredGap = Math.round(secondRect.left - firstRect.right);
      const leadingGap = measuredGap >= 10 && measuredGap <= 56 ? measuredGap : 24;

      list.setAttribute('data-hardrip-avada-faq-mobile-v2061', 'true');
      list.style.setProperty('--hardrip-avada-faq-leading-gap', `${leadingGap}px`);
      forceImportant(list, 'position', 'relative');
      forceImportant(list, 'inset-inline-start', `${leadingGap}px`);
      forceImportant(list, 'width', `calc(100% - ${leadingGap}px)`);
      forceImportant(list, 'max-width', `calc(100% - ${leadingGap}px)`);
      forceImportant(list, 'box-sizing', 'border-box');

      /* Remove only the superseded V20.41 inline styles from the first chip.
         The desktop layout remains completely native. */
      first.style.removeProperty('margin-inline-start');
      first.style.removeProperty('scroll-margin-inline-start');
      list.style.removeProperty('scroll-padding-inline-start');
    });
  }

  function fixFaqCategoryStartEverywhere() {
    faqContexts().forEach((context) => fixAvadaFaqCategorySpacing(context));
  }


  const ECOM_POPUP_STYLE_ID_V2050 = 'HardripEcomPopupChromeV2050';
  const ECOM_POPUP_CSS_V2050 = `
.react-responsive-modal-modal.pp-modal,
.pp-modal .ecomsend__Modal__Container,
.pp-modal .ecomsend__Modal__Content,
.pp-modal .ecomsend__Modal__CustomDialogWrapper,
.pp-modal .ecomsend__Modal__CustomDialog,
.pp-modal [class*="_modalContainer_"],
.pp-modal [class*="_modalContent_"],
.pp-modal [class*="_myCustomDialogWrapper_"],
.pp-modal [class*="_myCustomDialog_"] { border: 0 !important; outline: 0 !important; }
.pp-modal .ecomsend__Modal__CustomDialogWrapper,
.pp-modal .ecomsend__Modal__CustomDialog,
.pp-modal [class*="_myCustomDialogWrapper_"],
.pp-modal [class*="_myCustomDialog_"] { box-shadow: none !important; }
.pp-modal .ecomsend__Modal__Content,
.pp-modal [class*="_modalContent_"] { box-shadow: 0 24px 70px rgba(0,0,0,.58) !important; }
.pp-modal .ecomsend__Modal__CustomDialogWrapper::before,
.pp-modal .ecomsend__Modal__CustomDialogWrapper::after,
.pp-modal .ecomsend__Modal__CustomDialog::before,
.pp-modal .ecomsend__Modal__CustomDialog::after,
.pp-modal [class*="_myCustomDialogWrapper_"]::before,
.pp-modal [class*="_myCustomDialogWrapper_"]::after,
.pp-modal [class*="_myCustomDialog_"]::before,
.pp-modal [class*="_myCustomDialog_"]::after { border: 0 !important; outline: 0 !important; box-shadow: none !important; }
`;

  function installEcomPopupChrome(root = document) {
    if (!root?.querySelector) return;
    if (root.querySelector(`#${ECOM_POPUP_STYLE_ID_V2050}`)) return;
    const owner = root.nodeType === Node.DOCUMENT_NODE ? root : root.ownerDocument;
    const style = owner?.createElement?.('style');
    if (!style) return;
    style.id = ECOM_POPUP_STYLE_ID_V2050;
    style.textContent = ECOM_POPUP_CSS_V2050;
    const target = root.nodeType === Node.DOCUMENT_NODE ? (root.head || root.documentElement) : root;
    target?.appendChild?.(style);
  }

  function fixEcomPopupChromeEverywhere() {
    faqContexts().forEach(installEcomPopupChrome);
  }

  /* ----------------------------------------------------------------------
     HOMEPAGE SLIDESHOW — AUTOPLAY, CONTROLS OVERLAY AND MOBILE SWIPE
     The native Craft control strip is removed entirely from the DOM. A compact
     HARDRIP control dock is the only selector rendered over the media. On touch screens the image area can be dragged naturally;
     the NEW DROP panel and its button are deliberately excluded.
     ---------------------------------------------------------------------- */
  const HOME_SLIDESHOW_DELAY_V2061 = 5600;
  const HOME_SLIDESHOW_TRANSITION_V2061 = 820;
  const HOME_SLIDESHOW_DESKTOP_DURATION_V2083 = 980;
  const HOME_SLIDESHOW_SWIPE_THRESHOLD_V2061 = 34;
  const HOME_SLIDESHOW_CONTROL_CLASS_V2061 = 'hardrip-home-slideshow-controls-v2061';
  const homeSlideshowControllersV2061 = new WeakMap();

  function homeSlideshowCandidates(root = document) {
    if (normalizedPath !== '/' || !root?.querySelectorAll) return [];

    let candidates = [...root.querySelectorAll('slideshow-component')];
    if (!candidates.length) {
      candidates = [...root.querySelectorAll('.slideshow-component, [data-section-type="slideshow"]')];
    }

    return candidates.filter((component, index, list) => {
      if (!component?.isConnected) return false;
      if (component.closest('product-info, .product, .product__media-wrapper, quick-add-modal')) return false;
      if (list.some((other, otherIndex) => otherIndex !== index && other.contains(component))) return false;
      return homeSlideshowSlides(component).length > 1;
    });
  }

  function homeSlideshowSlides(component) {
    const all = [...component.querySelectorAll('.slideshow__slide, [id^="Slide-"]')];
    const nearestComponent = (slide) => slide.closest('slideshow-component, .slideshow-component, [data-section-type="slideshow"]');
    return all.filter((slide, index) => {
      if (all.indexOf(slide) !== index) return false;
      const owner = nearestComponent(slide);
      return !owner || owner === component || component.contains(owner);
    });
  }

  function homeSlideshowScroller(component) {
    if (component.matches?.('.slideshow, .slider, [id^="Slider-"]')) return component;
    return component.querySelector('.slideshow.slider, .slideshow, [id^="Slider-"], .slider');
  }

  function removeNativeSlideshowControlsV2061(component) {
    if (!component?.querySelectorAll) return;
    [...component.querySelectorAll('.slideshow__controls, .slider-buttons')].forEach((item) => {
      if (item.classList?.contains(HOME_SLIDESHOW_CONTROL_CLASS_V2061)) return;
      if (item.closest?.(`.${HOME_SLIDESHOW_CONTROL_CLASS_V2061}`)) return;
      item.remove();
    });
  }

  function homeSlideshowCurrentIndex(component, slides = homeSlideshowSlides(component)) {
    if (!slides.length) return 0;
    const track = homeSlideshowScroller(component);
    if (track && track.scrollWidth > track.clientWidth + 2) {
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let distance = Number.POSITIVE_INFINITY;
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const currentDistance = Math.abs(rect.left + rect.width / 2 - center);
        if (currentDistance < distance) {
          distance = currentDistance;
          closest = index;
        }
      });
      return closest;
    }

    const explicit = slides.findIndex((slide) =>
      slide.getAttribute('aria-hidden') === 'false' ||
      slide.getAttribute('aria-current') === 'true' ||
      slide.classList.contains('is-active') ||
      slide.classList.contains('active') ||
      slide.classList.contains('slider__slide--active')
    );
    return explicit >= 0 ? explicit : 0;
  }

  function createSlideshowArrow(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `hardrip-home-slideshow-arrow-v2061 hardrip-home-slideshow-arrow-${direction}-v2061`;
    button.setAttribute('aria-label', direction === 'next' ? (EN ? 'Next image' : 'Immagine successiva') : (EN ? 'Previous image' : 'Immagine precedente'));
    button.innerHTML = direction === 'next'
      ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5 5.5-5 5.5"/></svg>'
      : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 4.5-5 5.5 5 5.5"/></svg>';
    return button;
  }

  function setupHomepageSlideshow(component) {
    if (!component) return;
    if (homeSlideshowControllersV2061.has(component)) {
      homeSlideshowControllersV2061.get(component)?.refresh?.();
      return;
    }

    const state = {
      timer: 0,
      transitionTimer: 0,
      settleTimer: 0,
      refreshFrame: 0,
      inView: true,
      pausedByPointer: false,
      pausedByFocus: false,
      pausedByTouch: false,
      lastIndex: 0,
      targetIndex: null,
      navigationToken: 0,
      navigating: false,
      overlay: null,
      dots: [],
      observer: null,
      intersection: null,
      drag: null,
      suppressClickUntil: 0,
      scrollFrame: 0,
    };

    const slides = () => homeSlideshowSlides(component);
    const scroller = () => homeSlideshowScroller(component);

    /* HARDRIP V20.83 - DESKTOP GPU NAVIGATION START */
    const isDesktopSlideshowV2083 = () => window.matchMedia('(min-width: 750px)').matches;
    const desktopTrackIndexV2083 = (index) => {
      const track = scroller();
      if (!track) return;
      track.style.scrollBehavior = 'auto';
      if (track.scrollLeft !== 0) track.scrollLeft = 0;
      track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;
    };
    /* HARDRIP V20.83 - DESKTOP GPU NAVIGATION END */

    const clearTimer = () => {
      if (state.timer) window.clearTimeout(state.timer);
      state.timer = 0;
    };

    const clearSettle = () => {
      if (state.settleTimer) window.clearTimeout(state.settleTimer);
      state.settleTimer = 0;
    };

    const clearTransition = () => {
      if (state.transitionTimer) window.clearTimeout(state.transitionTimer);
      state.transitionTimer = 0;
      slides().forEach((slide) => slide.classList.remove('hardrip-slideshow-outgoing-v2061', 'hardrip-slideshow-incoming-v2061'));
      component.classList.remove('hardrip-slideshow-transitioning-v2061');
    };

    const canRun = () => !document.hidden && state.inView && !state.pausedByPointer && !state.pausedByFocus && !state.pausedByTouch && !state.navigating && slides().length > 1;

    /* HARDRIP V20.84 - DESKTOP LOGICAL STATE START */
    const updateControlState = (forcedIndex = null) => {
      const currentSlides = slides();
      if (!currentSlides.length) return;
      const desktop = isDesktopSlideshowV2083();
      const rawIndex = Number.isInteger(forcedIndex)
        ? forcedIndex
        : Number.isInteger(state.targetIndex)
          ? state.targetIndex
          : desktop
            ? state.lastIndex
            : homeSlideshowCurrentIndex(component, currentSlides);
      const index = ((rawIndex % currentSlides.length) + currentSlides.length) % currentSlides.length;
      state.lastIndex = index;
      state.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        const ariaCurrent = active ? 'true' : 'false';
        if (dot.getAttribute('aria-current') !== ariaCurrent) dot.setAttribute('aria-current', ariaCurrent);
      });
    };
    /* HARDRIP V20.84 - DESKTOP LOGICAL STATE END */

    const markTransition = (current, next) => {
      clearTransition();
      component.classList.add('hardrip-slideshow-transitioning-v2061');
      current?.classList.add('hardrip-slideshow-outgoing-v2061');
      next?.classList.add('hardrip-slideshow-incoming-v2061');
      state.transitionTimer = window.setTimeout(clearTransition, HOME_SLIDESHOW_TRANSITION_V2061 + 140);
    };

    const exactScrollLeft = (track, target) => {
      const trackRect = track.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const requested = track.scrollLeft + (targetRect.left - trackRect.left) - (track.clientWidth - targetRect.width) / 2;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      return Math.max(0, Math.min(maximum, requested));
    };

    const schedule = (delay = HOME_SLIDESHOW_DELAY_V2061) => {
      clearTimer();
      if (!canRun()) return;
      state.timer = window.setTimeout(() => navigateBy(1, false), delay);
    };

    const settleNavigation = (index, token, manual) => {
      if (token !== state.navigationToken) return;
      const currentSlides = slides();
      const track = scroller();
      const target = currentSlides[index];
      if (!track || !target) return;

      clearSettle();
      if (isDesktopSlideshowV2083()) {
        desktopTrackIndexV2083(index);
      } else {
        const left = exactScrollLeft(track, target);
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        requestAnimationFrame(() => track.style.removeProperty('scroll-behavior'));
      }

      state.lastIndex = index;
      state.targetIndex = null;
      state.navigating = false;
      updateControlState(index);
      component.dispatchEvent(new CustomEvent('slideChanged', { bubbles: true, detail: { currentPage: index + 1 } }));
      schedule(manual ? 4200 : HOME_SLIDESHOW_DELAY_V2061);
    };

    const navigateTo = (requestedIndex, manual = true) => {
      const currentSlides = slides();
      const track = scroller();
      if (!currentSlides.length || !track) return;

      clearTimer();
      clearSettle();
      const count = currentSlides.length;
      const index = ((requestedIndex % count) + count) % count;
      const desktop = isDesktopSlideshowV2083();
      const currentIndex = Number.isInteger(state.targetIndex)
        ? state.targetIndex
        : desktop
          ? state.lastIndex
          : homeSlideshowCurrentIndex(component, currentSlides);
      const target = currentSlides[index];
      if (!target) return;

      if (index === currentIndex && !state.navigating) {
        if (desktop) desktopTrackIndexV2083(index);
        updateControlState(index);
        schedule(manual ? 4200 : HOME_SLIDESHOW_DELAY_V2061);
        return;
      }

      const token = ++state.navigationToken;
      state.targetIndex = index;
      state.navigating = true;
      updateControlState(index);

      if (desktop) {
        clearTransition();
        desktopTrackIndexV2083(index);
        state.settleTimer = window.setTimeout(
          () => settleNavigation(index, token, manual),
          matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 30
            : HOME_SLIDESHOW_DESKTOP_DURATION_V2083 + 50
        );
        return;
      }

      markTransition(currentSlides[currentIndex], target);
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = track.scrollLeft;
      const left = exactScrollLeft(track, target);

      requestAnimationFrame(() => {
        if (token !== state.navigationToken) return;
        track.style.removeProperty('scroll-behavior');
        try {
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } catch (_) {
          track.scrollLeft = left;
        }
      });

      state.settleTimer = window.setTimeout(() => settleNavigation(index, token, manual), 720);
    };

    const navigateBy = (delta, manual = true) => {
      const currentSlides = slides();
      if (!currentSlides.length) return;
      const base = Number.isInteger(state.targetIndex)
        ? state.targetIndex
        : isDesktopSlideshowV2083()
          ? state.lastIndex
          : homeSlideshowCurrentIndex(component, currentSlides);
      navigateTo(base + delta, manual);
    };

    /* HARDRIP V20.82 - SSR CONTROLS HYDRATION START */
    const ensureOverlayControls = () => {
      const currentSlides = slides();
      if (currentSlides.length < 2) return;

      let overlay = component.querySelector(`:scope > .${HOME_SLIDESHOW_CONTROL_CLASS_V2061}`);
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = HOME_SLIDESHOW_CONTROL_CLASS_V2061;
        overlay.setAttribute('role', 'group');
        overlay.setAttribute('aria-label', EN ? 'Slideshow controls' : 'Controlli presentazione');
        const previous = createSlideshowArrow('previous');
        const dots = document.createElement('div');
        dots.className = 'hardrip-home-slideshow-dots-v2061';
        const next = createSlideshowArrow('next');
        overlay.append(previous, dots, next);
        component.appendChild(overlay);
      }
      state.overlay = overlay;

      const activateArrow = (delta) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
        clearTimer();
        navigateBy(delta, true);
      };

      const bindArrowOnce = (selector, delta) => {
        const button = state.overlay.querySelector(selector);
        if (!button || button.dataset.hardripNavBoundV2082 === 'true') return;
        button.dataset.hardripNavBoundV2082 = 'true';
        button.addEventListener('click', activateArrow(delta));
      };
      bindArrowOnce('.hardrip-home-slideshow-arrow-previous-v2061', -1);
      bindArrowOnce('.hardrip-home-slideshow-arrow-next-v2061', 1);

      const dotsHost = state.overlay.querySelector('.hardrip-home-slideshow-dots-v2061');
      if (!dotsHost) return;
      const existingDots = [...dotsHost.querySelectorAll('.hardrip-home-slideshow-dot-v2061')];
      if (existingDots.length !== currentSlides.length) {
        dotsHost.replaceChildren();
        currentSlides.forEach(() => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'hardrip-home-slideshow-dot-v2061';
          dotsHost.appendChild(dot);
        });
      }

      state.dots = [...dotsHost.querySelectorAll('.hardrip-home-slideshow-dot-v2061')];
      state.dots.forEach((dot, index) => {
        dot.type = 'button';
        dot.setAttribute('aria-label', `${EN ? 'Go to image' : 'Vai all’immagine'} ${index + 1}`);
        if (dot.dataset.hardripNavBoundV2082 !== 'true') {
          dot.dataset.hardripNavBoundV2082 = 'true';
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation?.();
            clearTimer();
            navigateTo(index, true);
          });
        }
      });
      updateControlState();
    };
    /* HARDRIP V20.82 - SSR CONTROLS HYDRATION END */

    const blockedSwipeTarget = (target) => Boolean(target?.closest?.(
      `.${HOME_SLIDESHOW_CONTROL_CLASS_V2061}, .banner__box, .slideshow__text, .slideshow__text-wrapper, input, select, textarea, label`
    ));

    const installTouchSwipe = () => {
      const track = scroller();
      if (!track || track.dataset.hardripSwipeV2061 === 'true') return;
      track.dataset.hardripSwipeV2061 = 'true';

      track.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1 || blockedSwipeTarget(event.target)) {
          state.drag = null;
          return;
        }

        clearTimer();
        clearSettle();
        state.navigationToken += 1;
        state.targetIndex = null;
        state.navigating = false;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft;

        const touch = event.touches[0];
        state.drag = {
          startX: touch.clientX,
          startY: touch.clientY,
          startScroll: track.scrollLeft,
          startIndex: homeSlideshowCurrentIndex(component, slides()),
          axis: null,
          moved: false,
        };
        state.pausedByTouch = true;
      }, { passive: true });

      track.addEventListener('touchmove', (event) => {
        if (!state.drag || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const dx = touch.clientX - state.drag.startX;
        const dy = touch.clientY - state.drag.startY;

        if (!state.drag.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 6) {
          state.drag.axis = Math.abs(dx) > Math.abs(dy) * 1.02 ? 'x' : 'y';
        }
        if (state.drag.axis !== 'x') return;

        event.preventDefault();
        state.drag.moved = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = state.drag.startScroll - dx;
      }, { passive: false });

      const finishSwipe = (event) => {
        if (!state.drag) return;
        const drag = state.drag;
        state.drag = null;
        state.pausedByTouch = false;
        track.style.removeProperty('scroll-behavior');

        if (drag.axis !== 'x' || !drag.moved) {
          schedule(2200);
          return;
        }

        const touch = event.changedTouches?.[0];
        const dx = touch ? touch.clientX - drag.startX : drag.startScroll - track.scrollLeft;
        const travelled = Math.abs(track.scrollLeft - drag.startScroll);
        const qualifies = Math.abs(dx) >= HOME_SLIDESHOW_SWIPE_THRESHOLD_V2061 || travelled >= Math.max(26, track.clientWidth * 0.09);
        const targetIndex = qualifies ? drag.startIndex + (dx < 0 ? 1 : -1) : drag.startIndex;
        state.suppressClickUntil = Date.now() + 420;
        navigateTo(targetIndex, true);
      };

      track.addEventListener('touchend', finishSwipe, { passive: true });
      track.addEventListener('touchcancel', finishSwipe, { passive: true });
      track.addEventListener('scroll', () => {
        if (state.scrollFrame) return;
        state.scrollFrame = requestAnimationFrame(() => {
          state.scrollFrame = 0;
          updateControlState();
        });
      }, { passive: true });

      if ('onscrollend' in window && !isDesktopSlideshowV2083()) {
        track.addEventListener('scrollend', () => {
          if (!state.navigating || !Number.isInteger(state.targetIndex)) return;
          settleNavigation(state.targetIndex, state.navigationToken, true);
        }, { passive: true });
      }

      component.addEventListener('click', (event) => {
        if (Date.now() < state.suppressClickUntil && !blockedSwipeTarget(event.target)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    };

    const refresh = () => {
      const currentSlides = slides();
      if (currentSlides.length < 2) {
        clearTimer();
        clearSettle();
        state.overlay?.remove();
        state.overlay = null;
        return;
      }

      component.setAttribute('data-hardrip-home-slideshow-v2061', 'true');
      currentSlides.forEach((slide) => slide.setAttribute('data-hardrip-home-slide-v2061', 'true'));

      /* HARDRIP V20.94 - DESKTOP SLIDE IMAGE RELIABILITY START */
      if (isDesktopSlideshowV2083()) {
        currentSlides.forEach((slide, slideIndex) => {
          slide.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
            img.decoding = 'async';
            if (slideIndex === 0) img.fetchPriority = 'high';

            if (img.dataset.hardripSlideImageReliabilityV2094 === 'true') return;
            img.dataset.hardripSlideImageReliabilityV2094 = 'true';

            const recoverCandidate = () => {
              if (img.dataset.hardripSlideImageRetriedV2094 === 'true') return;
              if (img.naturalWidth > 0) return;

              const candidates = (img.getAttribute('srcset') || '')
                .split(',')
                .map((part) => part.trim())
                .filter(Boolean)
                .map((part) => {
                  const pieces = part.split(/\s+/);
                  const descriptor = pieces[1] || '';
                  const width = descriptor.endsWith('w') ? parseInt(descriptor, 10) || 0 : 0;
                  return { url: pieces[0], width };
                })
                .filter((item) => item.url)
                .sort((a, b) => b.width - a.width);

              const fallback = candidates[0]?.url;
              if (!fallback || fallback === img.currentSrc || fallback === img.src) return;

              img.dataset.hardripSlideImageRetriedV2094 = 'true';
              img.removeAttribute('srcset');
              img.src = fallback;
            };

            img.addEventListener('error', recoverCandidate, { once: true });
            if (img.complete && img.naturalWidth === 0) recoverCandidate();
          });
        });
      }
      /* HARDRIP V20.94 - DESKTOP SLIDE IMAGE RELIABILITY END */
      ensureOverlayControls();
      removeNativeSlideshowControlsV2061(component);
      installTouchSwipe();
      if (isDesktopSlideshowV2083()) {
        state.lastIndex = Math.max(0, Math.min(currentSlides.length - 1, state.lastIndex));
        desktopTrackIndexV2083(state.lastIndex);
      }
      schedule();
    };

    component.addEventListener('pointerenter', () => {
      if (matchMedia('(hover: hover)').matches) {
        state.pausedByPointer = true;
        clearTimer();
      }
    });
    component.addEventListener('pointerleave', () => {
      state.pausedByPointer = false;
      schedule(1800);
    });
    component.addEventListener('focusin', (event) => {
      if (event.target?.closest?.(`.${HOME_SLIDESHOW_CONTROL_CLASS_V2061}, .banner__box, a, button`)) {
        state.pausedByFocus = true;
        clearTimer();
      }
    });
    component.addEventListener('focusout', () => {
      state.pausedByFocus = false;
      schedule(2200);
    });
    component.addEventListener('slideChanged', () => requestAnimationFrame(() => {
      if (!isDesktopSlideshowV2083()) updateControlState();
    }));

    state.observer = new MutationObserver(() => {
      if (state.refreshFrame) return;
      state.refreshFrame = requestAnimationFrame(() => {
        state.refreshFrame = 0;
        ensureOverlayControls();
        removeNativeSlideshowControlsV2061(component);
        if (isDesktopSlideshowV2083()) {
          const stableIndex = Number.isInteger(state.targetIndex) ? state.targetIndex : state.lastIndex;
          desktopTrackIndexV2083(stableIndex);
          updateControlState(stableIndex);
          if (!state.navigating) schedule();
        } else {
          updateControlState();
          schedule();
        }
      });
    });
    state.observer.observe(component, { childList: true, subtree: true });
    let desktopResizeFrameV2084 = 0;
    window.addEventListener('resize', () => {
      if (!isDesktopSlideshowV2083()) return;
      if (desktopResizeFrameV2084) cancelAnimationFrame(desktopResizeFrameV2084);
      desktopResizeFrameV2084 = requestAnimationFrame(() => {
        desktopResizeFrameV2084 = 0;
        const stableIndex = Number.isInteger(state.targetIndex) ? state.targetIndex : state.lastIndex;
        desktopTrackIndexV2083(stableIndex);
        updateControlState(stableIndex);
      });
    }, { passive: true });


    if ('IntersectionObserver' in window) {
      state.intersection = new IntersectionObserver((entries) => {
        state.inView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.18);
        if (state.inView) schedule(HOME_SLIDESHOW_DELAY_V2061); else clearTimer();
      }, { threshold: [0, 0.18, 0.5] });
      state.intersection.observe(component);
    }

    document.addEventListener('visibilitychange', () => document.hidden ? clearTimer() : schedule(1200));
    homeSlideshowControllersV2061.set(component, { refresh, schedule, navigateTo, navigateBy });
    refresh();
  }

  function initHomepageSlideshows(root = document) {
    homeSlideshowCandidates(root).forEach(setupHomepageSlideshow);
  }


  /* ----------------------------------------------------------------------
     GSC INSTAGRAM FEED — NATIVE APP RESTORED
     No HARDRIP JavaScript reads, rewrites, pauses, plays, hydrates or styles
     GSC media. The application regains complete control of its own feed.
     ---------------------------------------------------------------------- */

  function refresh() {
    scheduled = false;
    restoreNativeSwatches(document);
    initStarRingOxidationBadgeV2061();
    restoreNativeLocalization(document);
    markFooterLocalization(document);
    fixCountryPopoverLayout(document);
    fixLanguagePopoverLayout(document);
    wireDrawer();
    restoreEnglishCustomCollectionImage();
    fixFaqCategoryStartEverywhere();
    fixEcomPopupChromeEverywhere();
    initHomepageSlideshows(document);
    fixJudgeMe(document);
    organizeHomeReviews(document);
    removePoweredBy(document);
    if (EN) {
      replaceVisibleText(document);
      fixEnglishTrackLinks(document);
      queueChattyScan();
    }
  }

  /* ----------------------------------------------------------------------
     ANELLO “STAR” — OXIDATION EXCEPTION — URL VARIANT AUTHORITY / NATIVE DIAMOND PRESERVED
     Scope: ONLY /products/anello-star-argento-925-vvs-moissanite

     We intentionally DO NOT control the Diamond Tester badge in any way.
     No display/visibility/opacity/animation styles are applied to it and no
     native badge is force-shown. This keeps the original tester animation and
     its initial VVS state exactly under the existing HARDRIP/theme runtime.

     The only exception here is:
       - Argento & Zirconi     -> hide "Resistente all’ossidazione"
       - Color Oro & Zirconi  -> hide "Resistente all’ossidazione"
       - VVS / Moissanite     -> remove our exception and leave native UI alone

     The selected Shopify variant ID in the URL is authoritative. This avoids
     duplicated/sticky image-swatch markup reporting the wrong material. When
     Zirconi has no remaining badges, the badge-only row is collapsed too.
     ---------------------------------------------------------------------- */
  const STAR_RING_HANDLE_V2061 = 'anello-star-argento-925-vvs-moissanite';
  const STAR_RING_DATA_ID_V2061 = 'HardripStarRingVariantDataV2061';
  const STAR_RING_OXIDATION_HIDDEN_CLASS_V2061 = 'hardrip-star-ring-oxidation-hidden-v2061';
  const STAR_RING_EMPTY_ROW_HIDDEN_CLASS_V2061 = 'hardrip-star-ring-empty-badge-row-hidden-v2061';
  const STAR_RING_OXIDATION_MARK_V2061 = 'data-hardrip-star-ring-oxidation-v2061';
  const STAR_RING_ROW_MARK_V2061 = 'data-hardrip-star-ring-badge-row-v2061';
  let starRingVariantDataV2061 = null;
  let starRingRefreshQueuedV2061 = false;
  let starRingBoundaryV2061 = null;
  let starRingAbortV2061 = null;
  let starRingObserverV2061 = null;
  let starRingOxidationNodeObserversV2061 = new Map();
  let starRingLastExplicitClassificationV2061 = '';
  let starRingLastExplicitAtV2061 = 0;

  function normalizeBadgeTextV2061(value) {
    return clean(value)
      .toLocaleLowerCase('it')
      .replace(/[’‘`´']/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeVariantChoiceV2061(value) {
    return clean(value)
      .toLocaleLowerCase('it')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’‘`´']/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isStarRingPageV2061() {
    return normalizedPath === `/products/${STAR_RING_HANDLE_V2061}`;
  }

  function readStarRingVariantDataV2061() {
    if (starRingVariantDataV2061) return starRingVariantDataV2061;
    const node = document.getElementById(STAR_RING_DATA_ID_V2061);
    if (!node) return null;
    try {
      const parsed = JSON.parse(node.textContent || '{}');
      if (parsed?.handle !== STAR_RING_HANDLE_V2061 || !Array.isArray(parsed?.variants)) return null;
      starRingVariantDataV2061 = parsed;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  function classifyStarRingChoiceV2061(value) {
    const text = normalizeVariantChoiceV2061(value || '');
    if (!text) return '';
    const hasZircon = /zircon/i.test(text);
    const hasVvs = /(?:\bvvs\b|moissan)/i.test(text);
    if (hasZircon && !hasVvs) return 'zirconi';
    if (hasVvs) return 'vvs';
    return '';
  }

  function classifyStarRingVariantV2061(variant) {
    if (!variant) return '';
    const text = [variant.title, ...(Array.isArray(variant.options) ? variant.options : [])]
      .map((value) => clean(value))
      .join(' ');
    return classifyStarRingChoiceV2061(text);
  }

  function elementIsVisibleV2061(node) {
    if (!(node instanceof Element)) return false;
    const style = getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    const rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function starRingMainScopeV2061() {
    const main = document.querySelector('#MainContent, main');
    if (!main) return null;
    const visibleInfos = [...main.querySelectorAll('product-info')]
      .filter(elementIsVisibleV2061)
      .sort((a, b) => {
        const ar = a.getBoundingClientRect();
        const br = b.getBoundingClientRect();
        return (br.width * br.height) - (ar.width * ar.height);
      });
    return visibleInfos[0] || main;
  }

  function optionNodeTextsV2061(node) {
    const values = [];
    const push = (value) => {
      const normalized = normalizeVariantChoiceV2061(value || '');
      if (normalized && !values.includes(normalized)) values.push(normalized);
    };
    push(node?.value);
    push(node?.getAttribute?.('value'));
    push(node?.getAttribute?.('aria-label'));
    push(node?.getAttribute?.('title'));
    push(node?.dataset?.optionValue);
    push(node?.dataset?.value);
    if (node?.id) {
      try {
        const label = document.querySelector(`label[for="${CSS.escape(node.id)}"]`);
        push(label?.getAttribute?.('title'));
        push(label?.getAttribute?.('aria-label'));
        push(label?.dataset?.optionValue);
        push(label?.dataset?.value);
        push(label?.textContent);
      } catch (_) {}
    }
    return values;
  }

  function firstClassifiableValueV2061(values) {
    for (const value of values || []) {
      const classification = classifyStarRingChoiceV2061(value);
      if (classification) return classification;
    }
    return '';
  }

  function fieldLooksLikeColorV2061(field) {
    const legend = field.querySelector(':scope > legend, legend');
    const legendText = normalizeVariantChoiceV2061(legend?.textContent || '');
    if (/(^|\b)(colore|color)(\b|:)/i.test(legendText)) return true;
    const input = field.querySelector('input[type="radio"], select');
    const name = normalizeVariantChoiceV2061(input?.name || '');
    return /(^|\b)(colore|color)(\b|[-_])/i.test(name);
  }

  function classificationFromFieldV2061(field) {
    const selectedValue = field.querySelector('[data-selected-value]');
    let classification = firstClassifiableValueV2061([
      selectedValue?.textContent,
      selectedValue?.getAttribute?.('data-selected-value'),
      selectedValue?.getAttribute?.('value'),
      selectedValue?.getAttribute?.('aria-label'),
      selectedValue?.getAttribute?.('title'),
    ]);
    if (classification) return classification;

    const checked = field.querySelector('input[type="radio"]:checked, [role="radio"][aria-checked="true"], [aria-selected="true"]');
    classification = firstClassifiableValueV2061(optionNodeTextsV2061(checked));
    if (classification) return classification;

    const select = field.querySelector('select');
    if (select) {
      classification = firstClassifiableValueV2061([
        select.value,
        select.selectedOptions?.[0]?.textContent,
        select.selectedOptions?.[0]?.value,
      ]);
    }
    return classification;
  }

  function visibleStarRingPickerV2061(scope) {
    if (!scope) return null;
    const candidates = [...scope.querySelectorAll('variant-selects, variant-radios')];
    const visible = candidates.filter(elementIsVisibleV2061).sort((a, b) => {
      const ar = a.getBoundingClientRect();
      const br = b.getBoundingClientRect();
      return (br.width * br.height) - (ar.width * ar.height);
    });
    return visible[0] || candidates[0] || null;
  }

  function classificationFromVisiblePickerV2061(scope) {
    const picker = visibleStarRingPickerV2061(scope);
    if (!picker) return '';
    const fields = [...picker.querySelectorAll('fieldset.product-form__input, .product-form__input')];
    for (const field of fields.filter(fieldLooksLikeColorV2061)) {
      const classification = classificationFromFieldV2061(field);
      if (classification) return classification;
    }
    for (const node of picker.querySelectorAll('input[type="radio"]:checked, [role="radio"][aria-checked="true"], [aria-selected="true"]')) {
      const classification = firstClassifiableValueV2061(optionNodeTextsV2061(node));
      if (classification) return classification;
    }
    for (const select of picker.querySelectorAll('select')) {
      const classification = firstClassifiableValueV2061([select.value, select.selectedOptions?.[0]?.textContent]);
      if (classification) return classification;
    }
    return '';
  }

  function variantByIdV2061(id) {
    const data = readStarRingVariantDataV2061();
    if (!data || !id) return null;
    return data.variants.find((variant) => String(variant?.id ?? '') === String(id)) || null;
  }

  function classificationFromUrlV2061() {
    const data = readStarRingVariantDataV2061();
    if (!data) return '';
    const fromUrl = new URL(location.href).searchParams.get('variant');
    if (!fromUrl) return '';
    const variant = variantByIdV2061(fromUrl);
    return classifyStarRingVariantV2061(variant);
  }

  function fallbackStarRingClassificationV2061() {
    const data = readStarRingVariantDataV2061();
    if (!data) return '';
    const classification = classifyStarRingVariantV2061(variantByIdV2061(data.defaultVariantId));
    if (classification) return classification;
    return classifyStarRingVariantV2061(data.variants[0]);
  }

  function currentStarRingClassificationV2061(scope) {
    // Shopify keeps the selected variant ID in the product URL. On this
    // product that is the most reliable source because image-swatch markup can
    // contain duplicated/sticky pickers. If the URL has a known variant, it is
    // authoritative and is classified from the Liquid variant table.
    const fromUrl = classificationFromUrlV2061();
    if (fromUrl) return fromUrl;
    if (starRingLastExplicitClassificationV2061 && performance.now() - starRingLastExplicitAtV2061 < 1200) {
      return starRingLastExplicitClassificationV2061;
    }
    return classificationFromVisiblePickerV2061(scope) || fallbackStarRingClassificationV2061();
  }

  function isOxidationBadgeTextV2061(value) {
    const text = normalizeBadgeTextV2061(value);
    return text === 'resistente allossidazione' ||
      text === 'resistente all ossidazione' ||
      text === 'oxidation resistant' ||
      text === 'resistant to oxidation';
  }

  function exactOxidationBadgeContainerV2061(node, boundary) {
    let target = node;
    let parent = target.parentElement;
    const expected = normalizeBadgeTextV2061(node.textContent || '');
    for (let depth = 0; depth < 4 && parent && parent !== boundary; depth += 1) {
      if (normalizeBadgeTextV2061(parent.textContent || '') !== expected) break;
      target = parent;
      parent = parent.parentElement;
    }
    return target;
  }

  function badgeOnlyTextV2061(node) {
    if (!(node instanceof Element)) return false;
    if (node.matches('product-info, form, variant-selects, variant-radios, h1, h2, h3')) return false;
    if (node.querySelector('form, variant-selects, variant-radios, .price, [class*="price"], .jdgm-widget, .jdgm-preview-badge, h1, h2, h3')) return false;
    let text = ` ${normalizeBadgeTextV2061(node.textContent || '')} `;
    const known = [
      'resistente allossidazione',
      'resistente all ossidazione',
      'oxidation resistant',
      'resistant to oxidation',
      'supera il diamond tester',
      'passes diamond tester',
      'passes the diamond tester',
    ];
    let matched = false;
    for (const phrase of known) {
      if (text.includes(` ${phrase} `) || text.trim() === phrase) matched = true;
      text = text.split(phrase).join(' ');
    }
    return matched && text.replace(/\s+/g, '').length === 0;
  }

  function badgeRowForOxidationV2061(badge, boundary) {
    let parent = badge?.parentElement || null;
    let best = null;
    for (let depth = 0; depth < 5 && parent && parent !== boundary; depth += 1) {
      if (!badgeOnlyTextV2061(parent)) break;
      best = parent;
      parent = parent.parentElement;
    }
    return best;
  }

  function restoreOxidationNodeV2061(node) {
    if (!(node instanceof HTMLElement)) return;
    const previousDisplay = node.getAttribute('data-hardrip-star-ring-prev-display-v2061');
    const previousPriority = node.getAttribute('data-hardrip-star-ring-prev-display-priority-v2061') || '';
    const previousHidden = node.getAttribute('data-hardrip-star-ring-prev-hidden-v2061');
    if (previousDisplay === null || previousDisplay === '') node.style.removeProperty('display');
    else node.style.setProperty('display', previousDisplay, previousPriority);
    if (previousHidden === 'true') node.hidden = true;
    else node.hidden = false;
    node.removeAttribute('data-hardrip-star-ring-prev-display-v2061');
    node.removeAttribute('data-hardrip-star-ring-prev-display-priority-v2061');
    node.removeAttribute('data-hardrip-star-ring-prev-hidden-v2061');
    node.classList.remove(STAR_RING_OXIDATION_HIDDEN_CLASS_V2061);
    node.removeAttribute(STAR_RING_OXIDATION_MARK_V2061);
  }

  function clearStarRingExceptionV2061(boundary) {
    boundary.querySelectorAll(`[${STAR_RING_OXIDATION_MARK_V2061}]`).forEach(restoreOxidationNodeV2061);
    boundary.querySelectorAll(`[${STAR_RING_ROW_MARK_V2061}]`).forEach((node) => {
      node.classList.remove(STAR_RING_EMPTY_ROW_HIDDEN_CLASS_V2061);
      node.removeAttribute(STAR_RING_ROW_MARK_V2061);
    });
  }

  function ensureOxidationNodeObserverV2061(badge) {
    if (!(badge instanceof HTMLElement) || starRingOxidationNodeObserversV2061.has(badge)) return;
    const observer = new MutationObserver(() => {
      if (!badge.isConnected || currentStarRingClassificationV2061(starRingBoundaryV2061) !== 'zirconi') return;
      const stillHardHidden = badge.hidden &&
        badge.style.getPropertyValue('display') === 'none' &&
        badge.style.getPropertyPriority('display') === 'important' &&
        badge.classList.contains(STAR_RING_OXIDATION_HIDDEN_CLASS_V2061);
      if (!stillHardHidden) hardHideOxidationNodeV2061(badge);
    });
    // This observer is attached ONLY to the oxidation badge itself. It never
    // observes the Diamond Tester node or its animation attributes.
    observer.observe(badge, { attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
    starRingOxidationNodeObserversV2061.set(badge, observer);
  }

  function hardHideOxidationNodeV2061(badge) {
    if (!(badge instanceof HTMLElement)) return;
    if (!badge.hasAttribute(STAR_RING_OXIDATION_MARK_V2061)) {
      badge.setAttribute('data-hardrip-star-ring-prev-display-v2061', badge.style.getPropertyValue('display') || '');
      badge.setAttribute('data-hardrip-star-ring-prev-display-priority-v2061', badge.style.getPropertyPriority('display') || '');
      badge.setAttribute('data-hardrip-star-ring-prev-hidden-v2061', badge.hidden ? 'true' : 'false');
    }
    badge.setAttribute(STAR_RING_OXIDATION_MARK_V2061, 'true');
    badge.classList.add(STAR_RING_OXIDATION_HIDDEN_CLASS_V2061);
    badge.hidden = true;
    badge.style.setProperty('display', 'none', 'important');
    ensureOxidationNodeObserverV2061(badge);
  }

  function applyStarRingOxidationExceptionV2061(boundary, classification) {
    if (!boundary || !classification) return;

    // On VVS, remove only our oxidation exception. Diamond Tester itself is
    // never queried, restyled or animated by this code.
    if (classification !== 'zirconi') {
      clearStarRingExceptionV2061(boundary);
      return;
    }

    const oxidationBadges = [];
    const seen = new Set();
    boundary.querySelectorAll('span,div,p,li,strong,small,button').forEach((node) => {
      if (!isOxidationBadgeTextV2061(node.textContent || '')) return;
      const badge = exactOxidationBadgeContainerV2061(node, boundary);
      if (!badge || seen.has(badge)) return;
      seen.add(badge);
      oxidationBadges.push(badge);
    });

    const rows = new Set();
    oxidationBadges.forEach((badge) => {
      const row = badgeRowForOxidationV2061(badge, boundary);
      hardHideOxidationNodeV2061(badge);
      if (row) rows.add(row);
    });

    // Zirconi intentionally has no active product badges. Collapse only the
    // badge-only wrapper (never title/reviews/price) so no empty vertical slot
    // remains when oxidation is removed.
    rows.forEach((row) => {
      row.setAttribute(STAR_RING_ROW_MARK_V2061, 'true');
      row.classList.add(STAR_RING_EMPTY_ROW_HIDDEN_CLASS_V2061);
    });
  }

  function refreshStarRingOxidationBadgeV2061() {
    starRingRefreshQueuedV2061 = false;
    if (!isStarRingPageV2061()) return;
    const boundary = starRingMainScopeV2061();
    if (!boundary) return;
    applyStarRingOxidationExceptionV2061(boundary, currentStarRingClassificationV2061(boundary));
  }

  function scheduleStarRingOxidationBadgeV2061(delay = 0) {
    if (!isStarRingPageV2061()) return;
    if (delay > 0) {
      setTimeout(() => scheduleStarRingOxidationBadgeV2061(0), delay);
      return;
    }
    if (starRingRefreshQueuedV2061) return;
    starRingRefreshQueuedV2061 = true;
    requestAnimationFrame(refreshStarRingOxidationBadgeV2061);
  }

  function classificationFromInteractionV2061(target) {
    if (!(target instanceof Element)) return '';
    const picker = target.closest('variant-selects, variant-radios, .product-form__input');
    if (!picker) return '';
    return firstClassifiableValueV2061(optionNodeTextsV2061(target));
  }

  function classificationFromVariantEventV2061(event) {
    const variant = event?.detail?.variant || event?.detail?.productVariant || null;
    if (!variant) return '';
    const byId = variantByIdV2061(variant.id);
    return classifyStarRingVariantV2061(byId || variant);
  }

  function addedNodeContainsOxidationV2061(node) {
    if (!(node instanceof Element)) return false;
    if (isOxidationBadgeTextV2061(node.textContent || '')) return true;
    return [...node.querySelectorAll('span,div,p,li,strong,small,button')]
      .some((child) => isOxidationBadgeTextV2061(child.textContent || ''));
  }

  function bindStarRingBadgeObserverV2061(boundary) {
    starRingObserverV2061?.disconnect();
    starRingObserverV2061 = new MutationObserver((mutations) => {
      if (currentStarRingClassificationV2061(boundary) !== 'zirconi') return;
      const oxidationWasInserted = mutations.some((mutation) =>
        [...mutation.addedNodes].some(addedNodeContainsOxidationV2061)
      );
      if (oxidationWasInserted) scheduleStarRingOxidationBadgeV2061();
    });
    // Child-list only: our class/style changes do not retrigger this observer,
    // and Diamond Tester attributes/animation remain entirely untouched.
    starRingObserverV2061.observe(boundary, { childList: true, subtree: true });
  }

  function bindStarRingBadgeEventsV2061(boundary) {
    starRingAbortV2061?.abort();
    starRingObserverV2061?.disconnect();
    starRingOxidationNodeObserversV2061.forEach((observer) => observer.disconnect());
    starRingOxidationNodeObserversV2061.clear();
    starRingAbortV2061 = new AbortController();
    const signal = starRingAbortV2061.signal;

    const handleInteraction = (event) => {
      const fromVariantEvent = classificationFromVariantEventV2061(event);
      const explicit = fromVariantEvent || classificationFromInteractionV2061(event.target);
      if (explicit) {
        starRingLastExplicitClassificationV2061 = explicit;
        starRingLastExplicitAtV2061 = performance.now();
      }
      // URL update and Craft DOM replacement can happen on different ticks.
      // Re-read the authoritative variant ID at a few short intervals.
      [0, 35, 90, 180, 360, 700, 1200, 2000].forEach((delay) => scheduleStarRingOxidationBadgeV2061(delay));
    };

    boundary.addEventListener('change', handleInteraction, { capture: true, signal });
    boundary.addEventListener('input', handleInteraction, { capture: true, signal });
    boundary.addEventListener('click', (event) => {
      if (event.target?.closest?.('variant-selects, variant-radios, .product-form__input')) handleInteraction(event);
    }, { capture: true, signal });
    document.addEventListener('variant:change', handleInteraction, { signal });
    document.addEventListener('shopify:section:load', handleInteraction, { signal });
    window.addEventListener('popstate', handleInteraction, { signal });
    bindStarRingBadgeObserverV2061(boundary);
  }

  function initStarRingOxidationBadgeV2061() {
    if (!isStarRingPageV2061() || !readStarRingVariantDataV2061()) return;
    const boundary = starRingMainScopeV2061();
    if (!boundary) return;
    if (starRingBoundaryV2061 !== boundary) {
      starRingBoundaryV2061 = boundary;
      bindStarRingBadgeEventsV2061(boundary);
    }
    scheduleStarRingOxidationBadgeV2061();
    [80, 220, 500, 1000, 1800].forEach((delay) => scheduleStarRingOxidationBadgeV2061(delay));
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  function init() {
    restoreNativeSwatches(document);
    restoreNativeLocalization(document);
    markFooterLocalization(document);
    fixCountryPopoverLayout(document);
    fixLanguagePopoverLayout(document);
    resetDrawerLocalization(document);
    wireDrawer();
    wireLanguagePopover();
    restoreEnglishCustomCollectionImage();
    fixFaqCategoryStartEverywhere();
    fixEcomPopupChromeEverywhere();
    initHomepageSlideshows(document);
    fixJudgeMe(document);
    [120, 350, 800, 1600, 3200, 6000].forEach((delay) => setTimeout(() => {
      fixFaqCategoryStartEverywhere();
      fixEcomPopupChromeEverywhere();
      if (EN) queueChattyScan();
    }, delay));
    organizeHomeReviews(document);
    removePoweredBy(document);
    if (EN) {
      replaceVisibleText(document);
      fixEnglishTrackLinks(document);
      wireEnglishTrackNavigation();
    }
    wireChattyEnglish();
    applyEnglishPolicy();
    fixEcomPopupChromeEverywhere();
    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* HARDRIP V20.147 - HOME REVIEWS PASSIVE PREDECODE NO MASK START */
(() => {
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const lower = (value) => clean(value).toLocaleLowerCase();
  const normalizePath = (value) => {
    let p = String(value || '/').split('?')[0].split('#')[0];
    if (!p.startsWith('/')) p = '/' + p;
    return p.replace(/\/+$/, '') || '/';
  };
  const currentPath = normalizePath(location.pathname);
  const shopRoot = normalizePath(window.Shopify?.routes?.root || '/');
  const isHome = currentPath === shopRoot;
  const isProduct = /\/products\/[^/?#]+/i.test(location.pathname || '');

  /* ---------------------------------------------------------------------- */
  /* HOME · native Load More only. No click listener is registered here.   */
  /* ---------------------------------------------------------------------- */
  if (isHome && !window.__HARDRIP_HOME_REVIEWS_NATIVE_POST_RENDER_V20147__) {
    window.__HARDRIP_HOME_REVIEWS_NATIVE_POST_RENDER_V20147__ = true;

    const EMPTY_ATTR = 'data-hardrip-empty-home-review';
    const PRODUCT_LINK_SELECTOR = 'a[href*="/products/"]';
    const TARGET_VALID_PER_BATCH = 6;
    const MAX_NATIVE_PAGES_PER_BATCH = 10;
    const QUIET_MS = 250;
    const MAX_SETTLE_MS = 1800;
    let root = null;
    let observer = null;
    let stableKeys = new Set();
    let autoFillRunning = false;
    let settleTimer = 0;

    const canonical = (value) => lower(value)
      .replace(/[“”„‟«»]/g, '"')
      .replace(/[’‘`´]/g, "'")
      .replace(/[→➜➝➞➟➠⟶⟹⇢›»]+/g, ' ')
      .replace(/\s*[|•·]+\s*/g, ' ')
      .replace(/[\s\-–—:;,.!?]+$/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const isDate = (text) => /^(?:\d{1,2}[\/.-]\d{1,2}[\/.-]\d{2,4}|\d{1,2}\s+[a-zà-ÿ]+\s+\d{4})$/i.test(clean(text));
    const isStarsOnly = (text) => /^[★☆⭐✦✧\s]+$/.test(clean(text));
    const isInitial = (text) => /^[A-ZÀ-ÖØ-Ý]$/.test(clean(text));
    const isNumericNoise = (text) => /^(?:\(?\d+(?:[.,]\d+)?\)?|\d+\s*%)$/.test(clean(text));
    const isUiText = (text) => {
      const t = canonical(text);
      return !t || [
        'in evidenza','5 stelle','4 stelle','3 stelle o meno','con foto o video',
        'più convincenti','più recenti','valutazione più alta','valutazione più bassa',
        'prima foto e video','scopri altre recensioni','caricamento recensioni','caricamento recensioni…',
        'nessuna recensione corrisponde al filtro selezionato','recensioni reali','recensione reale',
        'most helpful','most recent','highest rating','lowest rating','with photos or videos',
        'photos and videos first','load more reviews','show more reviews','verified','verificato',
        'verified buyer','acquirente verificato','write a review','scrivi una recensione'
      ].includes(t);
    };

    const findRoot = () => {
      const headings = Array.from(document.querySelectorAll('h1,h2,h3,h4,[role="heading"]'));
      const heading = headings.find((el) => {
        const t = lower(el.textContent);
        return t.includes('cosa dicono di noi') || t.includes('what they say about us');
      });
      return heading?.closest('.shopify-section') || heading?.closest('section,[class*="section"]') || null;
    };

    const productLinks = (node) => Array.from(node.querySelectorAll(PRODUCT_LINK_SELECTOR));
    const hasStars = (node) => Boolean(node.querySelector('.jdgm-star,[class*="star"],[aria-label*="star" i],[aria-label*="stelle" i]')) || /[★⭐]{3,}/.test(String(node.innerText || ''));
    const inferCard = (link, reviewRoot) => {
      let node = link;
      let best = null;
      for (let depth = 0; node && depth < 12; depth += 1) {
        node = node.parentElement;
        if (!(node instanceof Element) || node === reviewRoot || !reviewRoot.contains(node)) break;
        const links = productLinks(node).length;
        if (links > 1) break;
        if (links === 1 && hasStars(node)) best = node;
      }
      return best;
    };
    const cards = (reviewRoot) => {
      if (!(reviewRoot instanceof Element)) return [];
      const found = new Set();
      reviewRoot.querySelectorAll(PRODUCT_LINK_SELECTOR).forEach((link) => {
        const card = inferCard(link, reviewRoot);
        if (card) found.add(card);
      });
      const arr = Array.from(found).filter((el) => reviewRoot.contains(el));
      return arr.filter((card) => !arr.some((other) => other !== card && other.contains(card)));
    };

    const titleCanonicals = (card) => productLinks(card).map((a) => canonical(a.textContent)).filter(Boolean);
    const isProductTitleOrFragment = (text, titles) => {
      const c = canonical(text);
      return Boolean(c) && titles.some((title) => c === title || (c.length >= 6 && title.includes(c)) || (title.length >= 6 && c.includes(title) && c.length - title.length <= 4));
    };
    const mediaElements = (card) => Array.from(card.querySelectorAll('img,video,picture')).filter((media) => {
      if (media.closest(PRODUCT_LINK_SELECTOR)) return false;
      const sig = lower(`${media.className || ''} ${media.getAttribute?.('alt') || ''} ${media.parentElement?.className || ''}`);
      if (/(avatar|profile|author|logo|icon|star|badge)/.test(sig)) return false;
      if (media.tagName !== 'IMG') return true;
      return Boolean(clean(media.currentSrc || media.getAttribute('src') || media.getAttribute('data-src') || media.getAttribute('data-lazy-src')));
    });
    const meaningfulText = (card) => {
      const titles = titleCanonicals(card);
      const lines = String(card.innerText || card.textContent || '').split(/\n+/).map(clean).filter(Boolean)
        .filter((line) => !isStarsOnly(line) && !isInitial(line) && !isDate(line) && !isNumericNoise(line) && !isUiText(line) && !isProductTitleOrFragment(line, titles))
        .map(canonical).filter(Boolean);
      return Array.from(new Set(lines));
    };
    const keepCard = (card) => mediaElements(card).length > 0 || meaningfulText(card).length >= 2;
    const filterCards = (reviewRoot) => cards(reviewRoot).forEach((card) => keepCard(card) ? card.removeAttribute(EMPTY_ATTR) : card.setAttribute(EMPTY_ATTR, 'true'));
    const visible = (el, reviewRoot) => {
      if (!(el instanceof Element) || el.hasAttribute(EMPTY_ATTR) || !reviewRoot.contains(el)) return false;
      for (let n = el; n && n !== reviewRoot; n = n.parentElement) {
        const cs = getComputedStyle(n);
        if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
      }
      return el.getClientRects().length > 0;
    };
    const cardKey = (card) => {
      const product = card.querySelector(PRODUCT_LINK_SELECTOR);
      const media = mediaElements(card)[0];
      const src = media instanceof HTMLImageElement ? clean(media.currentSrc || media.src || media.getAttribute('data-src')) : '';
      return `${canonical(product?.getAttribute('href') || '')}|${canonical(card.innerText || card.textContent || '')}|${canonical(src)}`.slice(0, 1400);
    };
    const visibleKeys = (reviewRoot) => {
      filterCards(reviewRoot);
      return new Set(cards(reviewRoot).filter((card) => visible(card, reviewRoot)).map(cardKey).filter(Boolean));
    };

    const label = (el) => canonical(el?.innerText || el?.textContent || el?.getAttribute?.('aria-label') || '');
    const isLoadMore = (text) => text.includes('scopri altre recensioni') || text.includes('load more reviews') || text.includes('mostra altre recensioni') || text.includes('show more reviews');
    const loadMoreButton = (reviewRoot) => Array.from(reviewRoot.querySelectorAll('button,a,[role="button"]')).find((el) => isLoadMore(label(el)) && !el.hidden && !el.hasAttribute('disabled') && el.getAttribute('aria-disabled') !== 'true' && getComputedStyle(el).display !== 'none') || null;

    const imageSource = (img) => clean(
      img?.currentSrc || img?.getAttribute?.('src') || img?.getAttribute?.('data-src') ||
      img?.getAttribute?.('data-lazy-src') || img?.getAttribute?.('data-original') || ''
    );
    const isReviewMediaImage = (img) => {
      if (!(img instanceof HTMLImageElement)) return false;
      const sig = lower(`${img.className || ''} ${img.alt || ''} ${img.parentElement?.className || ''}`);
      if (/(avatar|profile|author|logo|icon|star|badge)/.test(sig)) return false;
      return Boolean(imageSource(img));
    };

    /*
      PASSIVE PRE-DECODE V20.147
      IMPORTANT: nessun masking visivo. Non usiamo filter/opacity/visibility/display,
      non applichiamo classi pending alle card e non copriamo mai la pagina.
      Prepariamo soltanto tutte le possibili URL immagine in cache/decoder.
    */
    const prewarmCache = window.__HARDRIP_REVIEW_PREWARM_CACHE_V20147__ ||= new Map();
    const PREWARM_LIMIT = 180;

    const srcsetUrls = (value) => String(value || '').split(',').map((part) => clean(part.trim().split(/\s+/)[0])).filter(Boolean);
    const imageSources = (img) => {
      if (!(img instanceof HTMLImageElement)) return [];
      const values = [
        img.currentSrc, img.src,
        img.getAttribute('src'), img.getAttribute('data-src'), img.getAttribute('data-lazy-src'),
        img.getAttribute('data-original'), img.getAttribute('data-full'), img.getAttribute('data-large'),
        img.getAttribute('data-zoom-image'), img.dataset?.src, img.dataset?.original, img.dataset?.full,
        ...srcsetUrls(img.getAttribute('srcset')),
        ...srcsetUrls(img.getAttribute('data-srcset')),
        ...srcsetUrls(img.dataset?.srcset)
      ];
      const parentLink = img.closest('a[href]');
      if (parentLink && /\.(?:avif|webp|jpe?g|png)(?:[?#].*)?$/i.test(parentLink.href || '')) values.push(parentLink.href);
      return Array.from(new Set(values.map(clean).filter((u) => /^https?:|^\/\//i.test(u) || u.startsWith('/'))));
    };

    const warmUrl = (url) => {
      if (!url || prewarmCache.has(url) || prewarmCache.size >= PREWARM_LIMIT) return;
      const probe = new Image();
      probe.decoding = 'async';
      probe.loading = 'eager';
      try { probe.fetchPriority = 'low'; } catch (_) {}
      prewarmCache.set(url, probe);
      probe.src = url;
      if (probe.decode) probe.decode().catch(() => {});
    };

    const prewarmImage = (img) => {
      if (!isReviewMediaImage(img)) return;
      imageSources(img).forEach(warmUrl);
      /* Fa scegliere al browser anche la stessa variante responsive che userà la card. */
      const srcset = clean(img.getAttribute('srcset') || img.getAttribute('data-srcset'));
      if (srcset && prewarmCache.size < PREWARM_LIMIT) {
        const key = `srcset:${srcset}|${clean(img.getAttribute('sizes'))}`;
        if (!prewarmCache.has(key)) {
          const probe = new Image(); probe.decoding = 'async'; probe.loading = 'eager';
          probe.srcset = srcset; probe.sizes = img.getAttribute('sizes') || '160px';
          const fallback = imageSources(img)[0]; if (fallback) probe.src = fallback;
          prewarmCache.set(key, probe); if (probe.decode) probe.decode().catch(() => {});
        }
      }
    };

    const prewarmReviewMedia = (reviewRoot) => {
      if (!(reviewRoot instanceof Element)) return;
      reviewRoot.querySelectorAll('img').forEach(prewarmImage);
      /* Alcuni dati Judge.me sono fuori dal wrapper visuale: scaldali comunque. */
      document.querySelectorAll('.jdgm-rev img,[data-review-id] img,img[class*="jdgm"],img[class*="review"]').forEach(prewarmImage);
    };

    const prewarmAddedNodes = (mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node instanceof HTMLImageElement) {
          try { node.decoding = 'async'; node.loading = 'eager'; } catch (_) {}
          prewarmImage(node);
        }
        node.querySelectorAll?.('img').forEach((img) => {
          try { img.decoding = 'async'; img.loading = 'eager'; } catch (_) {}
          prewarmImage(img);
        });
      }));
    };

    const waitSettle = (reviewRoot) => new Promise((resolve) => {
      let last = performance.now();
      let count = cards(reviewRoot).length;
      const started = performance.now();
      const mo = new MutationObserver(() => { last = performance.now(); filterCards(reviewRoot); });
      mo.observe(reviewRoot, { childList: true, subtree: true });
      const timer = setInterval(() => {
        filterCards(reviewRoot);
        const next = cards(reviewRoot).length;
        if (next !== count) { count = next; last = performance.now(); }
        const elapsed = performance.now() - started;
        if ((elapsed > 300 && performance.now() - last >= QUIET_MS) || elapsed >= MAX_SETTLE_MS) {
          clearInterval(timer); mo.disconnect(); resolve();
        }
      }, 70);
    });

    const fillIfNeeded = async () => {
      if (!root || autoFillRunning) return;
      const current = visibleKeys(root);
      const gained = Array.from(current).filter((key) => !stableKeys.has(key)).length;
      if (gained <= 0) { stableKeys = current; return; }
      if (gained >= TARGET_VALID_PER_BATCH) { stableKeys = current; return; }

      autoFillRunning = true;
      try {
        let attempts = 0;
        let stagnant = 0;
        let previousCount = cards(root).length;
        while (attempts < MAX_NATIVE_PAGES_PER_BATCH) {
          const now = visibleKeys(root);
          const totalGained = Array.from(now).filter((key) => !stableKeys.has(key)).length;
          if (totalGained >= TARGET_VALID_PER_BATCH) break;
          const btn = loadMoreButton(root);
          if (!btn) break;
          attempts += 1;
          const beforeCount = cards(root).length;
          btn.click();
          await waitSettle(root);
          const afterCount = cards(root).length;
          if (afterCount <= beforeCount && afterCount <= previousCount) stagnant += 1; else stagnant = 0;
          previousCount = afterCount;
          if (stagnant >= 2) break;
        }
      } finally {
        filterCards(root);
        stableKeys = visibleKeys(root);
        autoFillRunning = false;
      }
    };

    const attach = () => {
      root = findRoot();
      if (!root) return false;
      let style = document.getElementById('HardripHomeReviewsNativePostRenderV20147');
      if (!style) {
        style = document.createElement('style');
        style.id = 'HardripHomeReviewsNativePostRenderV20147';
        style.textContent = '[data-hardrip-empty-home-review="true"]{display:none!important;}';
        document.head.appendChild(style);
      }
      filterCards(root);
      prewarmReviewMedia(root);
      [250, 800, 1800, 3500].forEach((ms) => setTimeout(() => prewarmReviewMedia(root), ms));
      if ('requestIdleCallback' in window) requestIdleCallback(() => prewarmReviewMedia(root), { timeout: 1800 });
      stableKeys = visibleKeys(root);
      observer?.disconnect();
      observer = new MutationObserver((mutations) => {
        prewarmAddedNodes(mutations);
        prewarmReviewMedia(root);
        clearTimeout(settleTimer);
        settleTimer = window.setTimeout(() => void fillIfNeeded(), 330);
      });
      observer.observe(root, { childList: true, subtree: true });
      return true;
    };

    const startHome = () => {
      if (attach()) return;
      let tries = 0;
      const timer = setInterval(() => { tries += 1; if (attach() || tries >= 30) clearInterval(timer); }, 250);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startHome, { once: true }); else startHome();
  }

  /* ---------------------------------------------------------------------- */
  /* PRODUCT · viewport/payment overflow + Judge.me recovery + viewer meta. */
  /* ---------------------------------------------------------------------- */
  if (isProduct && !window.__HARDRIP_PRODUCT_LAYOUT_REVIEWS_V20147__) {
    window.__HARDRIP_PRODUCT_LAYOUT_REVIEWS_V20147__ = true;
    document.documentElement.classList.add('hardrip-product-v20147');

    const style = document.createElement('style');
    style.id = 'HardripProductLayoutReviewsV20147';
    style.textContent = `
      @media (max-width: 749px) {
        html.hardrip-product-v20147, html.hardrip-product-v20147 body {
          width: 100% !important; max-width: 100% !important; overflow-x: clip !important;
        }
        html.hardrip-product-v20147 #MainContent,
        html.hardrip-product-v20147 #MainContent .shopify-section,
        html.hardrip-product-v20147 .product,
        html.hardrip-product-v20147 .product__info-wrapper,
        html.hardrip-product-v20147 .product__info-container,
        html.hardrip-product-v20147 .product-form,
        html.hardrip-product-v20147 product-form,
        html.hardrip-product-v20147 form[action*="/cart/add"] {
          min-width: 0 !important; max-width: 100% !important;
        }
        html.hardrip-product-v20147 .shopify-payment-button,
        html.hardrip-product-v20147 .shopify-payment-button__button,
        html.hardrip-product-v20147 .shopify-payment-button__more-options,
        html.hardrip-product-v20147 shopify-accelerated-checkout,
        html.hardrip-product-v20147 shopify-accelerated-checkout-cart,
        html.hardrip-product-v20147 shop-pay-wallet-button,
        html.hardrip-product-v20147 [data-shopify="payment-button"],
        html.hardrip-product-v20147 [class*="accelerated-checkout"] {
          box-sizing: border-box !important;
          min-width: 0 !important; max-width: 100% !important; width: 100% !important;
          left: auto !important; right: auto !important; inset-inline: auto !important;
          transform: none !important; margin-left: 0 !important; margin-right: 0 !important;
        }
        html.hardrip-product-v20147 .shopify-payment-button,
        html.hardrip-product-v20147 shopify-accelerated-checkout,
        html.hardrip-product-v20147 shopify-accelerated-checkout-cart,
        html.hardrip-product-v20147 [data-shopify="payment-button"] {
          position: relative !important; overflow: clip !important; contain: layout paint !important;
        }
        html.hardrip-product-v20147 .shopify-payment-button__more-options {
          position: relative !important; display: block !important; white-space: normal !important;
        }
      }
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147,
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147 .jdgm-rev-widg,
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147 .jdgm-rev-widg__body,
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147 .jdgm-rev-widg__reviews {
        display: block !important; visibility: visible !important; opacity: 1 !important;
        height: auto !important; max-height: none !important; overflow: visible !important;
        content-visibility: visible !important;
      }
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147 .jdgm-rev-widg__reviews > .jdgm-rev,
      html.hardrip-product-v20147 .hardrip-jdgm-restored-v20147 .jdgm-rev {
        visibility: visible !important; opacity: 1 !important; max-height: none !important;
      }
      #judgeme_product_reviews { scroll-margin-top: 145px; }
    `;
    document.head.appendChild(style);

    const paymentSelectors = [
      '.shopify-payment-button','shopify-accelerated-checkout','shopify-accelerated-checkout-cart',
      'shop-pay-wallet-button','[data-shopify="payment-button"]','[class*="accelerated-checkout"]',
      '.shopify-payment-button__more-options'
    ];
    const clampPayment = () => {
      if (innerWidth > 749) return;
      document.querySelectorAll(paymentSelectors.join(',')).forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        el.style.maxWidth = '100%'; el.style.minWidth = '0'; el.style.boxSizing = 'border-box';
        const r = el.getBoundingClientRect();
        if (r.right > innerWidth + 2 || r.left < -2) {
          el.style.width = '100%'; el.style.left = 'auto'; el.style.right = 'auto'; el.style.transform = 'none';
        }
      });
    };
    const paymentObserver = new MutationObserver(clampPayment);
    const startPaymentFix = () => {
      clampPayment();
      paymentObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style'] });
      setTimeout(() => paymentObserver.disconnect(), 6000);
      [100,250,500,900,1500,2500,4000].forEach((ms) => setTimeout(clampPayment, ms));
    };

    const reviewWidgetSelectors = [
      '#judgeme_product_reviews', '.jdgm-review-widget', '.jdgm-widget.jdgm-review-widget',
      '.jdgm-rev-widg', '[data-widget="review"][data-product-id]', '[data-id].jdgm-widget'
    ];
    const allReviewWidgets = () => Array.from(new Set(reviewWidgetSelectors.flatMap((sel) => Array.from(document.querySelectorAll(sel)))));
    const reviewWidget = () => {
      const candidates = allReviewWidgets();
      if (!candidates.length) return null;
      return candidates.sort((a,b) => b.querySelectorAll('.jdgm-rev,[data-review-id]').length - a.querySelectorAll('.jdgm-rev,[data-review-id]').length)[0] || null;
    };
    const reviewEntries = (widget) => widget ? widget.querySelectorAll('.jdgm-rev,[data-review-id]').length : 0;
    const advertisedReviewCount = () => {
      let max = 0;
      const selectors = [
        '.jdgm-prev-badge__text','.jdgm-rev-widg__summary-text','a[href*="#judgeme_product_reviews"]',
        '[class*="review-count"]','[class*="reviews-count"]','[data-review-count]','[data-reviews-count]',
        '.product__rating','.rating-count','.rating-text'
      ];
      document.querySelectorAll(selectors.join(',')).forEach((el) => {
        const raw = clean(el.getAttribute?.('data-review-count') || el.getAttribute?.('data-reviews-count') || el.textContent);
        const m = raw.match(/(\d[\d.,]*)\s*(?:recension|review)/i) || raw.match(/^\(?\s*(\d+)\s*\)?$/);
        if (m) max = Math.max(max, parseInt(m[1].replace(/[^\d]/g,''),10) || 0);
      });
      if (max === 0) {
        Array.from(document.querySelectorAll('a,span,div')).slice(0,1800).forEach((el) => {
          const t = clean(el.textContent);
          if (t.length > 50) return;
          const m = t.match(/(?:^|\s)(\d{1,5})\s*(?:recensioni?|reviews?)(?:\s|$)/i);
          if (m) max = Math.max(max, parseInt(m[1],10) || 0);
        });
      }
      return max;
    };
    const clearStaleReviewFlags = (widget) => {
      if (!(widget instanceof Element)) return;
      const staleAttrs = [
        'data-hardrip-empty-home-review','data-hardrip-review-queued','data-hardrip-review-staging',
        'data-hardrip-hidden','data-hardrip-filtered','aria-busy'
      ];
      [widget, ...widget.querySelectorAll('*')].forEach((el) => staleAttrs.forEach((attr) => el.removeAttribute?.(attr)));
    };
    const forceVisibleNode = (el, rootWidget) => {
      if (!(el instanceof HTMLElement)) return;
      el.hidden = false;
      el.removeAttribute('aria-hidden');
      ['display','visibility','opacity','height','max-height','overflow','content-visibility'].forEach((p) => el.style.removeProperty(p));
      if (el === rootWidget || el.matches('.jdgm-rev-widg,.jdgm-rev-widg__body,.jdgm-rev-widg__reviews')) {
        el.style.setProperty('display','block','important');
        el.style.setProperty('visibility','visible','important');
        el.style.setProperty('opacity','1','important');
        el.style.setProperty('height','auto','important');
        el.style.setProperty('max-height','none','important');
        el.style.setProperty('overflow','visible','important');
      }
    };
    const revealJudgeWidget = (widget) => {
      if (!(widget instanceof HTMLElement)) return;
      let rootWidget = widget.closest('#judgeme_product_reviews,.jdgm-review-widget,.jdgm-widget') || widget;
      rootWidget.classList.add('hardrip-jdgm-restored-v20147');
      clearStaleReviewFlags(rootWidget);
      forceVisibleNode(rootWidget, rootWidget);
      rootWidget.querySelectorAll('.jdgm-rev-widg,.jdgm-rev-widg__body,.jdgm-rev-widg__reviews,.jdgm-rev,[data-review-id]').forEach((el) => forceVisibleNode(el, rootWidget));
      for (let n = rootWidget.parentElement, i = 0; n && i < 7 && n !== document.body; n = n.parentElement, i += 1) {
        if (!(n instanceof HTMLElement)) continue;
        const cs = getComputedStyle(n);
        if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0 || n.hidden) {
          n.hidden = false; n.removeAttribute('aria-hidden');
          n.style.setProperty('display','block','important');
          n.style.setProperty('visibility','visible','important');
          n.style.setProperty('opacity','1','important');
          n.style.removeProperty('height'); n.style.removeProperty('max-height');
        }
        if (n.id === 'MainContent') break;
      }
    };
    const productId = () => {
      const direct = window.meta?.product?.id || window.ShopifyAnalytics?.meta?.product?.id || window.Shopify?.product?.id;
      if (direct) return String(direct);
      for (const s of document.querySelectorAll('script[type="application/json"]')) {
        try { const j=JSON.parse(s.textContent||'{}'); if (j?.id && (j?.variants || j?.title)) return String(j.id); } catch (_) {}
      }
      return '';
    };
    const findReviewMount = () => {
      const existing = reviewWidget(); if (existing) return existing;
      const heading = Array.from(document.querySelectorAll('h2,h3,h4,[role="heading"]')).find((el) => /customer reviews|recensioni(?: dei| del| clienti)?/i.test(clean(el.textContent)));
      return heading?.parentElement || heading?.closest('.shopify-section,section') || null;
    };
    const createMissingJudgeContainer = () => {
      if (reviewWidget() || advertisedReviewCount() <= 0) return null;
      const id = productId(); if (!id) return null;
      const mount = findReviewMount();
      if (!mount || mount.id === 'MainContent' || mount === document.body) return null;
      const div=document.createElement('div');
      div.id='judgeme_product_reviews'; div.className='jdgm-widget jdgm-review-widget hardrip-jdgm-restored-v20147'; div.setAttribute('data-id',id);
      mount.appendChild(div);
      return div;
    };
    let jdgmInitAttempts = 0;
    let recoveryDone = false;
    const initializeJudge = () => {
      if (!(window.jdgm && typeof window.jdgm.initializeWidgets === 'function')) return false;
      if (jdgmInitAttempts >= 8) return false;
      jdgmInitAttempts += 1;
      try { window.jdgm.initializeWidgets(); return true; } catch (_) { return false; }
    };
    const ensureProductReviews = () => {
      const count = advertisedReviewCount();
      if (count <= 0) return false;
      let widgets = allReviewWidgets();
      if (!widgets.length) {
        const created = createMissingJudgeContainer();
        if (created) widgets = [created];
      }
      widgets.forEach(revealJudgeWidget);
      const entries = widgets.reduce((sum,w) => sum + reviewEntries(w), 0);
      if (entries > 0) { recoveryDone = true; return true; }
      initializeJudge();
      setTimeout(() => allReviewWidgets().forEach(revealJudgeWidget), 180);
      setTimeout(() => allReviewWidgets().forEach(revealJudgeWidget), 700);
      return false;
    };
    let reviewRecoveryObserver = null;
    const startReviewRecovery = () => {
      const schedule = [0,250,600,1100,1800,2800,4200,6200,9000,12500,16500,20500];
      schedule.forEach((ms) => setTimeout(() => { if (!recoveryDone) ensureProductReviews(); }, ms));
      reviewRecoveryObserver = new MutationObserver((mutations) => {
        let relevant=false;
        for (const m of mutations) for (const n of m.addedNodes) {
          if (!(n instanceof Element)) continue;
          const sig=lower(`${n.id||''} ${n.className||''}`);
          if (/jdgm|judgeme|review/.test(sig) || n.querySelector?.('.jdgm-rev,#judgeme_product_reviews,.jdgm-review-widget')) { relevant=true; break; }
        }
        if (relevant) {
          allReviewWidgets().forEach(revealJudgeWidget);
          if (!recoveryDone) setTimeout(ensureProductReviews,60);
        }
      });
      reviewRecoveryObserver.observe(document.body,{childList:true,subtree:true});
      setTimeout(() => reviewRecoveryObserver?.disconnect(),23000);
    };

    /* HARDRIP_JUDGEME_REVAMP_IDENTITY_V20164
       Judge.me revamp can return only zero-width characters for imported reviewer identities.
       Preserve every real reviewer name; use a localized fallback only when the supplied identity is truly empty. */
    const hardripReviewVisibleText = (value) => clean(String(value || '').replace(/[\u200B-\u200D\u2060\uFEFF]/g, ''));
    const hardripReviewIsEnglish = () => {
      const lang = String(document.documentElement?.lang || window.Shopify?.locale || window.Shopify?.language || '').toLowerCase();
      const path = String(location.pathname || '').toLowerCase();
      return lang.startsWith('en') || path === '/en' || path.startsWith('/en/');
    };
    const fixJudgeRevampReviewerIdentity = (scope = document) => {
      const cards = [];
      if (scope instanceof Element && scope.matches('.jm-review-item')) cards.push(scope);
      if (scope?.querySelectorAll) cards.push(...scope.querySelectorAll('.jm-review-item'));
      Array.from(new Set(cards)).forEach((card) => {
        const nameEl = card.querySelector('.jm-reviewer-info__name');
        const avatarTextEl = card.querySelector('.jm-reviewer-avatar__initial .jm-text');
        if (nameEl && !hardripReviewVisibleText(nameEl.textContent)) {
          const fallbackName = hardripReviewIsEnglish() ? 'Customer' : 'Cliente';
          nameEl.textContent = fallbackName;
          nameEl.setAttribute('title', fallbackName);
          nameEl.setAttribute('data-hardrip-reviewer-fallback', 'true');
        }
        if (avatarTextEl && !hardripReviewVisibleText(avatarTextEl.textContent)) {
          avatarTextEl.textContent = 'C';
          avatarTextEl.setAttribute('data-hardrip-reviewer-fallback', 'true');
        }
      });
    };
    let hardripReviewIdentityQueued = false;
    const scheduleJudgeRevampReviewerIdentity = () => {
      if (hardripReviewIdentityQueued) return;
      hardripReviewIdentityQueued = true;
      requestAnimationFrame(() => {
        hardripReviewIdentityQueued = false;
        fixJudgeRevampReviewerIdentity(document);
      });
    };
    const judgeRevampIdentityObserver = new MutationObserver((mutations) => {
      let relevant = false;
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          if (mutation.target?.parentElement?.closest?.('.jm-review-item')) { relevant = true; break; }
          continue;
        }
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.jm-review-item') || node.querySelector?.('.jm-review-item') || node.closest?.('.jm-review-item')) { relevant = true; break; }
        }
        if (relevant) break;
      }
      if (relevant) scheduleJudgeRevampReviewerIdentity();
    });
    const startJudgeRevampIdentityFix = () => {
      fixJudgeRevampReviewerIdentity(document);
      [120,350,800,1500,3000,6000,10000].forEach((ms) => setTimeout(scheduleJudgeRevampReviewerIdentity, ms));
      judgeRevampIdentityObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    };

    /* HARDRIP_SHOP_VERIFICATION_UI_INERT_V20173
       "Verified by Shop" / "review written in Shop App" is verification UI,
       never customer media. Block only that UI (and other non-media images in
       a Shop App review); genuine review thumbnails remain fully interactive. */
    const hardripShopCardSelectorV20173 = '.jm-review-item,.jdgm-rev,[data-review-id]';
    const hardripShopSourceSelectorV20173 = '[data-badge-type="review_written_in_shop_app"],.jdgm-rev__transparency-badge[data-badge-type="review_written_in_shop_app"],.jdgm-rev__transparency-badge-wrapper [data-badge-type="review_written_in_shop_app"]';
    const hardripRealReviewMediaSelectorV20173 = '.jm-media-thumbnail-list,.jm-media-thumbnail-list__thumbnail,[class*="media-thumbnail"],[class*="review-media"],.jdgm-rev__pics,.jdgm-rev__pic-link';
    const hardripShopTextRxV20173 = /review\s+written\s+in\s+shop\s+app|recensione\s+scritta\s+in\s+shop\s+app/i;
    const hardripVerifiedRxV20173 = /verified\s*by\s*shop|verificat[oa]\s+(?:da|by)\s+shop/i;
    const hardripNodeSigV20173 = (node) => {
      if (!(node instanceof Element)) return '';
      const src = node instanceof HTMLImageElement ? `${node.currentSrc||''} ${node.getAttribute('src')||''} ${node.getAttribute('data-src')||''}` : '';
      return clean(`${node.textContent||''} ${node.id||''} ${node.className||''} ${node.getAttribute?.('aria-label')||''} ${node.getAttribute?.('title')||''} ${node.getAttribute?.('alt')||''} ${src}`);
    };
    const hardripShopCardV20173 = (event) => {
      const path = typeof event?.composedPath === 'function' ? event.composedPath() : [event?.target];
      const target = event?.target instanceof Element ? event.target : null;
      return target?.closest?.(hardripShopCardSelectorV20173) || path.find((node) => node instanceof Element && node.matches?.(hardripShopCardSelectorV20173)) || null;
    };
    const hardripIsShopCardV20173 = (card) => {
      if (!(card instanceof Element)) return false;
      if (card.getAttribute('data-hardrip-shop-review-v20173') === 'true') return true;
      if (card.querySelector?.(hardripShopSourceSelectorV20173)) return true;
      return hardripShopTextRxV20173.test(clean(card.textContent||''));
    };
    const hardripPathV20173 = (event) => (typeof event?.composedPath === 'function' ? event.composedPath() : [event?.target]).filter((node) => node instanceof Element);
    const hardripIsRealReviewMediaNodeV20173 = (node, card) => {
      if (!(node instanceof Element) || !(card instanceof Element) || !card.contains(node)) return false;
      return !!(node.matches?.(hardripRealReviewMediaSelectorV20173) || node.closest?.(hardripRealReviewMediaSelectorV20173));
    };
    const hardripIsExplicitShopUiNodeV20173 = (node, card) => {
      if (!(node instanceof Element) || !(card instanceof Element) || !card.contains(node)) return false;
      if (node.matches?.(hardripShopSourceSelectorV20173) || node.closest?.(hardripShopSourceSelectorV20173)) return true;
      let n=node;
      for(let i=0;n&&n!==card&&i<5;i++,n=n.parentElement){
        const sig=hardripNodeSigV20173(n);
        if(hardripVerifiedRxV20173.test(sig)) return true;
        const cls=lower(`${n.id||''} ${n.className||''}`);
        if(/transparency[-_ ]?badge|verified[-_ ]?shop|shop[-_ ]?verified/.test(cls)) return true;
      }
      return false;
    };
    const hardripStopShopUiV20173 = (event) => {
      const card=hardripShopCardV20173(event);
      if(!card) return;
      const path=hardripPathV20173(event);
      const explicit=path.some((node)=>hardripIsExplicitShopUiNodeV20173(node,card));
      if(explicit){
        event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();return;
      }
      if(!hardripIsShopCardV20173(card)) return;
      if(path.some((node)=>hardripIsRealReviewMediaNodeV20173(node,card))) return;
      const visual=path.find((node)=>node!==card && (node.matches?.('img,svg,picture,a,button,[role="button"]') || node.querySelector?.('img,svg')));
      if(!visual) return;
      event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
    };
    ['pointerdown','click','auxclick','touchend'].forEach((type)=>{
      window.addEventListener(type,hardripStopShopUiV20173,true);
      document.addEventListener(type,hardripStopShopUiV20173,true);
    });
    const hardripMarkShopUiV20173=(scope=document)=>{
      const cards=[];
      if(scope instanceof Element&&scope.matches?.(hardripShopCardSelectorV20173)) cards.push(scope);
      if(scope?.querySelectorAll) cards.push(...scope.querySelectorAll(hardripShopCardSelectorV20173));
      for(const card of new Set(cards)){
        if(!hardripIsShopCardV20173(card)) continue;
        card.setAttribute('data-hardrip-shop-review-v20173','true');
        for(const img of card.querySelectorAll('img')){
          if(img.closest(hardripRealReviewMediaSelectorV20173)) continue;
          img.setAttribute('data-hardrip-shop-nonmedia-v20173','true');
          img.setAttribute('draggable','false');
          img.style?.setProperty('cursor','default','important');
        }
        for(const el of card.querySelectorAll(`${hardripShopSourceSelectorV20173},.jdgm-rev__transparency-badge,[class*="transparency-badge"]`)){
          el.setAttribute('data-hardrip-shop-verification-ui-v20173','true');
          el.style?.setProperty('cursor','default','important');
        }
      }
    };
    let hardripShopUiQueuedV20173=false;
    const hardripQueueShopUiV20173=()=>{
      if(hardripShopUiQueuedV20173)return;
      hardripShopUiQueuedV20173=true;
      requestAnimationFrame(()=>{hardripShopUiQueuedV20173=false;hardripMarkShopUiV20173(document);});
    };
    const hardripShopUiObserverV20173=new MutationObserver(hardripQueueShopUiV20173);
    const hardripStartShopUiV20173=()=>{
      hardripMarkShopUiV20173(document);
      if(document.body) hardripShopUiObserverV20173.observe(document.body,{childList:true,subtree:true,characterData:true});
      [100,300,700,1400,3000,6000,10000].forEach(ms=>setTimeout(hardripQueueShopUiV20173,ms));
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',hardripStartShopUiV20173,{once:true});
    else hardripStartShopUiV20173();

    const judgeSignature = (node) => {
      for (let n = node instanceof Element ? node : null, i = 0; n && i < 12; n = n.parentElement, i += 1) {
        const sig = lower(`${n.id || ''} ${n.className || ''}`);
        if (/judgeme|jdgm|review|reviews|rev\b/.test(sig)) return true;
      }
      return false;
    };
    const reviewRootScore = (node) => {
      if (!(node instanceof Element)) return -999;
      const sig = lower(`${node.id || ''} ${node.className || ''}`);
      const authors = node.querySelectorAll('.jdgm-rev__author,[class*="review-author"],[class*="author-name"],[data-author]').length;
      const bodies = node.querySelectorAll('.jdgm-rev__body,[class*="review-body"],[data-review-body]').length;
      const titles = node.querySelectorAll('.jdgm-rev__title,[class*="review-title"],[data-review-title]').length;
      const dates = node.querySelectorAll('.jdgm-rev__timestamp,time,[class*="review-date"]').length;
      const nestedReviews = node.querySelectorAll('.jdgm-rev,[data-review-id]').length;
      let score = 0;
      if (node.matches('.jdgm-rev,[data-review-id]')) score += 180;
      if (/review-card|review_item|review-item|jdgm-carousel-item/.test(sig)) score += 80;
      if (authors === 1) score += 60; if (bodies === 1) score += 70; if (titles === 1) score += 30; if (dates === 1) score += 25;
      if (clean(node.innerText).length >= 20) score += 15;
      if (nestedReviews > 1 || authors > 1 || bodies > 1 || dates > 1) score -= 220;
      return score;
    };
    const robustReviewRoot = (img) => {
      let n = img instanceof Element ? img : null, best = null, bestScore = -999;
      for (let depth = 0; n && n !== document.body && depth < 16; depth += 1, n = n.parentElement) {
        const score = reviewRootScore(n);
        if (score > bestScore) { best = n; bestScore = score; }
        if (score >= 220) break;
      }
      return bestScore >= 30 ? best : null;
    };
    const textFrom = (rootEl, selectors) => {
      for (const sel of selectors) {
        const el = rootEl?.querySelector?.(sel);
        const t = clean(el?.innerText || el?.textContent || el?.getAttribute?.('data-review-title') || el?.getAttribute?.('data-review-body') || '');
        if (t) return t;
      }
      return '';
    };
    const dateRe = /\b\d{1,2}[\/.-]\d{1,2}[\/.-]\d{2,4}\b/;
    const extractFullReview = (rootEl) => {
      let author = textFrom(rootEl, ['.jdgm-rev__author','[class*="review-author"]','[class*="author-name"]','[data-author]']);
      let date = textFrom(rootEl, ['.jdgm-rev__timestamp','time','[class*="review-date"]']);
      let title = textFrom(rootEl, ['.jdgm-rev__title','[data-review-title]','[class*="review-title"]']);
      let body = textFrom(rootEl, ['.jdgm-rev__body','[data-review-body]','[class*="review-body"]']);
      const productTitles = Array.from(rootEl?.querySelectorAll?.('a[href*="/products/"]') || []).map((a) => clean(a.textContent)).filter(Boolean);
      const reject = (t) => {
        const x = clean(t); if (!x) return true;
        if (productTitles.some((p) => lower(x) === lower(p))) return true;
        if (/^[★☆⭐\s]+$/.test(x) || dateRe.test(x) || lower(x) === lower(author)) return true;
        return /^(verified|verificato|acquirente verificato|verified buyer)$/i.test(x);
      };
      if (!date) date = (clean(rootEl?.innerText).match(dateRe) || [])[0] || '';
      const candidates = [];
      rootEl?.querySelectorAll?.('p,blockquote,[class*="content"],[class*="text"],div').forEach((el) => {
        if (el.querySelector('a[href*="/products/"]')) return;
        const t = clean(el.innerText || el.textContent);
        if (t.length < 4 || t.length > 1200 || reject(t)) return;
        if (Array.from(el.children || []).some((c) => clean(c.innerText || c.textContent) === t)) return;
        if (!candidates.some((x) => lower(x) === lower(t))) candidates.push(t);
      });
      candidates.sort((a,b) => b.length - a.length);
      if (!body) body = candidates.find((t) => t.length >= 12 && lower(t) !== lower(title)) || '';
      if (!title) title = candidates.find((t) => t !== body && t.length <= 180 && t.length >= 3) || '';
      if (body && title && lower(body).startsWith(lower(title))) body = clean(body.slice(title.length));
      return { author: clean(author).replace(/^[A-Z]\s+/, ''), date: clean(date), title: clean(title), body: clean(body) };
    };
    const patchOpenViewer = (img) => {
      const rootEl = robustReviewRoot(img); if (!rootEl) return;
      const data = extractFullReview(rootEl);
      const apply = () => {
        const viewer = document.getElementById('hardrip-review-viewer');
        if (!viewer?.classList.contains('is-open')) return;
        const review = viewer.querySelector('.hrv-review'); if (!review) return;
        const head = review.querySelector('.hrv-review-head');
        if (data.author) {
          let el = review.querySelector('.hrv-author');
          if (!el) { el = document.createElement('p'); el.className = 'hrv-author'; (head || review).appendChild(el); }
          el.textContent = data.author;
        }
        if (data.date) {
          let el = review.querySelector('.hrv-date');
          if (!el) { el = document.createElement('p'); el.className = 'hrv-date'; (head || review).appendChild(el); }
          el.textContent = data.date;
        }
        if (data.title) {
          let el = review.querySelector('.hrv-review-title');
          if (!el) { el = document.createElement('p'); el.className = 'hrv-review-title'; review.appendChild(el); }
          el.textContent = data.title;
        }
        if (data.body) {
          let el = review.querySelector('.hrv-review-body');
          if (!el) { el = document.createElement('p'); el.className = 'hrv-review-body'; review.appendChild(el); }
          el.textContent = data.body;
        }
      };
      [0,40,120,260].forEach((ms) => setTimeout(apply, ms));
    };
    window.addEventListener('click', (event) => {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const img = event.target instanceof HTMLImageElement ? event.target : path.find((n) => n instanceof HTMLImageElement);
      if (!(img instanceof HTMLImageElement) || !judgeSignature(img)) return;
      // HARDRIP_JUDGEME_REVAMP_MODAL_NO_DUP_V20164: the current jm-* viewer already renders its review once.
      if (img.closest('.jm-review-item')) return;
      // HARDRIP_JUDGEME_VIEWER_SECOND_TAP_NO_DUP_V20165: never re-process the image already displayed inside our review viewer.
      if (img.closest('#hardrip-review-viewer')) return;
      patchOpenViewer(img);
    }, true);

    const reviewNavigationClick = (event) => {
      const el = event.target instanceof Element ? event.target.closest('a,button,[role="button"],.jdgm-prev-badge') : null;
      if (!el) return;
      const sig = lower(`${el.getAttribute?.('href') || ''} ${el.className || ''} ${el.textContent || ''}`);
      if (!/judgeme_product_reviews|jdgm-prev-badge|recension|review/.test(sig)) return;
      [80,350,900].forEach((ms) => setTimeout(ensureProductReviews, ms));
    };
    document.addEventListener('click', reviewNavigationClick, false);

    const startProduct = () => {
      startPaymentFix();
      startReviewRecovery();
      startJudgeRevampIdentityFix();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startProduct, { once: true }); else startProduct();
  }
})();
/* HARDRIP V20.147 - HOME REVIEWS PASSIVE PREDECODE NO MASK END */

/* HARDRIP V20.150 - GLOBAL ENGLISH STRICT CLEANUP START */
(() => {
  const lang = String(document.documentElement?.lang || window.Shopify?.locale || window.Shopify?.language || '').toLowerCase();
  const path = String(location.pathname || '').toLowerCase();
  const isEnglish = lang.startsWith('en') || path === '/en' || path.startsWith('/en/');
  if (!isEnglish || window.__HARDRIP_GLOBAL_ENGLISH_V20150__) return;
  window.__HARDRIP_GLOBAL_ENGLISH_V20150__ = true;

  const exactPairs = [
    // Product recommendations / bundles
    ['Recensioni Clienti', 'Customer Reviews'],
    ['Scrivi una recensione', 'Write a review'],
    ['1 recensione', '1 review'],
    ['Condividi', 'Share'],
    ['Leggi le domande frequenti per toglierti ogni dubbio!', 'Read the frequently asked questions to clear up any doubts!'],
    ['Passa inoltre i comuni diamond tester.', 'It also passes standard diamond testers.'],
    ['Come valuteresti questo prodotto?', 'How would you rate this product?'],
    ['Ci piacerebbe se condividessi qualcosa sulla tua esperienza.', 'We would love you to share something about your experience.'],
    ['Pessimo', 'Poor'],
    ['Ottimo', 'Excellent'],
    ['Spesso acquistati insieme', 'Frequently bought together'],
    ['Acquistati spesso insieme', 'Frequently bought together'],
    ['Comprati spesso insieme', 'Frequently bought together'],
    ['Completa il look', 'Complete the look'],
    ['Prodotti correlati', 'Related products'],
    ['Potrebbero piacerti', 'You may also like'],
    ['Potrebbe piacerti', 'You may also like'],
    ['Scopri anche', 'You may also like'],
    ['Scegli opzioni', 'Choose options'],
    ['Scegli le opzioni', 'Choose options'],
    ['Seleziona opzioni', 'Select options'],
    ['Aggiungi entrambi al carrello', 'Add both to cart'],
    ['Aggiungi tutto al carrello', 'Add all to cart'],
    ['Prezzo totale', 'Total price'],
    ['Totale', 'Total'],
    ['Risparmia', 'Save'],
    ['Visualizza prodotto', 'View product'],
    ['Vedi prodotto', 'View product'],
    ['A partire da', 'From'],
    // Withdrawal / returns page
    ['Verifica che l’articolo rispetti le condizioni indicate. Ci aiuterà a gestire la richiesta nel modo più rapido possibile.', 'Make sure the item meets the conditions listed below. This will help us process your request as quickly as possible.'],
    ["Verifica che l'articolo rispetti le condizioni indicate. Ci aiuterà a gestire la richiesta nel modo più rapido possibile.", 'Make sure the item meets the conditions listed below. This will help us process your request as quickly as possible.'],
    ['Verifica che l’articolo rispetti le condizioni indicate.', 'Make sure the item meets the conditions listed below.'],
    ["Verifica che l'articolo rispetti le condizioni indicate.", 'Make sure the item meets the conditions listed below.'],
    ['Ci aiuterà a gestire la richiesta nel modo più rapido possibile.', 'This will help us process your request as quickly as possible.'],
    ['La richiesta di reso deve essere inviata entro 14 giorni dalla consegna dell’ordine.', 'The return request must be submitted within 14 days of delivery of the order.'],
    ["La richiesta di reso deve essere inviata entro 14 giorni dalla consegna dell'ordine.", 'The return request must be submitted within 14 days of delivery of the order.'],
    ['L’articolo deve essere integro, senza evidenti segni di utilizzo e completo della confezione originale.', 'The item must be intact, show no clear signs of use, and include its original packaging.'],
    ["L'articolo deve essere integro, senza evidenti segni di utilizzo e completo della confezione originale.", 'The item must be intact, show no clear signs of use, and include its original packaging.'],
    ['I gioielli realizzati su misura, incisi o creati secondo specifiche richieste del cliente non possono essere restituiti né rimborsati in caso di ripensamento.', "Custom-made, engraved, or personalized jewelry created to the customer's specifications cannot be returned or refunded due to a change of mind."],
    ['Prima della spedizione, ove previsto, vengono inviati foto e/o video del prodotto finito per l’approvazione del cliente.', 'Before shipping, where applicable, photos and/or videos of the finished product are sent to the customer for approval.'],
    ["Prima della spedizione, ove previsto, vengono inviati foto e/o video del prodotto finito per l'approvazione del cliente.", 'Before shipping, where applicable, photos and/or videos of the finished product are sent to the customer for approval.'],
    ['Restano tutelati eventuali difetti di conformità o errori di produzione imputabili a HARDRIP.', 'Any lack of conformity or production errors attributable to HARDRIP remain covered.'],
    ['Restano tutelati eventuali difetti di conformità o errori di produzione imputabili a HARDRIP', 'Any lack of conformity or production errors attributable to HARDRIP remain covered.'],
    ['Le spese di spedizione del reso sono a carico del cliente e non sono rimborsabili.', "Return shipping costs are the customer's responsibility and are non-refundable."],
    ['Non inviare il prodotto al produttore. Dopo la richiesta riceverai le indicazioni necessarie per procedere correttamente. Tieni a disposizione il numero d’ordine o la prova di acquisto.', 'Do not send the product to the manufacturer. After submitting your request, you will receive the instructions needed to proceed correctly. Keep your order number or proof of purchase available.'],
    ["Non inviare il prodotto al produttore. Dopo la richiesta riceverai le indicazioni necessarie per procedere correttamente. Tieni a disposizione il numero d'ordine o la prova di acquisto.", 'Do not send the product to the manufacturer. After submitting your request, you will receive the instructions needed to proceed correctly. Keep your order number or proof of purchase available.'],

    // Extra storefront variants observed on EN pages
    ['Traccia Il Tuo Ordine', 'Track Your Order'],
    ['SPESSO ACQUISTATI INSIEME', 'FREQUENTLY BOUGHT TOGETHER'],
    ['Spesso Acquistati Insieme', 'Frequently Bought Together'],
    ['RECENSIONI', 'REVIEWS'],
    ['recensioni', 'reviews'],
    ['Recensioni', 'Reviews'],

    // Global header / navigation / footer
    ['SPEDIZIONE GRATUITA SU TUTTI GLI ORDINI', 'FREE SHIPPING ON ALL ORDERS'],
    ['Spedizione gratuita su tutti gli ordini', 'Free shipping on all orders'],
    ['Tutti i prodotti', 'All products'],
    ['Tutti I Prodotti', 'All products'],
    ['Guida Alle Taglie', 'Size Guide'],
    ['Guida alle taglie', 'Size Guide'],
    ['Traccia Il Tuo Ordine', 'Track Your Order'],
    ['Traccia il tuo ordine', 'Track Your Order'],
    ['Domande Frequenti', 'Frequently Asked Questions'],
    ['Domande frequenti', 'Frequently Asked Questions'],
    ['Modulo Di Recesso', 'Right of Withdrawal Form'],
    ['Modulo di recesso', 'Right of Withdrawal Form'],
    ['Contattaci', 'Contact us'],
    ['Link rapidi', 'Quick links'],
    ['LINK RAPIDI', 'QUICK LINKS'],
    ['Traccia Il Tuo Ordine', 'Track Your Order'],
    ['Torna allo shop', 'Back to shop'],
    ['Continua lo shopping', 'Continue shopping'],
    ['Chi siamo?', 'About us'],
    ['CHI SIAMO?', 'ABOUT US'],
    ['Iscriviti per rimanere aggiornato sulle novità, rilascio di nuovi prodotti e sconti.', 'Sign up to stay updated on news, new product releases and discounts.'],
    ['Indirizzo email', 'Email address'],
    ['HARDRIP è un brand di gioielli che offre prodotti di qualità con una massima lucentezza e con il minimo prezzo garantito.', 'HARDRIP is a jewelry brand offering high-quality pieces with maximum shine at the best possible price.'],
    ['HARDRIP — Drip is never enough. Gioielli dal design luxury per chi vuole distinguersi davvero. Dalle collezioni iconiche alle creazioni personalizzate su richiesta, ogni pezzo nasce per unire stile, brillantezza e cura dei dettagli, offrendo la massima qualità al miglior prezzo.', 'HARDRIP — Drip is never enough. Luxury-designed jewelry for those who truly want to stand out. From iconic collections to custom creations on request, every piece combines style, brilliance and attention to detail, delivering maximum quality at the best price.'],
    ['Gioielli dal design luxury per chi vuole distinguersi davvero.', 'Luxury-designed jewelry for those who truly want to stand out.'],
    ['Dalle collezioni iconiche alle creazioni personalizzate su richiesta, ogni pezzo nasce per unire stile, brillantezza e cura dei dettagli, offrendo la massima qualità al miglior prezzo.', 'From iconic collections to custom creations on request, every piece combines style, brilliance and attention to detail, delivering maximum quality at the best price.'],

    // Collection copy found on EN storefront
    ['Possiamo realizzare qualsiasi cosa, per richiedere una custom da zero contattaci tramite Instagram /...', 'We can create virtually anything. To request a fully custom piece from scratch, contact us via Instagram /...'],
    ['Possiamo realizzare qualsiasi cosa, per richiedere una custom da zero contattaci tramite Instagram', 'We can create virtually anything. To request a fully custom piece from scratch, contact us via Instagram'],
    ['Cosa è la moissanite?', 'What is moissanite?'],
    ["Cos'è la Moissanite?", 'What is moissanite?'],
    ['La Moissanite è la pietra più simile al diamante in assoluto e passa al diamond tester.', 'Moissanite is the gemstone that most closely resembles a diamond and it passes the diamond tester.'],
    ['Scopri le ultime novità HARDRIP e i nuovi gioielli appena aggiunti al', 'Discover the latest HARDRIP releases and newly added jewelry'],

    // Product UI / badges
    ['Supera il Diamond Tester', 'Passes the Diamond Tester'],
    ['Resistente all’ossidazione', 'Tarnish resistant'],
    ["Resistente all'ossidazione", 'Tarnish resistant'],
    ['Imposte incluse.', 'Taxes included.'],
    ['Imposte incluse', 'Taxes included'],
    ['In offerta', 'Sale'],
    ['Esaurito', 'Sold out'],
    ['Colore', 'Color'],
    ['Lunghezza', 'Length'],
    ['Larghezza', 'Width'],
    ['Taglia', 'Size'],
    ['Quantità', 'Quantity'],
    ['Numero di caratteri', 'Number of characters'],
    ['Aggiungi al carrello', 'Add to cart'],
    ['Altre opzioni di pagamento', 'More payment options'],
    ['Visualizza dettagli completi', 'View full details'],
    ['Diminuisci quantità per', 'Decrease quantity for'],
    ['Aumenta quantità per', 'Increase quantity for'],
    ['Paga ora', 'Buy it now'],
    ['Formato USA', 'US sizing'],
    ['APRI TABELLA', 'OPEN CHART'],
    ['Apri tabella', 'Open chart'],
    ['Pagamento Sicuro Con', 'Secure Payment With'],
    ['Spesso acquistati insieme', 'Frequently bought together'],
    ['SPESSO ACQUISTATI INSIEME', 'FREQUENTLY BOUGHT TOGETHER'],
    ['A partire da', 'From'],
    ['Pagamento sicuro con', 'Secure Payment With'],
    ['Scopri altre recensioni', 'Load more reviews'],
    ['RECENSIONI REALI', 'REAL REVIEWS'],
    ['Recensioni reali', 'Real reviews'],
    ['COSA DICONO DI NOI', 'WHAT CUSTOMERS SAY'],
    ['Cosa dicono di noi', 'What customers say'],
    ['Esperienze reali di chi ha scelto HARDRIP.', 'Real experiences from customers who chose HARDRIP.'],
    ['Più convincenti', 'Most convincing'],
    ['Più recenti', 'Most recent'],
    ['Verificato', 'Verified'],
    ['Altro', 'More'],

    // Judge.me review form + current newly submitted review
    ['Scrivi una recensione', 'Write a review'],
    ['Come valuteresti questo prodotto?', 'How would you rate this product?'],
    ['Ci piacerebbe se condividessi qualcosa sulla tua esperienza.', 'We would love it if you shared a little about your experience.'],
    ['Pessimo', 'Poor'],
    ['Ottimo', 'Excellent'],
    ['Anonimo', 'Anonymous'],
    ['Credo che sia tra i migliori in Italia in questo', 'I think they are among the best in Italy in this field'],
    ['Credo che sia tra i migliori in Italia in questo settore,qualità ottima ho preso più di 5 prodotti in Totale e sono arrivati tutti senza un giorno di ritardo e per qualsiasi domanda ricevi una risposta in meno di due ore', 'I think they are among the best in Italy in this field. Excellent quality: I have bought more than 5 products in total and they all arrived without a single day of delay. For any question, you get a reply in under two hours.'],
    ['Credo che sia tra i migliori in Italia in questo settore, qualità ottima ho preso più di 5 prodotti in Totale e sono arrivati tutti senza un giorno di ritardo e per qualsiasi domanda ricevi una risposta in meno di due ore', 'I think they are among the best in Italy in this field. Excellent quality: I have bought more than 5 products in total and they all arrived without a single day of delay. For any question, you get a reply in under two hours.'],

    // Withdrawal UI labels
    ['INFORMAZIONI IMPORTANTI', 'IMPORTANT INFORMATION'],
    ['Informazioni importanti', 'Important information'],
    ['PRIMA DI INVIARE LA RICHIESTA', 'BEFORE SENDING THE REQUEST'],
    ['Prima di inviare la richiesta', 'Before sending the request'],
    ['Richiesta entro 14 giorni', 'Request within 14 days'],
    ['Condizioni del prodotto', 'Product conditions'],
    ['Condizioni prodotto', 'Product conditions'],
    ['Prodotti personalizzati', 'Custom products'],
    ['Spese di restituzione', 'Return shipping costs'],
    ['Attendi istruzioni prima della spedizione', 'Wait for instructions before shipping'],
    ['Leggi la politica di rimborso completa', 'Read the full refund policy'],
    ['Leggi la politica completa sui rimborsi', 'Read the full refund policy'],
    ['Nome e cognome', 'Full name'],
    ['Nome', 'First name'],
    ['Cognome', 'Last name'],
    ['Numero d’ordine', 'Order number'],
    ["Numero d'ordine", 'Order number'],
    ['Numero ordine', 'Order number'],
    ['Prodotto/i', 'Product(s)'],
    ['Motivo della richiesta', 'Reason for request'],
    ['Motivo del recesso', 'Reason for withdrawal'],
    ['Descrivi la richiesta', 'Describe your request'],
    ['Messaggio', 'Message'],
    ['Note', 'Notes'],
    ['Allega foto', 'Attach photos'],
    ['Allega file', 'Attach files'],
    ['Carica file', 'Upload files'],
    ['Seleziona un’opzione', 'Select an option'],
    ["Seleziona un'opzione", 'Select an option'],
    ['Campo obbligatorio', 'Required field'],
    ['Invia richiesta', 'Submit request'],
    ['Invia il modulo', 'Submit form'],
    ['Invia', 'Submit']
  ].sort((a, b) => b[0].length - a[0].length);

  // Safe fragments for titles/materials. These are deliberately limited to
  // recurring storefront terminology so arbitrary names/content are not mangled.
  const fragmentPairs = [
    ['Ciondolo con Foto Custom', 'Custom Photo Pendant'],
    ['Ciondolo Foto Custom', 'Custom Photo Pendant'],
    ['Ciondolo Custom', 'Custom Pendant'],
    ['Anello da donna', "Women's Ring"],
    ['Orecchini Punto Luce', 'Stud Earrings'],
    ['Acciaio Inossidabile', 'Stainless Steel'],
    ['Argento 925', '925 Silver'],
    ['Color Oro Rosa', 'Rose Gold Color'],
    ['Color Argento', 'Silver Color'],
    ['Color Oro', 'Gold Color'],
    ['Ciondolo', 'Pendant'],
    ['Pendente', 'Pendant'],
    ['Collana', 'Necklace'],
    ['Bracciale', 'Bracelet'],
    ['Orecchini', 'Earrings'],
    ['Orecchino', 'Earring'],
    ['Anello', 'Ring'],
    ['Zirconi', 'Zirconia'],
    ['nella Cup', 'in the Cup'],
    ['Spesso acquistati insieme', 'Frequently bought together'],
    ['Guida Alle Taglie', 'Size Guide'],
    ['Domande Frequenti', 'Frequently Asked Questions'],
    ['Traccia Il Tuo Ordine', 'Track Your Order'],
    ['Modulo Di Recesso', 'Right of Withdrawal Form'],
    ['Link rapidi', 'Quick links']
  ].sort((a, b) => b[0].length - a[0].length);

  const escapeRegex = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const looseRegex = (source) => {
    let text = String(source || '').trim();
    const hadTerminalPunctuation = /[.!?]$/.test(text);
    if (hadTerminalPunctuation) text = text.slice(0, -1);
    let pattern = escapeRegex(text)
      .replace(/[’']/g, "['’]")
      .replace(/\s+/g, '\\s+');
    if (hadTerminalPunctuation) pattern += '[.!?]?';
    return new RegExp(pattern, 'gi');
  };

  const compiledExactPairs = exactPairs.map(([it, en]) => [looseRegex(it), en]);
  const compiledFragmentPairs = fragmentPairs.map(([it, en]) => [
  /^zirconi$/i.test(it) ? /\bZirconi\b/gi : looseRegex(it),
  en
]);

  const replaceKnown = (value) => {
    let out = String(value ?? '');
    if (!out) return out;
    for (const [rx, en] of compiledExactPairs) out = out.replace(rx, en);
    for (const [rx, en] of compiledFragmentPairs) out = out.replace(rx, en);
    return out;
  };

  const skipElement = (el) => {
    if (!el) return true;
    if (el.closest('script,style,noscript,code,pre,svg,canvas')) return true;
    // Keep language names intact inside the language selector so "Italiano" remains recognisable.
    if (el.closest('[data-localization-form], localization-form, .localization-form, [name="locale_code"], [name="language_code"]')) return true;
    return false;
  };


  /* HARDRIP V20.154 - FREE DYNAMIC EN TRANSLATION ENGINE START
     Fallback for arbitrary future PUBLIC storefront copy/reviews that is still
     Italian after the deterministic dictionary. It never reads form values,
     emails or hidden/admin data. Results are cached locally per browser. */
  const autoTranslateState = {
    inflight: new Map(),
    queue: [],
    active: 0,
    max: 2,
    seen: new WeakMap()
  };
  const encoder = new TextEncoder();
  const autoCachePrefix = 'hardrip:en:auto:v20154:';
  const italianHints = /\b(?:che|sia|sono|siamo|quest[oaie]|prodotto|prodotti|gioiell[oi]|qualit[aà]|ottim[oaie]|molto|anche|arrivat[oi]|spedizion[ei]|acquist[oi]|comprat[oi]|cliente|clienti|recension[ei]|consegna|ordine|ordini|domanda|risposta|giorn[oi]|miglior[ei]|italia|settore|senza|della|delle|degli|nella|nelle|dopo|prima|entro|reso|restituzion[ei]|rimbor|richiesta|inviare|articolo|integr[oa]|utilizzo|confezione|personalizzat[oa]|misura|incis[oa]|difett[oi]|produzione|procedere|correttamente|tieni|disposizione|prova|acquisto|frequenti|condividi|scrivi|valuteresti|piacerebbe|esperienza|pessimo|ottimo|imposte|incluse|quantit[aà]|taglia|colore|lunghezza|pagamento|carrello|offerta|esaurito|argento|ciondolo|collana|bracciale|anello|orecchini)\b/i;
  const shouldAutoTranslateElement = (el) => {
    if (!el || skipElement(el)) return false;
    if (el.closest('input,textarea,select,option,[contenteditable="true"],[contenteditable="plaintext-only"]')) return false;
    if (el.closest('.jdgm-rev__author,.hrv-author,[class*="review-author"],[class*="author-name"],[itemprop="author"],[data-author]')) return false;
    if (el.closest('[aria-hidden="true"],[hidden]')) return false;
    return true;
  };
  const looksItalian = (value) => {
    const t = String(value || '').replace(/\s+/g,' ').trim();
    if (t.length < 10 || t.length > 5000) return false;
    if (!/[A-Za-zÀ-ÿ]/.test(t)) return false;
    const hits = (t.match(new RegExp(italianHints.source, 'gi')) || []).length;
    return hits >= 1 && (hits >= 2 || t.length < 95 || /[àèéìòù]/i.test(t));
  };
  const hashText = (s) => {
    let h=2166136261;
    for (let i=0;i<s.length;i++){ h^=s.charCodeAt(i); h=Math.imul(h,16777619); }
    return (h>>>0).toString(36);
  };
  const getCachedTranslation = (text) => {
    try { return localStorage.getItem(autoCachePrefix + hashText(text)) || ''; } catch (_) { return ''; }
  };
  const setCachedTranslation = (text, translated) => {
    try { localStorage.setItem(autoCachePrefix + hashText(text), translated); } catch (_) {}
  };
  const htmlDecode = (value) => {
    const ta=document.createElement('textarea'); ta.innerHTML=String(value||''); return ta.value;
  };
  const utf8Chunks = (text, maxBytes=430) => {
    const words=String(text||'').split(/(\s+)/); const out=[]; let buf='';
    const push=()=>{ if(buf){out.push(buf);buf='';} };
    for(const part of words){
      if(!part) continue;
      if(encoder.encode(buf+part).length<=maxBytes){buf+=part;continue;}
      push();
      if(encoder.encode(part).length<=maxBytes){buf=part;continue;}
      let piece='';
      for(const ch of part){ if(encoder.encode(piece+ch).length>maxBytes){out.push(piece);piece=ch;} else piece+=ch; }
      buf=piece;
    }
    push(); return out;
  };
  const translateChunk = async (chunk) => {
    const url='https://api.mymemory.translated.net/get?q='+encodeURIComponent(chunk)+'&langpair=it%7Cen&mt=1';
    const ctrl=new AbortController(); const timer=setTimeout(()=>ctrl.abort(),8000);
    try {
      const r=await fetch(url,{method:'GET',mode:'cors',credentials:'omit',cache:'force-cache',signal:ctrl.signal,referrerPolicy:'no-referrer'});
      if(!r.ok) throw new Error('translate '+r.status);
      const j=await r.json();
      const t=htmlDecode(j?.responseData?.translatedText||'').trim();
      return t && !/^QUERY LENGTH LIMIT/i.test(t) ? t : chunk;
    } finally { clearTimeout(timer); }
  };
  const translatePublicText = async (text) => {
    const cached=getCachedTranslation(text); if(cached) return cached;
    if(autoTranslateState.inflight.has(text)) return autoTranslateState.inflight.get(text);
    const p=(async()=>{
      try {
        const pieces=utf8Chunks(text); const translated=[];
        for(const piece of pieces) translated.push(await translateChunk(piece));
        const out=translated.join('').replace(/\s+([,.!?;:])/g,'$1').trim();
        if(out && out.toLowerCase()!==text.trim().toLowerCase()) setCachedTranslation(text,out);
        return out || text;
      } catch (_) { return text; }
      finally { autoTranslateState.inflight.delete(text); }
    })();
    autoTranslateState.inflight.set(text,p); return p;
  };
  const pumpAutoQueue = () => {
    while(autoTranslateState.active<autoTranslateState.max && autoTranslateState.queue.length){
      const job=autoTranslateState.queue.shift(); autoTranslateState.active++;
      translatePublicText(job.text).then((translated)=>{
        if(!job.node.isConnected) return;
        const now=String(job.node.nodeValue||'');
        if(now!==job.expected) return;
        if(translated && translated!==job.text){
          const prefix=(now.match(/^\s*/)||[''])[0], suffix=(now.match(/\s*$/)||[''])[0];
          job.node.nodeValue=prefix+translated+suffix;
          autoTranslateState.seen.set(job.node, job.node.nodeValue);
        }
      }).finally(()=>{autoTranslateState.active--;pumpAutoQueue();});
    }
  };
  const maybeAutoTranslate = (node) => {
    if(!(node instanceof Text)) return;
    const el=node.parentElement; if(!shouldAutoTranslateElement(el)) return;
    const raw=String(node.nodeValue||''); const trimmed=raw.trim();
    if(!looksItalian(trimmed)) return;
    if(autoTranslateState.seen.get(node)===raw) return;
    autoTranslateState.seen.set(node,raw);
    const cached=getCachedTranslation(trimmed);
    if(cached){
      const prefix=(raw.match(/^\s*/)||[''])[0], suffix=(raw.match(/\s*$/)||[''])[0];
      node.nodeValue=prefix+cached+suffix; autoTranslateState.seen.set(node,node.nodeValue); return;
    }
    autoTranslateState.queue.push({node,text:trimmed,expected:raw}); pumpAutoQueue();
  };
  /* HARDRIP V20.154 - FREE DYNAMIC EN TRANSLATION ENGINE END */

  const translateTextNode = (node) => {
    if (!(node instanceof Text)) return;
    const parent = node.parentElement;
    if (!parent || skipElement(parent)) return;
    const before = node.nodeValue || '';
    const after = replaceKnown(before);
    if (after !== before) node.nodeValue = after;
    maybeAutoTranslate(node);
  };

  const translateAttrs = (el) => {
    if (!(el instanceof Element) || skipElement(el)) return;
    for (const attr of ['placeholder', 'aria-label', 'title']) {
      const before = el.getAttribute(attr);
      if (!before) continue;
      const after = replaceKnown(before);
      if (after !== before) el.setAttribute(attr, after);
    }
    if ((el instanceof HTMLInputElement || el instanceof HTMLButtonElement) && el.value && el.type !== 'hidden') {
      const after = replaceKnown(el.value);
      if (after !== el.value) el.value = after;
    }
  };

  const translateSubtree = (root) => {
    if (!root) return;
    if (root instanceof Text) return translateTextNode(root);
    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;
    if (root instanceof Element) translateAttrs(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      if (n instanceof Text) translateTextNode(n);
      else translateAttrs(n);
    }
  };

  const queue = new Set();
  let scheduled = false;
  const flush = () => {
    scheduled = false;
    const items = Array.from(queue); queue.clear();
    for (const item of items) translateSubtree(item);
  };
  const enqueue = (node) => {
    if (!node) return;
    queue.add(node.nodeType === Node.TEXT_NODE ? node : node);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  };

  const start = () => {
    translateSubtree(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'characterData') enqueue(m.target);
        for (const n of m.addedNodes || []) enqueue(n);
      }
    });
    observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
    window.__HARDRIP_GLOBAL_ENGLISH_OBSERVER_V20150__ = observer;
    [60, 250, 800, 1800, 4000, 8000, 15000].forEach((ms) => setTimeout(() => translateSubtree(document.body), ms));
    document.addEventListener('shopify:section:load', (e) => enqueue(e.target));
    window.addEventListener('pageshow', () => { enqueue(document.body); setTimeout(() => enqueue(document.body), 300); }, { passive: true });
    document.addEventListener('shopify:section:select', (e) => enqueue(e.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
/* HARDRIP V20.150 - GLOBAL ENGLISH STRICT CLEANUP END */

/* HARDRIP V20.165 - WRITE REVIEW NATIVE CLOSE + BADGE COMPOSITOR + HOME RUNTIME LIVE SYNC + ORIGINAL MEDIA VIEWER START */
(() => {
  if (window.__HARDRIP_V20165__) return;
  window.__HARDRIP_V20165__ = true;
  const clean=(v)=>String(v||'').replace(/\s+/g,' ').trim();
  const lower=(v)=>clean(v).toLowerCase();
  const isProduct=/\/products\/[^/?#]+/i.test(location.pathname||'');
  const anon=/^(?:anonimo|anonymous|anonim[oa])$/i;
  const writeQuestion=/(?:come valuteresti questo prodotto\?|how would you rate this product\?)/i;

  const css=document.createElement('style'); css.id='hardrip-v20165-style';
  css.textContent=`
    /* NEW DROP desktop: forza il vero pannello V20.99 al centro geometrico
       senza cambiare opacity/filter/background/animazioni. */
    @media (min-width:990px){
      [data-hardrip-new-drop-host-v2099='true']>[data-hardrip-new-drop-original-v2089='true']{
        display:grid!important;place-items:center!important;justify-content:center!important;align-items:center!important;
        width:100%!important;max-width:none!important;margin:0!important;padding-left:0!important;padding-right:0!important;
      }
      [data-hardrip-new-drop-host-v2099='true']>[data-hardrip-new-drop-original-v2089='true'] .banner__box{
        justify-self:center!important;align-self:center!important;margin-left:auto!important;margin-right:auto!important;
      }
    }

    /* Spazio prodotto -> recensioni: niente vuoto da "fine pagina". */
    body.template-product [data-hardrip-review-section-v20155='true'],body[class*='template-product'] [data-hardrip-review-section-v20155='true']{
      margin-top:0!important;padding-top:0!important;
    }
    body.template-product [data-hardrip-review-host-v20155='true'],body[class*='template-product'] [data-hardrip-review-host-v20155='true']{
      margin-top:0!important;padding-top:0!important;min-height:0!important;
    }
    body.template-product #judgeme_product_reviews,body[class*='template-product'] #judgeme_product_reviews{
      margin-top:18px!important;padding-top:0!important;scroll-margin-top:110px!important;
    }
    body.template-product [data-hardrip-product-section-before-reviews-v20155='true'],body[class*='template-product'] [data-hardrip-product-section-before-reviews-v20155='true']{
      margin-bottom:0!important;padding-bottom:0!important;
    }
    body.template-product [data-hardrip-product-section-before-reviews-v20155='true'] [class*='section'][class*='padding'],
    body[class*='template-product'] [data-hardrip-product-section-before-reviews-v20155='true'] [class*='section'][class*='padding']{
      padding-bottom:22px!important;
    }
    body.template-product share-button,body.template-product .share-button,body[class*='template-product'] share-button,body[class*='template-product'] .share-button{
      margin-bottom:0!important;padding-bottom:0!important;
    }

    /* Foto prodotto nel flow "Scrivi una recensione". Non è una foto recensione e non è cliccabile. */
    [data-hardrip-write-review-product-v20155='true'],.hardrip-review-form-product-image-v20155{
      pointer-events:none!important;-webkit-user-select:none!important;user-select:none!important;-webkit-touch-callout:none!important;
    }
    .hardrip-review-form-product-image-v20155{
      display:flex!important;align-items:center!important;justify-content:center!important;
      width:min(76vw,340px)!important;height:min(48vw,220px)!important;max-height:220px!important;
      margin:10px auto 20px!important;overflow:hidden!important;border-radius:18px!important;background:#09090B!important;
    }
    .hardrip-review-form-product-image-v20155 img,
    img[data-hardrip-write-review-product-v20155='true']{
      display:block!important;max-width:min(76vw,340px)!important;max-height:220px!important;width:auto!important;height:auto!important;
      object-fit:contain!important;opacity:1!important;visibility:visible!important;filter:none!important;background:#09090B!important;
      pointer-events:none!important;-webkit-user-drag:none!important;-webkit-touch-callout:none!important;
    }

    /* HOME review photo: viewer HARDRIP usa direttamente il file migliore
       disponibile, senza thumbnail/srcset ricreati dal widget. */
    #hardrip-review-hq-viewer-v20165{
      position:fixed!important;inset:0!important;z-index:2147483647!important;
      display:flex!important;align-items:center!important;justify-content:center!important;
      width:100vw!important;height:100dvh!important;margin:0!important;padding:
        max(72px,calc(env(safe-area-inset-top) + 58px))
        max(20px,env(safe-area-inset-right))
        max(72px,calc(env(safe-area-inset-bottom) + 58px))
        max(20px,env(safe-area-inset-left))!important;
      box-sizing:border-box!important;background:#09090B!important;overscroll-behavior:contain!important;
      touch-action:manipulation!important;
    }
    #hardrip-review-hq-viewer-v20165[hidden]{display:none!important}
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-image-v20165{
      display:block!important;width:auto!important;height:auto!important;max-width:min(94vw,1280px)!important;
      max-height:calc(100dvh - max(144px,calc(env(safe-area-inset-top) + env(safe-area-inset-bottom) + 116px)))!important;
      object-fit:contain!important;border-radius:18px!important;background:#09090B!important;
      filter:none!important;transform:translate3d(0,0,0)!important;image-rendering:auto!important;
      -webkit-user-drag:none!important;
    }
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-close-v20165{
      position:fixed!important;top:max(22px,calc(env(safe-area-inset-top) + 14px))!important;
      right:max(20px,calc(env(safe-area-inset-right) + 14px))!important;
      width:52px!important;height:52px!important;display:grid!important;place-items:center!important;
      margin:0!important;padding:0!important;border:1px solid rgba(191,169,222,.42)!important;
      border-radius:50%!important;background:rgba(18,18,22,.94)!important;color:#F8F7FA!important;
      -webkit-text-fill-color:#F8F7FA!important;font:300 38px/1 Arial,sans-serif!important;
      box-shadow:0 8px 24px rgba(0,0,0,.36),inset 0 0 0 3px rgba(95,60,150,.12)!important;
      cursor:pointer!important;touch-action:manipulation!important;
    }
    body.hardrip-review-hq-viewer-open-v20165{overflow:hidden!important;overscroll-behavior:none!important}
  `;
  (document.head||document.documentElement).appendChild(css);


  /* HOME V20.179 · badge Verificata IG moderno + media viewer. */
  const homeUiCssV20179=document.createElement('style');
  homeUiCssV20179.id='hardrip-home-ui-v20179';
  homeUiCssV20179.textContent=`
    .hardrip-home-verified-label-v20179{
      display:inline-flex!important;align-items:center!important;justify-content:flex-start!important;
      gap:4px!important;height:20px!important;min-height:20px!important;line-height:20px!important;
      vertical-align:middle!important;align-self:center!important;margin:0 0 0 2px!important;padding:0!important;
      color:#BFA9DE!important;-webkit-text-fill-color:#BFA9DE!important;font-family:"Outfit",var(--font-body-family),sans-serif!important;font-size:14px!important;font-weight:600!important;
      white-space:nowrap!important;position:relative!important;top:auto!important;transform:none!important;
    }
    .hardrip-home-verified-icon-v20179{
      width:18px!important;height:18px!important;min-width:18px!important;flex:0 0 18px!important;
      display:inline-flex!important;align-items:center!important;justify-content:center!important;
      margin:0!important;padding:0!important;line-height:0!important;overflow:visible!important;
    }
    .hardrip-home-verified-icon-v20179 svg{
      display:block!important;width:18px!important;height:18px!important;overflow:visible!important;
    }
    .hardrip-home-verified-text-v20179{
      display:inline-flex!important;align-items:center!important;height:20px!important;line-height:20px!important;
      margin:0!important;padding:0!important;color:#BFA9DE!important;-webkit-text-fill-color:#BFA9DE!important;
      font-family:"Outfit",var(--font-body-family),sans-serif!important;font-size:14px!important;font-weight:600!important;line-height:20px!important;
    }
    [data-hardrip-old-verified-icon-v20179='true'],[data-hardrip-old-verified-icon-v20178='true'],
    [data-hardrip-old-verified-icon-v20177='true'],[data-hardrip-old-verified-icon-v20176='true']{
      display:none!important;width:0!important;height:0!important;min-width:0!important;min-height:0!important;
      margin:0!important;padding:0!important;overflow:hidden!important;
    }
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-nav-v20179{
      position:fixed!important;top:50%!important;z-index:3!important;transform:translateY(-50%)!important;
      width:48px!important;height:48px!important;display:grid!important;place-items:center!important;margin:0!important;padding:0!important;
      border:1px solid rgba(191,169,222,.42)!important;border-radius:50%!important;background:rgba(18,18,22,.92)!important;
      color:#F8F7FA!important;-webkit-text-fill-color:#F8F7FA!important;font:400 34px/1 Arial,sans-serif!important;
      box-shadow:0 8px 24px rgba(0,0,0,.32)!important;cursor:pointer!important;touch-action:manipulation!important;
    }
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-prev-v20179{left:max(14px,calc(env(safe-area-inset-left) + 8px))!important}
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-next-v20179{right:max(14px,calc(env(safe-area-inset-right) + 8px))!important}
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-nav-v20179[hidden]{display:none!important}
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-count-v20179{
      position:fixed!important;left:50%!important;bottom:max(22px,calc(env(safe-area-inset-bottom) + 14px))!important;
      transform:translateX(-50%)!important;z-index:3!important;display:flex!important;align-items:center!important;justify-content:center!important;
      min-width:58px!important;height:34px!important;padding:0 12px!important;border:1px solid rgba(191,169,222,.34)!important;
      border-radius:999px!important;background:rgba(18,18,22,.92)!important;color:#F8F7FA!important;-webkit-text-fill-color:#F8F7FA!important;
      font:600 14px/1 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;letter-spacing:.02em!important;
    }
    #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-count-v20179[hidden]{display:none!important}
    @media(max-width:749px){
      #hardrip-review-hq-viewer-v20165 .hardrip-review-hq-nav-v20179{width:44px!important;height:44px!important;font-size:30px!important}
    }
  `;
  (document.head||document.documentElement).appendChild(homeUiCssV20179);

  /* HOME: centra continuamente il pannello reale, anche dopo resize/fullscreen Chrome. */
  const centerNewDrop=()=>{
    if(innerWidth<990)return;
    for(const original of document.querySelectorAll("[data-hardrip-new-drop-host-v2099='true']>[data-hardrip-new-drop-original-v2089='true']")){
      original.style.setProperty('display','grid','important');
      original.style.setProperty('place-items','center','important');
      original.style.setProperty('justify-content','center','important');
      original.style.setProperty('align-items','center','important');
      original.style.setProperty('max-width','none','important');
      original.style.setProperty('width','100%','important');
      original.style.setProperty('padding-left','0','important');
      original.style.setProperty('padding-right','0','important');
      const box=original.querySelector('.banner__box');
      if(box){box.style.setProperty('justify-self','center','important');box.style.setProperty('align-self','center','important');box.style.setProperty('margin-left','auto','important');box.style.setProperty('margin-right','auto','important');}
    }
  };
  [0,80,250,700,1600,3500].forEach(ms=>setTimeout(centerNewDrop,ms));
  addEventListener('resize',()=>requestAnimationFrame(centerNewDrop),{passive:true});

  /* -------------------------------------------------------------------- */
  /* HOME V20.165 · LIVE RUNTIME SYNC + ORIGINAL MEDIA VIEWER.                   */
  /* Non dipende dalla posizione del Custom Liquid/section/snippet.       */
  /* Il widget locale resta il first paint; Judge.me live è autorevole.   */
  /* -------------------------------------------------------------------- */
  const normalizePath=(v)=>{let p=String(v||'/').split('?')[0].split('#')[0];if(!p.startsWith('/'))p='/'+p;return p.replace(/\/+$/,'')||'/'};
  const isHome=normalizePath(location.pathname)===normalizePath(window.Shopify?.routes?.root||'/');
  if(isHome&&!window.__HARDRIP_HOME_RUNTIME_SYNC_V20165__){
    window.__HARDRIP_HOME_RUNTIME_SYNC_V20165__=true;

    /* V20.182 · payload recensioni catturati già dall'HEAD. Il widget HOME
       può conoscere +N foto da una risposta JSON senza inserire tutte le URL
       nel DOM: manteniamo quelle risposte disponibili al viewer. */
    const networkReviewPayloadsV20182=()=>Array.isArray(window.__HARDRIP_REVIEW_NETWORK_PAYLOADS_V20182__)?window.__HARDRIP_REVIEW_NETWORK_PAYLOADS_V20182__:[];

    const norm=(v)=>lower(v).replace(/[“”„‟«»]/g,'"').replace(/[’‘`´]/g,"'").replace(/\s+/g,' ').trim();
    const productSel='a[href*="/products/"]';
    const homeRoot=()=>{
      const heading=[...document.querySelectorAll('h1,h2,h3,h4,[role="heading"]')].find(n=>{
        const t=lower(n.textContent);
        return t.includes('cosa dicono di noi')||t.includes('what customers say')||t.includes('what they say about us');
      });
      return heading?.closest('.shopify-section')||heading?.closest('section,[class*="section"]')||document;
    };
    /* V20.203 · HOME MOBILE: riduce SOLO il vuoto sopra Recensioni Reali.
       Non misura, non legge e non modifica in alcun modo card/media/slide/track/
       viewport GSC. Applica soltanto un marker al blocco recensioni; il CSS
       sposta quel blocco verso l'alto di 52px fissi. */
    const markHomeReviewGapV20203=()=>{
      if(innerWidth>749)return;
      const root=homeRoot();
      if(!(root instanceof Element)||root===document)return;
      root.setAttribute('data-hardrip-home-review-gap-v20203','true');
    };
    const reviewIdOf=(root)=>{
      if(!(root instanceof Element))return'';
      for(const n of [root,...root.querySelectorAll('[data-review-id],[data-id]')]){
        const id=clean(n.getAttribute?.('data-review-id')||n.dataset?.reviewId||n.getAttribute?.('data-id'));
        if(/^\d+$/.test(id))return id;
      }
      return'';
    };
    const textOf=(root,sels)=>{
      for(const s of sels){
        const e=root?.querySelector?.(s),t=clean(e?.innerText||e?.textContent);
        if(t)return t;
      }
      return'';
    };
    const cardMeta=(card)=>({
      id:reviewIdOf(card),
      author:textOf(card,['.hardrip-ai-review-card__author','.jdgm-rev__author','[class*="review-author"]','[class*="author-name"]']),
      title:textOf(card,['.hardrip-ai-review-card__title','.jdgm-rev__title','[class*="review-title"]']),
      body:textOf(card,['.hardrip-ai-review-card__body','.jdgm-rev__body','[class*="review-body"]']),
      product:card?.querySelector?.(productSel)||null
    });
    const reviewCards=()=>{
      const root=homeRoot(),out=new Set();
      root.querySelectorAll('.hardrip-ai-review-card,[data-hardrip-supplement-review="true"],[data-review-id]').forEach(n=>{
        if(n instanceof Element&&n.querySelector(productSel))out.add(n);
      });
      root.querySelectorAll(productSel).forEach(link=>{
        let n=link,best=null;
        for(let i=0;n&&n!==root&&i<10;i++,n=n.parentElement){
          if(!(n instanceof Element))continue;
          if(/★{3,}|⭐{3,}/.test(n.innerText||'')||n.querySelector('.jdgm-star,[class*="star"]'))best=n;
        }
        if(best)out.add(best);
      });
      return [...out];
    };

    /* V20.170 · HOME: stessa privacy nome impostata in Judge.me.
       Il dato completo resta intatto nel backend/live sync; cambiamo soltanto
       il testo VISIBILE delle card HOME in "Nome C.". Anonimo resta Anonimo. */
    const formatPublicAuthorV20170=(value)=>{
      const raw=clean(value);if(!raw||anon.test(raw))return raw;
      const parts=raw.split(/\s+/).filter(Boolean);if(parts.length<2)return raw;
      const first=parts[0];
      const second=parts[1].replace(/[^\p{L}\p{N}]/gu,'');
      if(!second)return first;
      const initial=second.charAt(0).toLocaleUpperCase(document.documentElement.lang||undefined);
      return `${first} ${initial}.`;
    };
    const homeAuthorSelector='.hardrip-ai-review-card__author,.jdgm-rev__author,[class*="review-author"],[class*="author-name"],[class*="reviewer-name"]';
    const formatHomeReviewAuthorsV20170=()=>{
      for(const card of reviewCards()){
        const el=card.querySelector(homeAuthorSelector);if(!el)continue;
        const full=clean(el.dataset.hardripFullAuthorV20170||el.textContent);
        if(!full)continue;
        if(!el.dataset.hardripFullAuthorV20170)el.dataset.hardripFullAuthorV20170=full;
        const visible=formatPublicAuthorV20170(full);
        if(visible&&clean(el.textContent)!==visible)el.textContent=visible;
      }
    };


    /* V20.179 · HOME: icona verificata nello stile IG moderno, viola HARDRIP.
       È un SVG vero: forma rosetta più morbida e check moderno centrato. */
    const verifiedSvgV20179=()=>{
      const ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg');
      svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
      const badge=document.createElementNS(ns,'path');
      /* 12 punte poco profonde + stroke dello stesso colore con round join = contorno IG più morbido. */
      badge.setAttribute('d','M12 1.8 14.25 3.45 17.02 2.95 18.18 5.53 20.82 6.55 20.45 9.35 22.2 11.55 20.45 13.75 20.82 16.55 18.18 17.57 17.02 20.15 14.25 19.65 12 21.3 9.75 19.65 6.98 20.15 5.82 17.57 3.18 16.55 3.55 13.75 1.8 11.55 3.55 9.35 3.18 6.55 5.82 5.53 6.98 2.95 9.75 3.45Z');
      badge.setAttribute('fill','#5F3C96');badge.setAttribute('stroke','#5F3C96');badge.setAttribute('stroke-width','1.15');badge.setAttribute('stroke-linejoin','round');
      const check=document.createElementNS(ns,'path');
      check.setAttribute('d','M7.55 11.85 10.35 14.65 16.55 8.45');check.setAttribute('fill','none');check.setAttribute('stroke','#F8F7FA');
      check.setAttribute('stroke-width','2.15');check.setAttribute('stroke-linecap','round');check.setAttribute('stroke-linejoin','round');
      svg.append(badge,check);return svg;
    };
    const fixHomeVerifiedBadgesV20179=()=>{
      for(const card of reviewCards()){
        const author=card.querySelector(homeAuthorSelector);if(!(author instanceof Element))continue;
        const candidates=[...card.querySelectorAll('span,div,p,strong,b,small')]
          .filter(el=>/^(?:verificata|verified)$/i.test(clean(el.textContent)));
        let label=card.querySelector('.hardrip-home-verified-label-v20179')||candidates.sort((a,b)=>a.querySelectorAll('*').length-b.querySelectorAll('*').length)[0];
        if(!(label instanceof Element))continue;
        const publicText=/^verified$/i.test(clean(label.textContent))?'Verified':'Verificata';
        label.className='hardrip-home-verified-label-v20179';label.setAttribute('data-hardrip-home-verified-label-v20179','true');
        const icon=document.createElement('span');icon.className='hardrip-home-verified-icon-v20179';icon.appendChild(verifiedSvgV20179());
        const txt=document.createElement('span');txt.className='hardrip-home-verified-text-v20179';txt.textContent=publicText;
        label.replaceChildren(icon,txt);
        /* Deve stare subito dopo il nome, sulla stessa riga, non centrata nel contenitore. */
        if(author.parentElement&&label.parentElement===author.parentElement&&author.nextElementSibling!==label)author.insertAdjacentElement('afterend',label);
        const parent=author.parentElement;
        if(parent){
          const sibs=[...parent.children],ai=sibs.indexOf(author),li=sibs.indexOf(label);
          for(const oldIcon of sibs){
            if(oldIcon===author||oldIcon===label)continue;
            const idx=sibs.indexOf(oldIcon);if(ai>=0&&li>=0&&(idx<Math.min(ai,li)-1||idx>Math.max(ai,li)+1))continue;
            const txt0=clean(oldIcon.textContent),sig=lower(`${oldIcon.className||''} ${oldIcon.getAttribute?.('aria-label')||''} ${oldIcon.getAttribute?.('title')||''}`);
            const looksIcon=!txt0&&(oldIcon.matches?.('svg,i,[aria-hidden="true"]')||!!oldIcon.querySelector?.('svg,i')||/icon|badge|verified|check/.test(sig));
            if(looksIcon)oldIcon.setAttribute('data-hardrip-old-verified-icon-v20179','true');
          }
          /* Se il parent è già flex, align-items center basta. Se non lo è non ne cambiamo la struttura. */
          if(['flex','inline-flex'].includes(getComputedStyle(parent).display))parent.style.setProperty('align-items','center','important');
        }
      }
    };

    const discoverJudgeCredentials=()=>{
      let shop=clean(window.Shopify?.shop||'');
      let token='';
      const attrNodes=document.querySelectorAll('[data-shop-domain],[data-api-token],[data-judge-me-api-token],[data-judgeme-api-token]');
      for(const n of attrNodes){
        shop=shop||clean(n.getAttribute('data-shop-domain')||n.dataset?.shopDomain);
        token=token||clean(n.getAttribute('data-api-token')||n.getAttribute('data-judge-me-api-token')||n.getAttribute('data-judgeme-api-token')||n.dataset?.apiToken);
        if(shop&&token)break;
      }
      if(!token||!shop){
        const scripts=[...document.scripts].map(s=>s.textContent||'');
        for(const t of scripts){
          if(!shop){
            const m=t.match(/(?:shop_domain|shopDomain)\s*[:=]\s*["']([^"']+\.myshopify\.com)["']/i);
            if(m)shop=m[1];
          }
          if(!token){
            const m=t.match(/(?:api_token|apiToken|judgeMeApiToken|judgemeApiToken)\s*[:=]\s*["']([^"']{8,})["']/i);
            if(m)token=m[1];
          }
          if(shop&&token)break;
        }
      }
      /* V20.182: Judge.me espone spesso token/shop in oggetti runtime, non
         necessariamente come attributi DOM. Ricerca limitata e sicura. */
      if(!token||!shop){
        const roots=[window.jdgm,window.Judgeme,window.JudgeMe,window.jdgmSettings,window.judgeme].filter(v=>v&&typeof v==='object');
        const seen=new WeakSet();
        const walk=(v,depth=0)=>{
          if(!v||typeof v!=='object'||depth>6||seen.has(v))return;seen.add(v);
          for(const [k,val] of Object.entries(v)){
            const key=String(k||'').toLowerCase();
            if(!shop&&typeof val==='string'&&/(?:shop_domain|shopdomain|shop)/.test(key)&&/\.myshopify\.com$/i.test(val.trim()))shop=val.trim();
            if(!token&&typeof val==='string'&&/(?:api_token|apitoken|token)/.test(key)&&val.trim().length>=8)token=val.trim();
            if(val&&typeof val==='object')walk(val,depth+1);
            if(shop&&token)return;
          }
        };
        for(const r of roots){walk(r);if(shop&&token)break}
      }
      return{shop,token};
    };

    const parseReviews=(json)=>{
      const direct=[json?.reviews,json?.data?.reviews,json?.response?.reviews,json?.payload?.reviews,json?.review?.reviews,json?.data?.data?.reviews];
      for(const x of direct)if(Array.isArray(x)&&x.length)return x;
      if(Array.isArray(json))return json;
      /* Widget API: alcune versioni annidano le review più in profondità. */
      const found=[],seen=new WeakSet();
      const walk=(v,depth=0)=>{
        if(v==null||depth>8)return;
        if(Array.isArray(v)){for(const x of v)walk(x,depth+1);return}
        if(typeof v!=='object')return;if(seen.has(v))return;seen.add(v);
        const body=clean(v.body||v.review_body||v.content||v.description||'');
        const author=clean(v?.reviewer?.name||v.reviewer_name||v.name||v.author||'');
        const hasMedia=!!(v.pictures||v.images||v.photos||v.media||v.review_pictures||v.attachments);
        if((body||author)&&(v.rating!=null||v.id!=null||v.review_id!=null||hasMedia))found.push(v);
        for(const val of Object.values(v))if(val&&typeof val==='object')walk(val,depth+1);
      };
      walk(json);return found;
    };
    const imageScore=(url,key='')=>{
      const u=lower(url),k=lower(key);let s=0;
      if(/original|full|master|source|raw|hires|high_res|high-res|xlarge/.test(k))s+=180;
      else if(/large|xl|2x|3x/.test(k))s+=110;
      else if(/url|src|image|picture|photo|media/.test(k))s+=45;
      if(/thumb|thumbnail|small|tiny|pico|icon/.test(k))s-=150;
      if(/medium/.test(k))s-=55;
      if(/original|full|master|source|raw|hires|high[-_]?res/.test(u))s+=80;
      if(/(?:thumb|thumbnail|small|tiny|pico|icon)(?:[._/-]|$)/.test(u))s-=120;
      if(/(?:medium)(?:[._/-]|$)/.test(u))s-=45;
      const dims=[...u.matchAll(/(?:_|-|\/|=)(\d{2,4})x(\d{0,4})(?=[._?&/-]|$)/g)];
      if(dims.length){const m=dims[dims.length-1],w=Number(m[1]||0),h=Number(m[2]||w);s+=Math.min(70,Math.log2(Math.max(1,w*h))*2)}
      if(/[?&](?:width|w)=\d+/i.test(url))s-=20;
      return s;
    };
    const queryFreeURL=(value)=>{
      value=clean(value);if(!value)return'';
      try{
        const u=new URL(value,location.href);
        for(const k of ['width','height','w','h','crop','fit','resize'])u.searchParams.delete(k);
        return u.href;
      }catch(_){return value}
    };
    const resizeFreeURL=(value)=>{
      value=queryFreeURL(value);if(!value)return'';
      try{
        const u=new URL(value,location.href);
        /* Shopify/Judge.me spesso codificano la misura nel filename.
           La versione senza suffisso è SOLO un candidato: verrà usata
           esclusivamente se il browser riesce davvero a caricarla. */
        u.pathname=u.pathname
          .replace(/_(?:pico|icon|thumb|thumbnail|small|compact|medium|large|grande|master)(?=\.[a-z0-9]{2,6}$)/i,'')
          .replace(/_(?:\d{2,4}x\d{0,4}|x\d{2,4})(?=\.[a-z0-9]{2,6}$)/i,'');
        return u.href;
      }catch(_){return value}
    };
    const addCandidate=(out,value,key='',bonus=0)=>{
      value=clean(value);if(!value||value.startsWith('data:')||!/^https?:|^\/\//i.test(value)&&!value.startsWith('/'))return;
      let abs=value;try{abs=new URL(value,location.href).href}catch(_){}
      const push=(u,b=0)=>{
        if(!u)return;const found=out.find(x=>x.url===u);
        const score=imageScore(u,key)+bonus+b;
        if(found){if(score>found.score)found.score=score;return}
        out.push({url:u,score,key});
      };
      push(abs);
      const free=resizeFreeURL(abs);if(free&&free!==abs)push(free,35);
    };
    const mediaCandidates=(x)=>{
      const out=[],seen=new WeakSet();
      const walk=(v,key='',depth=0)=>{
        if(v==null||depth>5)return;
        if(typeof v==='string'){addCandidate(out,v,key);return}
        if(Array.isArray(v)){v.forEach((item,i)=>walk(item,`${key}[${i}]`,depth+1));return}
        if(typeof v!=='object')return;
        if(seen.has(v))return;seen.add(v);
        for(const [k,val] of Object.entries(v)){
          if(typeof val==='string')addCandidate(out,val,`${key}.${k}`);
          else if(val&&typeof val==='object')walk(val,`${key}.${k}`,depth+1);
        }
      };
      walk(x,'media',0);
      return out.sort((a,b)=>b.score-a.score);
    };
    /* V20.179 · Judge.me può restituire le foto in pictures/images/media,
       ma anche in oggetti annidati (review_pictures, photos, attachments...).
       Estraiamo ogni media come elemento distinto, mantenendo le varianti URL
       della stessa foto come candidates e deduplicando solo la stessa immagine. */
    const reviewMediaItemsV20179=(r)=>{
      const out=[],seenObj=new WeakSet();
      const mediaKeyRx=/(?:picture|image|photo|media|attachment|asset|file)/i;
      const urlKeyRx=/(?:url|src|original|full|master|large|medium|small|thumb|image|picture|photo)/i;
      const push=v=>{if(v!=null)out.push(v)};
      const walk=(v,key='',depth=0)=>{
        if(v==null||depth>7)return;
        if(typeof v==='string'){
          if(mediaKeyRx.test(key)||/^https?:|^\/\//i.test(v)||v.startsWith('/'))push(v);
          return;
        }
        if(Array.isArray(v)){v.forEach((item,i)=>walk(item,`${key}[${i}]`,depth+1));return}
        if(typeof v!=='object')return;
        if(seenObj.has(v))return;seenObj.add(v);
        const entries=Object.entries(v);
        const urlEntries=entries.filter(([k,val])=>typeof val==='string'&&urlKeyRx.test(k)&&(/^(?:https?:)?\/\//i.test(val)||val.startsWith('/')));
        /* Un oggetto con uno o più URL è quasi sempre UNA picture con più
           risoluzioni: trattiamolo come singolo elemento. */
        if(urlEntries.length&&(mediaKeyRx.test(key)||entries.some(([k])=>urlKeyRx.test(k)))){push(v);return}
        for(const [k,val] of entries){
          if(mediaKeyRx.test(k)||mediaKeyRx.test(key)||Array.isArray(val))walk(val,`${key}.${k}`,depth+1);
        }
      };
      for(const [k,v] of Object.entries(r||{}))if(mediaKeyRx.test(k))walk(v,k,0);
      return out;
    };
    const canonicalMediaKeyV20179=(url)=>{
      let u=resizeFreeURL(clean(url));
      try{
        const x=new URL(u,location.href);
        x.hash='';
        for(const k of ['width','height','w','h','crop','fit','resize'])x.searchParams.delete(k);
        u=x.href;
      }catch(_){}
      return u.replace(/_(?:pico|icon|thumb|thumbnail|small|compact|medium|large|grande|master|\d{2,4}x\d{0,4}|x\d{2,4})(?=\.[a-z0-9]{2,6}(?:\?|$))/i,'');
    };
    const normalizeLiveReview=(r)=>{
      const product=r?.product||r?.product_info||r?.product_data||{};
      let handle=clean(product.handle||r?.product_handle||r?.handle||'');
      let url=clean(product.url||product.path||r?.product_url||'');
      if(!handle&&url){try{const m=/\/products\/([^/?#]+)/i.exec(new URL(url,location.href).pathname);if(m)handle=decodeURIComponent(m[1])}catch(_){}}
      const media=[];
      for(const item of reviewMediaItemsV20179(r)){
        const candidates=mediaCandidates(item);if(!candidates.length)continue;
        const key=canonicalMediaKeyV20179(candidates[0].url);
        const found=media.find(x=>x.key===key);
        if(found){
          for(const c of candidates)if(!found.candidates.some(x=>x.url===c.url))found.candidates.push(c);
          found.candidates.sort((a,b)=>b.score-a.score);found.url=found.candidates[0]?.url||found.url;
        }else media.push({url:candidates[0].url,key,candidates});
      }
      return{
        id:clean(r?.id||r?.review_id||r?.uuid||''),
        author:clean(r?.reviewer?.name||r?.reviewer_name||r?.name||r?.author||''),
        title:clean(r?.title||r?.headline||r?.review_title||''),
        body:clean(r?.body||r?.review_body||r?.content||r?.description||''),
        productTitle:clean(product.title||product.name||r?.product_title||r?.product_name||''),
        handle,url,media
      };
    };
    const capturedLiveReviewsV20182=()=>{
      const out=[],seen=new Set();
      for(const item of networkReviewPayloadsV20182()){
        const raw=String(item?.text||'');if(!raw||raw.length>6000000)continue;
        try{
          const parsed=JSON.parse(raw),arr=parseReviews(parsed);
          for(const r of arr){const nr=normalizeLiveReview(r),key=`${nr.id}|${norm(nr.author)}|${norm(nr.body).slice(0,80)}`;if((nr.id||nr.body)&&!seen.has(key)){seen.add(key);out.push(nr)}}
        }catch(_){}
      }
      return out;
    };
    let livePromise=null,liveAt=0;
    const fetchLiveReviews=async(force=false)=>{
      if(!force&&livePromise&&Date.now()-liveAt<45000)return livePromise;
      liveAt=Date.now();
      livePromise=(async()=>{
        const captured=capturedLiveReviewsV20182();
        const {shop,token}=discoverJudgeCredentials();
        if(!shop||!token)return captured;
        const out=[...captured],seen=new Set(out.map(r=>`${r.id}|${norm(r.author)}|${norm(r.body).slice(0,80)}`));
        for(let page=1;page<=4;page++){
          try{
            const u=new URL('https://judge.me/api/v1/widgets/all_reviews_page');
            u.searchParams.set('shop_domain',shop);u.searchParams.set('api_token',token);
            u.searchParams.set('page',String(page));u.searchParams.set('per_page','100');
            u.searchParams.set('_hardrip_live',String(Date.now()));
            const res=await fetch(u.href,{mode:'cors',credentials:'omit',cache:'no-store'});
            if(!res.ok)break;
            const json=await res.json(),arr=parseReviews(json);
            if(!arr.length)break;
            for(const r of arr){const nr=normalizeLiveReview(r),key=`${nr.id}|${norm(nr.author)}|${norm(nr.body).slice(0,80)}`;if(!seen.has(key)){seen.add(key);out.push(nr)}}
            if(arr.length<100)break;
          }catch(_){break}
        }
        return out;
      })();
      return livePromise;
    };
    const score=(cm,r)=>{
      if(cm.id&&r.id&&cm.id===r.id)return 1000;
      let s=0;
      if(cm.author&&r.author&&norm(cm.author)===norm(r.author))s+=8;
      if(cm.title&&r.title&&norm(cm.title)===norm(r.title))s+=9;
      if(cm.body&&r.body){
        const a=norm(cm.body),b=norm(r.body);
        if(a===b)s+=40;
        else if(a.length>24&&b.length>24&&(a.startsWith(b.slice(0,120))||b.startsWith(a.slice(0,120))))s+=30;
      }
      return s;
    };
    const bestLiveForCard=(card,reviews)=>{
      const cm=cardMeta(card);let best=null,bs=0;
      for(const r of reviews){const s=score(cm,r);if(s>bs){bs=s;best=r}}
      return bs>=30?best:null;
    };

    const originalize=(value)=>queryFreeURL(value);
    const decodeCache=new Map();
    const inspectImage=(url)=>{
      url=clean(url);if(!url)return Promise.resolve(null);
      if(decodeCache.has(url))return decodeCache.get(url);
      const p=new Promise(resolve=>{
        const im=new Image();im.decoding='async';im.loading='eager';try{im.fetchPriority='high'}catch(_){}
        im.onload=async()=>{try{await im.decode?.()}catch(_){}resolve({url,width:im.naturalWidth||0,height:im.naturalHeight||0,area:(im.naturalWidth||0)*(im.naturalHeight||0)})};
        im.onerror=()=>resolve(null);im.src=url;
      });
      decodeCache.set(url,p);return p;
    };
    const predecode=(url)=>inspectImage(originalize(clean(url))).then(Boolean);
    const bestDecodedURL=async(candidates)=>{
      const map=new Map();
      for(const c of candidates||[]){
        const obj=typeof c==='string'?{url:c,score:imageScore(c)}:c;
        if(!obj?.url)continue;
        const expanded=[];addCandidate(expanded,obj.url,obj.key||'',obj.score||0);
        for(const e of expanded){
          const old=map.get(e.url);if(!old||e.score>old.score)map.set(e.url,e);
        }
      }
      const ranked=[...map.values()].sort((a,b)=>b.score-a.score).slice(0,4);
      if(!ranked.length)return'';
      const checked=await Promise.all(ranked.map(async c=>({c,result:await inspectImage(c.url)})));
      const valid=checked.filter(x=>x.result&&x.result.width>40&&x.result.height>40);
      if(!valid.length)return ranked[0].url;
      valid.sort((a,b)=>{
        const ap=a.result.area,bp=b.result.area;
        if(bp!==ap)return bp-ap;
        return b.c.score-a.c.score;
      });
      return valid[0].result.url;
    };
    const domImageCandidates=(img)=>{
      const out=[];if(!(img instanceof HTMLImageElement))return out;
      const add=(v,key,bonus=0)=>addCandidate(out,v,key,bonus);
      add(img.dataset?.original,'data-original',160);
      add(img.dataset?.full,'data-full',150);
      add(img.dataset?.src,'data-src',35);
      add(img.getAttribute('data-lazy-src'),'data-lazy-src',35);
      add(img.currentSrc,'currentSrc',20);add(img.src,'src',10);
      for(const attr of ['srcset','data-srcset']){
        const ss=img.getAttribute(attr)||'';
        for(const part of ss.split(',')){
          const bits=part.trim().split(/\s+/);if(!bits[0])continue;
          const d=bits[1]||'',w=/^(\d+)w$/.exec(d),x=/^([\d.]+)x$/.exec(d);
          add(bits[0],attr,(w?Math.min(120,Number(w[1])/12):x?Number(x[1])*35:0));
        }
      }
      const a=img.closest('a[href]');if(a)add(a.href,'anchor-href',120);
      return out.sort((a,b)=>b.score-a.score);
    };
    const setHQOnImage=(img,url,applySrc=false)=>{
      if(!(img instanceof HTMLImageElement)||!url)return;
      url=originalize(url);img.removeAttribute('srcset');img.removeAttribute('data-srcset');
      img.setAttribute('data-full',url);img.setAttribute('data-original',url);img.dataset.hardripHq=url;
      img.decoding='async';img.loading='eager';try{img.fetchPriority='high'}catch(_){}
      if(applySrc&&img.src!==url)img.src=url;
    };
    const armViewerBeforePaint=(url)=>{
      if(!url)return()=>{};
      let active=true,quietFrames=0;
      const patch=()=>{
        if(!active)return;
        let visibleViewer=false;
        const shells=document.querySelectorAll('[role="dialog"],dialog,[class*="lightbox"],[class*="picture-modal"],[class*="gallery-popup"],[class*="photo-modal"],[class*="image-modal"],[class*="modal"]');
        for(const shell of shells){
          const cs=getComputedStyle(shell);if(cs.display==='none'||cs.visibility==='hidden'||!shell.getClientRects().length)continue;
          const imgs=[...shell.querySelectorAll('img')].sort((a,b)=>{const ar=a.getBoundingClientRect(),br=b.getBoundingClientRect();return(br.width*br.height)-(ar.width*ar.height)});
          const img=imgs[0];if(!img)continue;visibleViewer=true;setHQOnImage(img,url,true);
        }
        quietFrames=visibleViewer?0:quietFrames+1;
      };
      const mo=new MutationObserver(patch);mo.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','open','class','style']});
      patch();const stop=()=>{active=false;mo.disconnect()};setTimeout(stop,8000);return stop;
    };
    const ensureHQViewer=()=>{
      let v=document.getElementById('hardrip-review-hq-viewer-v20165');if(v)return v;
      v=document.createElement('div');v.id='hardrip-review-hq-viewer-v20165';v.hidden=true;
      v.setAttribute('role','dialog');v.setAttribute('aria-modal','true');v.setAttribute('aria-label','Foto recensione');
      const img=document.createElement('img');img.className='hardrip-review-hq-image-v20165';img.alt='Foto della recensione';img.decoding='async';img.loading='eager';
      const close=document.createElement('button');close.type='button';close.className='hardrip-review-hq-close-v20165';close.setAttribute('aria-label','Chiudi');close.textContent='×';
      const prev=document.createElement('button');prev.type='button';prev.className='hardrip-review-hq-nav-v20179 hardrip-review-hq-prev-v20179';prev.setAttribute('aria-label','Foto precedente');prev.textContent='‹';
      const next=document.createElement('button');next.type='button';next.className='hardrip-review-hq-nav-v20179 hardrip-review-hq-next-v20179';next.setAttribute('aria-label','Foto successiva');next.textContent='›';
      const count=document.createElement('div');count.className='hardrip-review-hq-count-v20179';count.setAttribute('aria-live','polite');
      const render=()=>{
        const urls=Array.isArray(v.__hardripUrlsV20179)?v.__hardripUrlsV20179:[];if(!urls.length)return;
        let i=Number(v.__hardripIndexV20179)||0;i=((i%urls.length)+urls.length)%urls.length;v.__hardripIndexV20179=i;
        img.removeAttribute('srcset');img.src=urls[i];
        const multi=urls.length>1;prev.hidden=!multi;next.hidden=!multi;count.hidden=!multi;count.textContent=multi?`${i+1} / ${urls.length}`:'';
      };
      const step=dir=>{const urls=v.__hardripUrlsV20179||[];if(urls.length<2)return;v.__hardripIndexV20179=(Number(v.__hardripIndexV20179)||0)+dir;render()};
      const shut=()=>{v.hidden=true;img.removeAttribute('src');v.__hardripUrlsV20179=[];document.body?.classList.remove('hardrip-review-hq-viewer-open-v20165')};
      close.addEventListener('click',shut);prev.addEventListener('click',e=>{e.stopPropagation();step(-1)});next.addEventListener('click',e=>{e.stopPropagation();step(1)});
      v.addEventListener('click',e=>{if(e.target===v)shut()});
      let sx=0,sy=0;v.addEventListener('touchstart',e=>{const t=e.touches?.[0];if(!t)return;sx=t.clientX;sy=t.clientY},{passive:true});
      v.addEventListener('touchend',e=>{const t=e.changedTouches?.[0];if(!t)return;const dx=t.clientX-sx,dy=t.clientY-sy;if(Math.abs(dx)>52&&Math.abs(dx)>Math.abs(dy)*1.2)step(dx<0?1:-1)},{passive:true});
      v.__hardripCloseV20165=shut;v.__hardripStepV20179=step;v.__hardripRenderV20179=render;v.append(img,close,prev,next,count);document.body.appendChild(v);return v;
    };
    const openHQViewer=(urls,index=0)=>{
      const list=(Array.isArray(urls)?urls:[urls]).map(originalize).filter(Boolean).filter((u,i,a)=>a.indexOf(u)===i);if(!list.length)return;
      const v=ensureHQViewer();v.__hardripUrlsV20179=list;v.__hardripIndexV20179=Math.max(0,Math.min(Number(index)||0,list.length-1));v.__hardripRenderV20179?.();v.hidden=false;
      document.body?.classList.add('hardrip-review-hq-viewer-open-v20165');requestAnimationFrame(()=>v.querySelector('.hardrip-review-hq-close-v20165')?.focus?.({preventScroll:true}));
    };
    document.addEventListener('keydown',e=>{
      const v=document.getElementById('hardrip-review-hq-viewer-v20165');if(!v||v.hidden)return;
      if(e.key==='Escape')v.__hardripCloseV20165?.();else if(e.key==='ArrowLeft')v.__hardripStepV20179?.(-1);else if(e.key==='ArrowRight')v.__hardripStepV20179?.(1);
    },false);
    let reviewsCache=[];
    const syncHome=async(force=false)=>{
      const cards=reviewCards();if(!cards.length)return;
      const reviews=await fetchLiveReviews(force);if(!reviews.length)return;
      reviewsCache=reviews;
      for(const card of cards){
        const live=bestLiveForCard(card,reviews);if(!live)continue;
        card.__hardripLiveReviewV20165=live;if(live.id)card.dataset.hardripLiveReviewId=live.id;
        const authorNode=card.querySelector(homeAuthorSelector);
        if(authorNode&&live.author&&!anon.test(clean(live.author))){
          authorNode.dataset.hardripFullAuthorV20170=clean(live.author);
          authorNode.textContent=formatPublicAuthorV20170(live.author);
        }
        const link=card.querySelector(productSel);
        if(link&&live.handle){
          const root=window.Shopify?.routes?.root||'/',href=`${root}products/${encodeURIComponent(live.handle)}`.replace(/\/+/g,'/');
          if(link.getAttribute('href')!==href)link.setAttribute('href',href);
          if(live.productTitle){const hadArrow=/→\s*$/.test(clean(link.textContent));link.textContent=live.productTitle+(hadArrow?' →':'')}
        }
        const imgs=[...card.querySelectorAll('img')].filter(img=>{const sig=lower(`${img.className||''} ${img.alt||''} ${img.parentElement?.className||''}`);return !/avatar|author|profile|logo|icon|star|badge|product/.test(sig)});
        const nativeMultiV20184=expectedGalleryCountV20179(card)>1;
        imgs.forEach((img,i)=>{const m=live.media[i]||live.media[0];if(!m)return;const hq=originalize(m.url);setHQOnImage(img,hq,false);const a=img.closest('a[href]');
          /* V20.184: su review +N NON riscriviamo l'href nativo della foto: alcuni
             viewer Judge.me usano proprio quel nodo per recuperare l'intero gruppo. */
          if(a&&hq&&!nativeMultiV20184)a.href=hq;if(i===0&&hq)predecode(hq)});
      }
    };

    const cardFromTarget=(t)=>{
      if(!(t instanceof Element))return null;let n=t;const root=homeRoot();
      for(let i=0;n&&n!==root&&i<10;i++,n=n.parentElement){
        if(!(n instanceof Element))continue;
        if(n.__hardripLiveReviewV20165||n.matches('.hardrip-ai-review-card,[data-hardrip-supplement-review="true"],[data-review-id]'))return n;
        if(n.querySelector?.(productSel)&&(/★{3,}|⭐{3,}/.test(n.innerText||'')||n.querySelector?.('.jdgm-star,[class*="star"]')))return n;
      }
      return null;
    };

    const isReviewMediaNodeV20179=(el)=>{
      if(!(el instanceof Element))return false;
      /* V20.182: una foto recensione può essere avvolta da un link /products/.
         Non la escludiamo più solo per questo: filtriamo invece avatar/icon/logo
         e, per le IMG visibili, richiediamo una dimensione coerente con una foto. */
      const sig=lower(`${el.className||''} ${el.getAttribute?.('alt')||''} ${el.parentElement?.className||''} ${el.getAttribute?.('aria-label')||''}`);
      if(/avatar|author|profile|logo|icon|star|verified|badge/.test(sig))return false;
      if(el instanceof HTMLImageElement){
        const r=el.getBoundingClientRect();
        if(r.width&&r.height&&Math.max(r.width,r.height)<54)return false;
      }
      return true;
    };
    const addGalleryURLV20179=(out,value)=>{
      value=clean(value);if(!value||value.startsWith('data:'))return;
      const pieces=[];
      if(/^(?:https?:)?\/\//i.test(value)||value.startsWith('/'))pieces.push(value);
      else{
        const re=/(?:https?:)?\/\/[^\s"'<>\\]+|\/\/[^\s"'<>\\]+/g;
        for(const m of value.matchAll(re))pieces.push(m[0]);
      }
      for(let u of pieces){
        try{u=new URL(u,location.href).href}catch(_){}
        if(!/\.(?:jpe?g|png|webp|avif|gif)(?:[?#]|$)|cdn\.shopify\.com|judge\.me|judgeme/i.test(u))continue;
        const key=canonicalMediaKeyV20179(u);if(!key)continue;
        if(!out.some(x=>x.key===key))out.push({url:originalize(u),key});
      }
    };
    const cardGalleryV20179=(card)=>{
      const out=[];
      for(const img of card.querySelectorAll('img')){
        if(!isReviewMediaNodeV20179(img))continue;
        const cs=domImageCandidates(img);for(const c of cs.slice(0,5))addGalleryURLV20179(out,c.url);
      }
      for(const el of card.querySelectorAll('*')){
        if(!isReviewMediaNodeV20179(el))continue;
        for(const a of el.attributes||[]){
          if(!/(?:src|href|url|image|photo|picture|media|full|original)/i.test(a.name))continue;
          addGalleryURLV20179(out,a.value);
        }
        const bg=getComputedStyle(el).backgroundImage;
        if(bg&&bg!=='none')addGalleryURLV20179(out,bg);
      }
      return out.map(x=>x.url);
    };
    const expectedGalleryCountV20179=(card)=>{
      const imgs=[...card.querySelectorAll('img')].filter(isReviewMediaNodeV20179);
      let plus=0;
      for(const el of card.querySelectorAll('span,div,button')){
        const m=/^\+(\d+)$/.exec(clean(el.textContent));if(m)plus=Math.max(plus,Number(m[1]));
      }
      return Math.max(imgs.length,imgs.length+plus);
    };
    const mergeGalleryV20179=(...groups)=>{
      const out=[];
      for(const g of groups.flat())addGalleryURLV20179(out,typeof g==='string'?g:(g?.url||''));
      return out.map(x=>x.url);
    };

    /* V20.179 · recupera media anche dai dati Judge.me già caricati nella pagina,
       dai JSON inline e da eventuali cloni/elementi nascosti della stessa review. */
    const latentGalleryCacheV20179=new WeakMap();
    const reviewFingerprintMatchV20182=(raw,parts)=>{
      raw=String(raw||'');if(!raw)return-1;
      for(const fp0 of parts||[]){const fp=clean(fp0);if(!fp||fp.length<4)continue;let at=raw.indexOf(fp);if(at<0)at=raw.toLowerCase().indexOf(fp.toLowerCase());if(at>=0)return at}
      return-1;
    };
    const urlsAroundFingerprintV20182=(raw,at,out)=>{
      if(at<0)return;const chunk=String(raw||'').slice(Math.max(0,at-80000),Math.min(String(raw||'').length,at+120000)).replace(/\\\//g,'/').replace(/\\u0026/gi,'&').replace(/&amp;/g,'&');
      const rx=/(?:https?:)?\\?\/\\?\/[^\s"'<>\\]+?(?:\.jpe?g|\.png|\.webp|\.avif)(?:\?[^\s"'<>\\]*)?/gi;
      for(const m of chunk.matchAll(rx))addGalleryURLV20179(out,m[0].replace(/\\/g,''));
    };
    /* V20.183 · HOME MULTI-FOTO: associazione ESATTA alla stessa recensione.
       Se la card mostra +N ma il DOM espone una sola IMG, leggiamo anche HTML/JSON
       già catturati dal widget e riconosciamo la review tramite ID, prima foto o testo.
       In questo modo le altre foto NON dipendono dalla loro presenza visibile nella card. */
    const galleryFromElementV20183=(rootEl)=>{
      const out=[];if(!(rootEl instanceof Element))return[];
      for(const img of rootEl.querySelectorAll('img')){
        const sig=lower(`${img.className||''} ${img.alt||''} ${img.parentElement?.className||''}`);
        if(/avatar|author|profile|logo|icon|star|verified|badge|product-image|product__media/.test(sig))continue;
        for(const c of domImageCandidates(img))addGalleryURLV20179(out,c.url);
      }
      for(const el of [rootEl,...rootEl.querySelectorAll('*')]){
        const sig=lower(`${el.className||''} ${el.getAttribute?.('aria-label')||''}`);
        if(/avatar|author|profile|logo|icon|star|verified|badge/.test(sig))continue;
        for(const a of el.attributes||[]){
          const v=a.value||'';
          if(/(?:src|srcset|href|url|image|photo|picture|media|full|original|large|zoom)/i.test(a.name))addGalleryURLV20179(out,v);
        }
        const inline=el.getAttribute?.('style')||'';if(/url\(/i.test(inline))addGalleryURLV20179(out,inline);
      }
      return out.map(x=>x.url);
    };
    const reviewNodeScoreV20183=(node,card,initialKey)=>{
      if(!(node instanceof Element))return-1;
      const cm=cardMeta(card),rid=reviewIdOf(card),sid=reviewIdOf(node);
      if(rid&&sid&&rid===sid)return 10000;
      const gallery=galleryFromElementV20183(node);
      if(initialKey&&gallery.some(u=>canonicalMediaKeyV20179(u)===initialKey))return 7000;
      const text=norm(node.textContent||''),body=norm(cm.body),author=norm(cm.author),product=cm.product;
      let score=0;
      if(body){const b80=body.slice(0,80),b45=body.slice(0,45);if(b80.length>18&&text.includes(b80))score+=1800;else if(b45.length>18&&text.includes(b45))score+=900}
      if(author&&text.includes(author.replace(/\s+[A-Z]\.\s*$/i,'')))score+=180;
      const href=clean(product?.getAttribute?.('href')||product?.href||'');
      if(href){try{const h=new URL(href,location.href).pathname;for(const a of node.querySelectorAll('a[href*="/products/"]')){if(new URL(a.href,location.href).pathname===h){score+=260;break}}}catch(_){}}
      if(gallery.length>1)score+=120;
      return score;
    };
    const galleryFromHtmlV20183=(html,card,initialKey)=>{
      html=String(html||'').trim();if(!html||html.length<40||!/[<>]/.test(html))return[];
      let doc;try{doc=new DOMParser().parseFromString(html,'text/html')}catch(_){return[]}
      const nodes=[...doc.querySelectorAll('.jdgm-rev,[data-review-id],[data-review-uuid],[class*="jdgm-rev"],[class*="review-card"],[class*="review-item"]')];
      let best=null,bestScore=-1;
      for(const node of nodes){const sc=reviewNodeScoreV20183(node,card,initialKey);if(sc>bestScore){bestScore=sc;best=node}}
      if(best&&bestScore>=600)return galleryFromElementV20183(best);
      /* Alcune risposte contengono la singola review senza wrapper classico. */
      const body=doc.body;if(body){const sc=reviewNodeScoreV20183(body,card,initialKey);if(sc>=6500)return galleryFromElementV20183(body)}
      return[];
    };
    const exactSameReviewGalleryV20183=(card,initial='')=>{
      if(!(card instanceof Element))return[];
      const out=[],initialKey=canonicalMediaKeyV20179(initial),expected=expectedGalleryCountV20179(card);
      const merge=(urls)=>{for(const u of urls||[])addGalleryURLV20179(out,u)};
      merge(cardGalleryV20179(card));
      /* A) sorgente DOM nascosta/clonata: la PRIMA FOTO è l'identificatore più
         affidabile quando il nome è anonimizzato o abbreviato. */
      let best=null,bestScore=-1;
      for(const source of document.querySelectorAll('.jdgm-rev,[data-review-id],[data-review-uuid],[class*="jdgm-rev"],[class*="review-card"],[class*="review-item"]')){
        if(source===card||card.contains(source))continue;
        const sc=reviewNodeScoreV20183(source,card,initialKey);if(sc>bestScore){bestScore=sc;best=source}
      }
      if(best&&bestScore>=600)merge(galleryFromElementV20183(best));
      if(expected>1&&out.length>=expected)return out.map(x=>x.url);
      /* B) payload fetch/XHR. Gestisce sia JSON strutturato sia HTML serializzato
         dentro proprietà JSON (caso comune del widget). */
      const inspectValue=(v,depth=0,seen=new WeakSet())=>{
        if(v==null||depth>9)return;
        if(typeof v==='string'){
          if(v.length>40&&/[<>]/.test(v)){merge(galleryFromHtmlV20183(v,card,initialKey));}
          return;
        }
        if(Array.isArray(v)){for(const x of v)inspectValue(x,depth+1,seen);return}
        if(typeof v!=='object'||seen.has(v))return;seen.add(v);
        const id=clean(v.id||v.review_id||v.uuid||''),rid=reviewIdOf(card),cm=cardMeta(card),body=norm(cm.body),vb=norm(v.body||v.review_body||v.content||v.description||'');
        const bodyMatch=!!(body&&vb&&(body===vb||body.startsWith(vb.slice(0,70))||vb.startsWith(body.slice(0,70))));
        if((rid&&id&&rid===id)||bodyMatch){for(const item of reviewMediaItemsV20179(v)){for(const c of mediaCandidates(item))addGalleryURLV20179(out,c.url)}}
        for(const val of Object.values(v))inspectValue(val,depth+1,seen);
      };
      for(const item of networkReviewPayloadsV20182()){
        const raw=String(item?.text||'');if(!raw)continue;
        if(/<[a-z][\s\S]*>/i.test(raw))merge(galleryFromHtmlV20183(raw,card,initialKey));
        try{inspectValue(JSON.parse(raw))}catch(_){}
        if(expected>1&&out.length>=expected)break;
      }
      return out.map(x=>x.url);
    };

    const latentGalleryV20179=(card)=>{
      if(!(card instanceof Element))return[];if(latentGalleryCacheV20179.has(card))return latentGalleryCacheV20179.get(card);
      const out=[];const cm=cardMeta(card),rid=reviewIdOf(card),author=norm(cm.author),body=norm(cm.body).slice(0,140);
      const pushAny=v=>{for(const item of reviewMediaItemsV20179(v||{})){for(const c of mediaCandidates(item).slice(0,12))addGalleryURLV20179(out,c.url)}};
      const fingerprints=[rid,clean(cm.body).slice(0,80),clean(cm.body).slice(0,45),clean(cm.author)].filter(x=>x&&x.length>3);
      /* 1) stesso review-id in DOM, inclusi nodi nascosti fuori dalla card. */
      if(rid){
        for(const el of document.querySelectorAll(`[data-review-id="${CSS.escape(rid)}"],[data-id="${CSS.escape(rid)}"]`)){
          for(const img of el.querySelectorAll('img'))if(isReviewMediaNodeV20179(img))for(const c of domImageCandidates(img))addGalleryURLV20179(out,c.url);
          for(const x of [el,...el.querySelectorAll('*')])for(const a of x.attributes||[])if(/(?:src|href|url|image|photo|picture|media|full|original|pictures|images)/i.test(a.name))addGalleryURLV20179(out,a.value);
        }
      }
      /* 2) oggetti runtime Judge.me/HARDRIP. */
      const roots=[window.jdgm?.data,window.jdgm?.reviews,window.Judgeme?.data,window.JudgeMe?.data].filter(Boolean),seen=new WeakSet();
      for(const k of Object.keys(window)){
        if(!/(?:judge|jdgm|review|hardrip)/i.test(k))continue;
        try{const v=window[k];if(v&&typeof v==='object'&&v!==window&&!(v instanceof Node))roots.push(v)}catch(_){}
      }
      const walk=(v,depth=0)=>{
        if(v==null||depth>10||typeof v!=='object')return;if(seen.has(v))return;seen.add(v);
        if(Array.isArray(v)){for(const x of v)walk(x,depth+1);return}
        const id=clean(v.id||v.review_id||v.uuid||''),a=norm(v?.reviewer?.name||v.reviewer_name||v.name||v.author||''),b=norm(v.body||v.review_body||v.content||v.description||'').slice(0,140);
        const bodyMatch=!!(body&&b&&(body===b||body.startsWith(b.slice(0,70))||b.startsWith(body.slice(0,70))));
        const authorLoose=!!(author&&a&&(author===a||a.startsWith(author.replace(/\s+[A-Z]\.$/i,' '))||author.startsWith(a.replace(/\s+[A-Z]\.$/i,' '))));
        const match=(rid&&id&&rid===id)||bodyMatch||(authorLoose&&bodyMatch);
        if(match)pushAny(v);
        for(const val of Object.values(v))if(val&&typeof val==='object')walk(val,depth+1);
      };
      for(const r of roots)walk(r);
      /* 3) JSON/script inline. */
      if(fingerprints.length){
        for(const s of document.querySelectorAll('script:not([src]),template')){
          const raw=s.textContent||s.innerHTML||'';if(raw.length<20)continue;
          const at=reviewFingerprintMatchV20182(raw,fingerprints);if(at<0)continue;
          try{const parsed=JSON.parse(raw);walk(parsed)}catch(_){}
          urlsAroundFingerprintV20182(raw,at,out);
        }
      }
      /* 4) Risposte fetch/XHR catturate dall'HEAD: questa è la sorgente più
         importante quando la card mostra +N ma nel DOM esiste una sola IMG. */
      for(const item of networkReviewPayloadsV20182()){
        const raw=String(item?.text||'');if(!raw)continue;const at=reviewFingerprintMatchV20182(raw,fingerprints);if(at<0)continue;
        try{const parsed=JSON.parse(raw);walk(parsed)}catch(_){}
        urlsAroundFingerprintV20182(raw,at,out);
      }
      /* 5) Recensione Judge.me sorgente anche se nascosta fuori dal widget HOME. */
      const sourceSel='.jdgm-rev,[data-review-id],[class*="jdgm-rev"],[class*="review-card"],[class*="review-item"]';
      for(const source of document.querySelectorAll(sourceSel)){
        if(source===card||card.contains(source))continue;
        const sm=cardMeta(source),sa=norm(sm.author),sb=norm(sm.body).slice(0,140),sid=reviewIdOf(source);
        const bodyMatch=!!(body&&sb&&(body===sb||body.startsWith(sb.slice(0,70))||sb.startsWith(body.slice(0,70))));
        const idMatch=!!(rid&&sid&&rid===sid),authorMatch=!!(author&&sa&&(author===sa||sa.startsWith(author.replace(/\s+[A-Z]\.$/i,' '))));
        if(!(idMatch||bodyMatch||(authorMatch&&bodyMatch)))continue;
        for(const img of source.querySelectorAll('img')){
          const sig=lower(`${img.className||''} ${img.alt||''} ${img.parentElement?.className||''}`);
          if(/avatar|author|profile|logo|icon|star|badge|product/.test(sig))continue;
          for(const c of domImageCandidates(img))addGalleryURLV20179(out,c.url);
        }
        for(const x of [source,...source.querySelectorAll('*')]){
          const sig=lower(`${x.className||''} ${x.getAttribute?.('aria-label')||''}`);if(/avatar|author|profile|logo|icon|star|badge|product/.test(sig))continue;
          for(const a of x.attributes||[]){const av=a.value||'';if(/(?:src|href|url|image|photo|picture|media|full|original|pictures|images)/i.test(a.name)||/(?:https?:)?\/\/[^\s"']+\.(?:jpe?g|png|webp|avif)/i.test(av))addGalleryURLV20179(out,av)}
        }
      }
      const result=out.map(x=>x.url),expected=expectedGalleryCountV20179(card);
      if(expected<=1||result.length>=expected)latentGalleryCacheV20179.set(card,result);
      return result;
    };

    let resolvingViewer=false;
    const moreReviewsCtaV20182=(target)=>{
      const ctl=target?.closest?.('button,a,summary,[role="button"],details');if(!ctl)return false;
      return /(?:scopri\s+altre\s+recensioni|mostra\s+altre\s+recensioni|show\s+more\s+reviews|more\s+reviews|load\s+more\s+reviews)/i.test(clean(ctl.textContent));
    };
    const mediaImageFromTargetV20181=(target,card,plusBadge=false)=>{
      let img=target?.closest?.('img')||null;if(img&&isReviewMediaNodeV20179(img))return img;
      if(!(card instanceof Element))return null;
      /* IMPORTANT: il fallback alla foto della card è ammesso SOLO per il badge
         +N. Così pulsanti/CTA come “Scopri altre recensioni” non possono mai
         essere scambiati per un click sulla foto. */
      if(!plusBadge)return null;
      const imgs=[...card.querySelectorAll('img')].filter(isReviewMediaNodeV20179);if(!imgs.length)return null;
      imgs.sort((a,b)=>{const ar=a.getBoundingClientRect(),br=b.getBoundingClientRect();return(br.width*br.height)-(ar.width*ar.height)});return imgs[0]||null;
    };
    const updateOpenViewerV20181=(urls,index=0)=>{
      const v=document.getElementById('hardrip-review-hq-viewer-v20165');if(!v||v.hidden)return false;
      const list=mergeGalleryV20179(urls);if(!list.length)return false;
      v.__hardripUrlsV20179=list;v.__hardripIndexV20179=Math.max(0,Math.min(Number(index)||0,list.length-1));v.__hardripRenderV20179?.();return true;
    };
    document.addEventListener('click',async(e)=>{
      if(resolvingViewer)return;
      const t=e.target instanceof Element?e.target:null;if(!t)return;
      const root=homeRoot();if(!root.contains(t))return;
      /* V20.182: il CTA “Scopri altre recensioni” resta SEMPRE al suo handler
         originale. Nessun viewer immagini può intercettarlo. */
      if(moreReviewsCtaV20182(t))return;
      const plusNode=t.closest?.('span,div,button');const plusMatch=/^\+(\d+)$/.exec(clean(plusNode?.textContent||t.textContent)),plusBadge=!!plusMatch;
      const directImg=t.closest?.('img');if(!plusBadge&&!(directImg&&isReviewMediaNodeV20179(directImg)))return;
      const card=cardFromTarget(t);if(!card)return;
      const expectedNative=expectedGalleryCountV20179(card);
      /* V20.184 · MULTI-FOTO: il +N del widget è già la prova che Judge.me
         possiede una gallery nativa più ricca del DOM visibile. In quel caso NON
         intercettiamo il click e NON apriamo il viewer HARDRIP con la sola prima
         URL: lasciamo intatti bubbling/default handler del widget, che conosce
         tutte le foto della stessa recensione e gestisce frecce/swipe.
         Il viewer HARDRIP resta fallback esclusivamente per card a singola foto. */
      if(expectedNative>1){
        card.setAttribute('data-hardrip-native-multigallery-v20184','true');
        return;
      }
      const img=mediaImageFromTargetV20181(t,card,plusBadge);if(!img)return;
      const initialCandidates=[...domImageCandidates(img)],initial=originalize(img.dataset?.hardripHq||initialCandidates[0]?.url||img.currentSrc||img.src||'');if(!initial)return;
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();openHQViewer([initial],0);resolvingViewer=true;
      try{
        let live=card.__hardripLiveReviewV20165;if(!live&&reviewsCache.length)live=bestLiveForCard(card,reviewsCache);
        const expected=expectedGalleryCountV20179(card),cardImgs=[...card.querySelectorAll('img')].filter(isReviewMediaNodeV20179),clickedIndex=Math.max(0,cardImgs.indexOf(img));
        const enrich=async(force=false)=>{
          if(!live||force){const fresh=await fetchLiveReviews(force);if(fresh.length){reviewsCache=fresh;const better=bestLiveForCard(card,fresh);if(better){live=better;card.__hardripLiveReviewV20165=better}}}
          latentGalleryCacheV20179.delete(card);
          const exactV20183=exactSameReviewGalleryV20183(card,initial);
          let gallery=mergeGalleryV20179([initial],(live?.media||[]).map(m=>m.url),exactV20183,cardGalleryV20179(card),latentGalleryV20179(card));
          for(const m of live?.media||[])gallery=mergeGalleryV20179(gallery,(m.candidates||[]).map(c=>c.url));
          if(gallery.length){const key=canonicalMediaKeyV20179(initial);let idx=gallery.findIndex(u=>canonicalMediaKeyV20179(u)===key);if(idx<0)idx=Math.min(clickedIndex,gallery.length-1);updateOpenViewerV20181(gallery,idx);gallery.forEach((u,i)=>{if(i!==idx)predecode(u)})}
          return gallery;
        };
        let gallery=await enrich(false);
        if(expected>gallery.length){
          gallery=await enrich(true);
          if(expected>gallery.length)for(const wait of [120,320,700,1300,2200]){await new Promise(r=>setTimeout(r,wait));if(document.getElementById('hardrip-review-hq-viewer-v20165')?.hidden)break;gallery=await enrich(false);if(gallery.length>=expected)break}
        }
      }catch(_){/* La prima foto resta aperta anche se una sorgente live fallisce. */}
      finally{resolvingViewer=false}
    },true);

    const start=()=>{
      markHomeReviewGapV20203();formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179();
      [0,120,400,1200,3000].forEach(ms=>setTimeout(()=>{markHomeReviewGapV20203();formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()},ms));
      syncHome(true);[1200,4000,12000].forEach(ms=>setTimeout(()=>{markHomeReviewGapV20203();syncHome(false);formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()},ms));
      const root=homeRoot();
      if(root&&root!==document){let timer=0;new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(()=>{markHomeReviewGapV20203();syncHome(false);formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()},120)}).observe(root,{subtree:true,childList:true})}
      addEventListener('pageshow',()=>{markHomeReviewGapV20203();syncHome(true);formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()},{passive:true});
      document.addEventListener('visibilitychange',()=>{if(!document.hidden){markHomeReviewGapV20203();syncHome(true);formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()}},{passive:true});
      setInterval(()=>{if(!document.hidden){markHomeReviewGapV20203();syncHome(true);formatHomeReviewAuthorsV20170();fixHomeVerifiedBadgesV20179()}},60000);
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  }

  if(!isProduct)return;

  /* HARDRIP_VERIFIED_SHOP_STATIC_BADGE_V20185
     The official Shopify “Verified by Shop” asset is verification UI, never
     customer review media. Judge.me can render it as IMG/SVG/text and can
     change wrappers, therefore block the interaction by semantic signature
     inside the product review widget before any gallery/lightbox handler. */
  const hardripVerifiedShopSignatureV20185=(node)=>{
    if(!(node instanceof Element))return false;
    const src=node instanceof HTMLImageElement
      ? `${node.currentSrc||''} ${node.getAttribute('src')||''} ${node.getAttribute('data-src')||''}`
      : '';
    const sig=lower(`${node.textContent||''} ${node.className||''} ${node.getAttribute?.('aria-label')||''} ${node.getAttribute?.('title')||''} ${node.getAttribute?.('alt')||''} ${src}`);
    return /verified\s+by\s+shop|verificat[oa]\s+(?:da|by)\s+shop/.test(sig);
  };
  const hardripVerifiedShopClickV20185=(event)=>{
    const path=typeof event?.composedPath==='function'?event.composedPath():[event?.target];
    for(const node of path){
      /* Stop before a review card or broad Judge.me widget container. Only the
         element actually tapped (or its small wrapper) may classify as the
         Verified-by-Shop badge; unrelated controls remain fully native. */
      if(node instanceof Element&&node.matches?.('.jm-review-item,.jdgm-rev,[data-review-id],#judgeme_product_reviews,.jdgm-review-widget,.jm-review-widget,[data-judgeme-product-reviews]'))break;
      if(hardripVerifiedShopSignatureV20185(node))return true;
      if(node instanceof Element){
        const nested=node.querySelector?.('img[alt*="Verified by Shop" i],img[title*="Verified by Shop" i],[aria-label*="Verified by Shop" i]');
        if(nested&&hardripVerifiedShopSignatureV20185(nested))return true;
      }
    }
    return false;
  };
  const hardripInsideProductReviewsV20185=(event)=>{
    const path=typeof event?.composedPath==='function'?event.composedPath():[event?.target];
    return path.some(node=>node instanceof Element&&(
      node.matches?.('#judgeme_product_reviews,.jdgm-review-widget,[data-judgeme-product-reviews],.jm-review-item,.jdgm-rev')||
      node.closest?.('#judgeme_product_reviews,.jdgm-review-widget,[data-judgeme-product-reviews]')
    ));
  };
  document.addEventListener('click',(event)=>{
    if(!hardripInsideProductReviewsV20185(event)||!hardripVerifiedShopClickV20185(event))return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  },true);

  /* V20.183 · PRODOTTO MOBILE: centro VERTICALE VISIVO ITERATIVO.
     Obiettivo: gap sopra e sotto la riga stelle/recensioni realmente uguale.
     Non aggiunge margini: corregge solo la posizione visiva del blocco rating. */
  const ratingLabelV20179=n=>{
    const it=(document.documentElement.lang||'it').toLowerCase().startsWith('it');
    return it?(n===1?'1 recensione':`${n} recensioni`):(n===1?'1 review':`${n} reviews`);
  };
  const visibleRectUnionV20182=(nodes)=>{
    const rs=[...nodes].filter(n=>n instanceof Element&&n.getClientRects().length).map(n=>n.getBoundingClientRect()).filter(r=>r.width>0&&r.height>0);
    if(!rs.length)return null;return{top:Math.min(...rs.map(r=>r.top)),bottom:Math.max(...rs.map(r=>r.bottom)),left:Math.min(...rs.map(r=>r.left)),right:Math.max(...rs.map(r=>r.right))};
  };
  const textVisualRectV20183=(root)=>{
    if(!(root instanceof Element)||!root.getClientRects().length)return null;
    const rects=[],walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    let n;while((n=walker.nextNode())){
      if(!clean(n.nodeValue))continue;
      try{const range=document.createRange();range.selectNodeContents(n);for(const r of range.getClientRects())if(r.width>0&&r.height>0)rects.push(r)}catch(_){}
    }
    if(!rects.length)return null;
    return{top:Math.min(...rects.map(r=>r.top)),bottom:Math.max(...rects.map(r=>r.bottom)),left:Math.min(...rects.map(r=>r.left)),right:Math.max(...rects.map(r=>r.right))};
  };
  const stabilizeProductRatingV20179=()=>{
    const info=document.querySelector('.product__info-container');if(!info)return;
    const outer=info.querySelector('.jdgm-preview-badge,.jdgm-prev-badge');if(!outer)return;
    let block=outer;while(block.parentElement&&block.parentElement!==info)block=block.parentElement;if(block.parentElement!==info)return;
    block.removeAttribute('data-hardrip-rating-after-badges-v20179');block.removeAttribute('data-hardrip-rating-after-badges-v20180');block.removeAttribute('data-hardrip-rating-after-badges-v20181');block.removeAttribute('data-hardrip-rating-after-badges-v20182');
    const badge=outer.matches('.jdgm-prev-badge')?outer:(outer.querySelector('.jdgm-prev-badge')||outer);
    let textEl=badge.querySelector('.jdgm-prev-badge__text,.jdgm-preview-badge__text')||outer.querySelector('.jdgm-prev-badge__text,.jdgm-preview-badge__text');
    const text=clean(textEl?.textContent),match=text.match(/(\d+)\s*(?:recension(?:e|i)|review(?:s)?)/i);let attrs=NaN;
    for(const k of ['data-number-of-reviews','data-review-count','data-reviews-count']){const raw=badge.getAttribute(k)??outer.getAttribute(k);if(raw!==null&&raw!==''&&Number.isFinite(Number(raw))){attrs=Number(raw);break}}
    const seed=Number(window.__HARDRIP_PRODUCT_REVIEW_COUNT_V20179__);const n=match?Number(match[1]):(Number.isFinite(attrs)?attrs:(Number.isFinite(seed)?seed:NaN));
    if(Number.isFinite(n)&&n<=0){block.setAttribute('data-hardrip-rating-empty-v20179','true');return}block.removeAttribute('data-hardrip-rating-empty-v20179');
    if(Number.isFinite(n)){
      if(!textEl){textEl=document.createElement('span');textEl.className='jdgm-prev-badge__text';badge.appendChild(textEl)}
      if(!clean(textEl.textContent))textEl.textContent=ratingLabelV20179(n);block.setAttribute('data-hardrip-rating-ready-v20179','true');
    }
    if(innerWidth>749){block.style.removeProperty('transform');delete block.dataset.hardripRatingShiftV20182;delete block.dataset.hardripRatingShiftV20183;return}
    let feature=null,p=block.previousElementSibling,steps=0;while(p&&steps++<8){if(p.matches?.('.hardrip-feature-badges')||p.querySelector?.('.hardrip-feature-badges')){feature=p.matches('.hardrip-feature-badges')?p:p.querySelector('.hardrip-feature-badges');break}p=p.previousElementSibling}
    if(!feature||!feature.getClientRects().length){block.style.removeProperty('transform');delete block.dataset.hardripRatingShiftV20182;delete block.dataset.hardripRatingShiftV20183;return}
    const price=[...info.children].find(el=>el.id?.startsWith('price-')&&el.getClientRects().length)||info.querySelector('[id^="price-"]');if(!price||!price.getClientRects().length)return;
    /* Fondo reale delle pill visibili. Evitiamo wrapper con padding/margini. */
    let pills=[...feature.querySelectorAll('.hardrip-feature-badge,[class*="hardrip-feature-badge"]')].filter(el=>el.getClientRects().length&&getComputedStyle(el).display!=='none');
    if(!pills.length)pills=[...feature.children].filter(el=>el.getClientRects().length&&getComputedStyle(el).display!=='none');
    const fr=visibleRectUnionV20182(pills)||feature.getBoundingClientRect();
    /* Top reale dei caratteri del prezzo/compare-at, non del wrapper Liquid. */
    const priceSelectors=['.price__sale .price-item--sale','.price__sale .price-item--regular','.price__regular .price-item--regular','.price-item--sale','.price-item--regular','.price-item'];
    const priceNodes=[];for(const sel of priceSelectors)for(const el of price.querySelectorAll(sel))if(clean(el.textContent)&&el.getClientRects().length&&!priceNodes.includes(el))priceNodes.push(el);
    const textRects=priceNodes.map(textVisualRectV20183).filter(Boolean);
    const pr=textRects.length?{top:Math.min(...textRects.map(r=>r.top)),bottom:Math.max(...textRects.map(r=>r.bottom))}:(visibleRectUnionV20182(priceNodes)||price.getBoundingClientRect());
    /* Correzione relativa alla posizione VISIVA corrente. Così non dipende da un
       vecchio dataset shift e converge anche dopo font, prezzo/variante o resize. */
    const rr=badge.getBoundingClientRect(),targetCenter=(fr.bottom+pr.top)/2,currentCenter=(rr.top+rr.bottom)/2;
    const error=targetCenter-currentCenter;
    let current=Number(block.dataset.hardripRatingShiftV20183||block.dataset.hardripRatingShiftV20182||0);if(!Number.isFinite(current))current=0;
    let next=current+error;next=Math.max(-56,Math.min(56,next));if(Math.abs(next)<.1)next=0;
    delete block.dataset.hardripRatingShiftV20182;block.dataset.hardripRatingShiftV20183=String(next);block.setAttribute('data-hardrip-rating-after-badges-v20183','true');
    block.style.setProperty('transform',`translate3d(0,${next.toFixed(2)}px,0)`,'important');
    /* Secondo pass al frame successivo: porta l'errore residuo sotto il pixel. */
    if(Math.abs(error)>.45&&!block.__hardripRatingSecondPassV20183){block.__hardripRatingSecondPassV20183=true;requestAnimationFrame(()=>{block.__hardripRatingSecondPassV20183=false;stabilizeProductRatingV20179()})}
  };
  let productRatingFrameV20182=0;
  const queueProductRatingV20179=()=>{cancelAnimationFrame(productRatingFrameV20182);productRatingFrameV20182=requestAnimationFrame(stabilizeProductRatingV20179)};
  [0,16,32,64,100,180,320,600,1000,1800,3000].forEach(ms=>setTimeout(queueProductRatingV20179,ms));
  const productRatingObserverV20179=new MutationObserver(queueProductRatingV20179);
  productRatingObserverV20179.observe(document.querySelector('.product__info-container')||document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews','data-review-count','data-reviews-count','class','style']});
  addEventListener('resize',queueProductRatingV20179,{passive:true});document.fonts?.ready?.then(queueProductRatingV20179).catch?.(()=>{});

  /* ------------------------------------------------------------------
     V20.172 · FAQ PIXEL-CENTER · DIAMOND RESTORE SOLO CSS
     ------------------------------------------------------------------ */
  const faqCenterJobsV20172=new WeakMap();
  const clampFaqShiftV20172=n=>Math.max(-28,Math.min(28,n));
  const centerFaqModalV20172=(modal)=>{
    if(!(modal instanceof Element))return;
    const content=modal.querySelector('.product-popup-modal__content');
    const info=modal.querySelector('.product-popup-modal__content-info');
    if(!content||!info)return;
    const signature=lower(`${content.getAttribute('aria-label')||''} ${info.textContent||''}`);
    const search=info.querySelector('.Avada-Faq_Search');
    if(!search&&!/domande frequenti|frequently asked questions/.test(signature))return;
    modal.setAttribute('data-hardrip-faq-modal-v20172','true');
    content.setAttribute('data-hardrip-faq-content-v20172','true');
    info.setAttribute('data-hardrip-faq-info-v20172','true');
    let inner=search;
    if(search){
      while(inner.parentElement&&inner.parentElement!==info&&info.contains(inner.parentElement))inner=inner.parentElement;
      if(inner&&inner!==info)inner.setAttribute('data-hardrip-faq-inner-v20172','true');
    }
    if(!inner||inner===info||!content.getClientRects().length||!search?.getClientRects().length)return;
    inner.style.setProperty('--hardrip-faq-center-shift-v20172','0px');
    const old=faqCenterJobsV20172.get(modal);if(old)cancelAnimationFrame(old);
    const raf=requestAnimationFrame(()=>{
      const cr=content.getBoundingClientRect();
      const ar=search.getBoundingClientRect();
      if(!cr.width||!ar.width)return;
      const popupCenter=(cr.left+cr.right)/2;
      const visualCenter=(ar.left+ar.right)/2;
      const dx=clampFaqShiftV20172(popupCenter-visualCenter);
      inner.style.setProperty('--hardrip-faq-center-shift-v20172',`${Math.abs(dx)<.5?0:dx.toFixed(2)}px`);
    });
    faqCenterJobsV20172.set(modal,raf);
  };
  const centerAllFaqV20172=()=>document.querySelectorAll('.product-popup-modal').forEach(centerFaqModalV20172);
  [0,40,120,260,600,1200].forEach(ms=>setTimeout(centerAllFaqV20172,ms));
  const faqObserverV20172=new MutationObserver(mutations=>{
    if(mutations.some(m=>m.addedNodes?.length))requestAnimationFrame(centerAllFaqV20172);
  });
  faqObserverV20172.observe(document.documentElement,{subtree:true,childList:true});
  document.addEventListener('click',e=>{
    const opener=e.target?.closest?.('modal-opener,.product-popup-modal__opener,[aria-haspopup=\"dialog\"]');
    if(!opener)return;
    const txt=lower(opener.textContent||'');
    if(!/domande frequenti|frequently asked questions/.test(txt))return;
    [0,40,120,260,520].forEach(ms=>setTimeout(centerAllFaqV20172,ms));
  },true);
  addEventListener('resize',()=>requestAnimationFrame(centerAllFaqV20172),{passive:true});
  addEventListener('orientationchange',()=>setTimeout(centerAllFaqV20172,120),{passive:true});

  /* Diamond Tester V20.172: nessun sequencer/timer/class JS. La timeline torna
     interamente quella nativa del badge; il CSS sostituisce soltanto i keyframe
     costosi con equivalenti transform/opacity mantenendo cadenza e delay originali. */

  /* V20.168 · GAP CONDIVIDI -> RECENSIONI + FLOW DESKTOP SAFE.
     MOBILE: avvicina davvero il blocco recensioni a Condividi con una correzione
     misurata e LIMITATA. DESKTOP: mai margin negativi dinamici; questo elimina
     il raro stato in cui recensioni/complementary products potevano salire e
     fluttuare sopra la gallery durante hydration/scroll. */
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const reviewWidget=()=>document.querySelector(
    '#judgeme_product_reviews,.jdgm-review-widget,[data-judgeme-product-reviews]'
  );
  const clearReviewGapShift=(reviewSection,host,widget)=>{
    reviewSection?.style.removeProperty('--hardrip-review-gap-shift-v20156');
    reviewSection?.style.setProperty('margin-top','0px','important');
    reviewSection?.style.setProperty('padding-top','0px','important');
    host?.style.setProperty('margin-top','0px','important');
    host?.style.setProperty('padding-top','0px','important');
    widget?.style.setProperty('margin-top','0px','important');
    widget?.style.setProperty('padding-top','0px','important');
  };
  const tightenReviewGap=()=>{
    const widget=reviewWidget();
    if(!widget||!widget.getClientRects().length)return;
    const reviewSection=widget.closest('.shopify-section')||widget.closest('section')||widget.parentElement;
    const host=widget.closest('.shopify-app-block')||widget.parentElement;
    host?.setAttribute('data-hardrip-review-host-v20155','true');
    reviewSection?.setAttribute('data-hardrip-review-section-v20155','true');
    if(!reviewSection)return;
    clearReviewGapShift(reviewSection,host,widget);
    widget.style.setProperty('scroll-margin-top','110px','important');

    /* Desktop: il flusso normale è l'unica sorgente di verità. */
    if(innerWidth>=750)return;

    const share=document.querySelector('share-button,.share-button');
    if(!share||!share.getClientRects().length)return;
    const shareRect=share.getBoundingClientRect();
    const reviewTop=widget.getBoundingClientRect().top;
    const gap=reviewTop-shareRect.bottom;
    const target=24;
    /* Il cap impedisce qualunque salto patologico se un'app sta ancora
       idratando. Per il gap reale mostrato su mobile è più che sufficiente. */
    const excess=clamp(gap-target,0,260);
    if(excess>1){
      reviewSection.style.setProperty('--hardrip-review-gap-shift-v20156',`${excess}px`);
      reviewSection.style.setProperty('margin-top',`${-excess}px`,'important');
    }
  };
  [0,90,250,700,1600,3500,7000].forEach(ms=>setTimeout(tightenReviewGap,ms));

  /* Badge V20.165: percorso compositor completo preparato nel <head>, zero TreeWalker/characterData e zero pause/restart. */

  /* V20.169 · IDENTITÀ RECENSIONI UNIVERSALE.
     Non ricostruiamo nomi privati e non sostituiamo Anonimo/Anonymous.
     Rendiamo leggibili i nodi autore già pubblici e, se il cerchio avatar è
     davvero vuoto, aggiungiamo soltanto l'iniziale derivata dallo stesso nome
     pubblico presente nella card. */
  const reviewIdentitySelector='.jdgm-rev,[data-review-id],[class*="review-card"],[class*="review-item"]';
  const authorIdentitySelector='.jdgm-rev__author,[class*="reviewer-name"],[class*="reviewer_name"],[class*="author-name"],[class*="author_name"],[data-testid*="reviewer" i],[data-testid*="author" i]';
  const avatarIdentitySelector='.jdgm-rev__icon,[class*="avatar"],[class*="initial"],[data-testid*="avatar" i],[data-testid*="initial" i]';
  const forceIdentityText=(el)=>{
    if(!(el instanceof Element))return;
    for(const [k,v] of [
      ['color','#F8F7FA'],['-webkit-text-fill-color','#F8F7FA'],['opacity','1'],
      ['visibility','visible'],['filter','none'],['-webkit-filter','none'],
      ['mix-blend-mode','normal'],['text-indent','0']
    ])el.style.setProperty(k,v,'important');
  };
  const pseudoHasVisibleContent=(el,pseudo)=>{
    try{
      const c=clean(getComputedStyle(el,pseudo).content).replace(/^['"]|['"]$/g,'');
      return!!c&&!/^(?:none|normal)$/i.test(c);
    }catch(_){return false}
  };
  const publicAuthorValue=(root,author)=>{
    const direct=clean(author?.textContent);
    if(direct)return direct;
    for(const node of [author,root].filter(Boolean)){
      for(const a of ['aria-label','data-reviewer-name','data-author-name','data-display-name']){
        const v=clean(node.getAttribute?.(a));
        if(v&&v.length<90)return v;
      }
    }
    return'';
  };
  const recoverAuthors=()=>{
    if(!isProduct)return;
    const widget=document.querySelector('#judgeme_product_reviews,.jdgm-review-widget,[data-judgeme-product-reviews]');
    if(!widget)return;
    for(const root of widget.querySelectorAll(reviewIdentitySelector)){
      const author=root.querySelector(authorIdentitySelector);
      const authorName=publicAuthorValue(root,author);
      if(author){
        forceIdentityText(author);
        for(const child of author.querySelectorAll('*'))forceIdentityText(child);
        if(clean(author.textContent)&&!author.hasAttribute('hidden')){
          try{
            const acs=getComputedStyle(author);
            if(acs.display==='none')author.style.setProperty('display','inline','important');
            if((parseFloat(acs.fontSize)||0)<8)author.style.setProperty('font-size','15px','important');
            if((parseFloat(acs.lineHeight)||0)<10)author.style.setProperty('line-height','1.35','important');
          }catch(_){}
        }
        const authorWrap=author.closest('.jdgm-rev__author-wrapper,[class*="author-wrapper"],[class*="reviewer-wrapper"]');
        if(authorWrap&&root.contains(authorWrap)&&!authorWrap.hasAttribute('hidden')){
          forceIdentityText(authorWrap);
          try{if(getComputedStyle(authorWrap).display==='none')authorWrap.style.setProperty('display','inline-flex','important')}catch(_){}
        }
      }
      for(const avatar of root.querySelectorAll(avatarIdentitySelector)){
        forceIdentityText(avatar);
        for(const child of avatar.querySelectorAll('*'))forceIdentityText(child);
        const fallback=avatar.querySelector(':scope > .hardrip-review-initial-v20169');
        const nativeText=clean([...avatar.childNodes].filter(n=>n!==fallback).map(n=>n.textContent||'').join(' '));
        const hasNativeVisual=!!avatar.querySelector('img,picture,svg,canvas');
        const hasPseudo=pseudoHasVisibleContent(avatar,'::before')||pseudoHasVisibleContent(avatar,'::after');
        if(nativeText||hasNativeVisual||hasPseudo||!authorName||anon.test(authorName)){
          fallback?.remove();
          continue;
        }
        const initial=clean(authorName).charAt(0).toLocaleUpperCase(document.documentElement.lang||undefined);
        if(!initial)continue;
        const node=fallback||document.createElement('span');
        node.className='hardrip-review-initial-v20169';
        node.textContent=initial;
        if(!fallback)avatar.appendChild(node);
      }
    }
  };
  [0,120,350,800,1600,3500,7000].forEach(ms=>setTimeout(recoverAuthors,ms));

  /* --- WRITE A REVIEW V20.165: container Judge.me full-screen + immagine prodotto deterministica. --- */
  const normalizeProductImageURL=(value)=>{
    value=clean(value);if(!value||value.startsWith('data:'))return'';
    try{
      const u=new URL(value,location.href);
      /* Nel form bastano 900 px reali: evita thumbnail piccole senza scaricare
         inutilmente originali enormi. */
      if(/\/cdn\/shop\/files\//i.test(u.pathname)){
        u.searchParams.delete('height');u.searchParams.delete('crop');
        u.searchParams.set('width','900');
      }
      return u.href;
    }catch(_){return value}
  };
  const productImageCandidates=()=>{
    const arr=[];
    const add=v=>{v=normalizeProductImageURL(v);if(v&&!arr.includes(v))arr.push(v)};
    /* Prima l'immagine realmente attiva nella gallery/variante selezionata. */
    for(const img of document.querySelectorAll(
      'media-gallery .product__media-item.is-active img,media-gallery [data-media-id].is-active img,'+
      '.product__media-item.is-active img,.product-media-container.is-active img,'+
      'slider-component .slider__slide[aria-hidden="false"] img'
    ))add(img.currentSrc||img.src||img.dataset?.src);
    /* Poi le altre vere immagini prodotto del template. */
    for(const img of document.querySelectorAll('media-gallery img,.product__media img,.product-media-container img,[data-media-id] img')){
      const sig=lower(`${img.className||''} ${img.alt||''} ${img.closest?.('[class]')?.className||''}`);
      if(/logo|icon|badge|payment|review|avatar/.test(sig))continue;
      add(img.currentSrc||img.src||img.dataset?.src);
    }
    add(document.querySelector('meta[property="og:image"]')?.content);
    add(document.querySelector('meta[name="twitter:image"]')?.content);
    for(const sc of document.querySelectorAll('script[type="application/ld+json"]'))try{
      const j=JSON.parse(sc.textContent||'null');
      const walk=x=>{
        if(!x)return;if(Array.isArray(x))return x.forEach(walk);if(typeof x!=='object')return;
        if(String(x['@type']||'').toLowerCase()==='product'){
          const im=x.image;
          if(Array.isArray(im))im.forEach(v=>add(typeof v==='string'?v:v?.url||v?.contentUrl));
          else add(typeof im==='string'?im:im?.url||im?.contentUrl);
        }
        Object.values(x).forEach(walk);
      };
      walk(j);
    }catch(_){ }
    return arr;
  };

  const visibleHeading=()=>{
    const modal=document.querySelector('.jdgm-write-review-modal');
    const scope=modal&&modal.getClientRects().length?modal:document;
    return[...scope.querySelectorAll('h1,h2,h3,h4,p,div,span')].find(n=>{
      if(!writeQuestion.test(clean(n.textContent)))return false;
      const cs=getComputedStyle(n);
      return cs.display!=='none'&&cs.visibility!=='hidden'&&Number(cs.opacity)!==0&&n.getClientRects().length;
    });
  };
  const ancestors=(el)=>{const a=[];for(let n=el;n&&n!==document.body;n=n.parentElement)a.push(n);return a;};
  const shellVisible=(shell)=>{
    if(!(shell instanceof Element)||!shell.isConnected)return false;
    const cs=getComputedStyle(shell),r=shell.getBoundingClientRect();
    return cs.display!=='none'&&cs.visibility!=='hidden'&&Number(cs.opacity)!==0&&r.width>1&&r.height>1;
  };
  const findFormContext=()=>{
    const heading=visibleHeading();if(!heading)return null;
    const chain=ancestors(heading);
    /* Classe Judge.me nota: niente euristiche quando è disponibile. */
    let shell=heading.closest('.jdgm-write-review-modal');
    if(!shell)shell=chain.find(n=>n.matches?.('dialog[open],[role="dialog"],[aria-modal="true"]'))||null;
    if(!shell)shell=chain.find(n=>{
      const sig=lower(`${n.id||''} ${n.className||''}`),r=n.getBoundingClientRect();
      return /jdgm|judge/.test(sig)&&/modal|popup|review-form|write-review|drawer|overlay/.test(sig)&&r.width>=innerWidth*.62&&r.height>=innerHeight*.48;
    })||null;
    if(!shell||shell===document.body||!shell.contains(heading)||!shellVisible(shell))return null;
    const container=heading.closest('.jdgm-write-review-modal__container')||shell.querySelector('.jdgm-write-review-modal__container')||shell;
    const content=heading.closest('.jdgm-write-review-modal__content')||shell.querySelector('.jdgm-write-review-modal__content')||container;
    const panel=heading.closest('.jdgm-write-review-modal__review-form,.jdgm-write-review-modal__section')||content;
    return{heading,shell,container,content,panel};
  };

  const preloadFirstProductImage=async()=>{
    for(const u of productImageCandidates())try{
      const im=new Image();im.decoding='async';im.src=u;
      await(im.decode?.()||new Promise((res,rej)=>{im.onload=res;im.onerror=rej}));
      if(im.naturalWidth>=160&&im.naturalHeight>=120)return u;
    }catch(_){ }
    return'';
  };
  let cachedProductImagePromise=null;
  const productImageUrl=()=>cachedProductImagePromise||(cachedProductImagePromise=preloadFirstProductImage());

  const clearLegacyReviewImageArtifacts=()=>{
    document.querySelectorAll('.hardrip-review-form-product-image-v20155,[data-hardrip-write-review-owned-v20158="true"],[data-hardrip-write-review-owned-v20165="true"]').forEach(n=>n.remove());
    document.querySelectorAll('[data-hardrip-write-review-product-v20155],[data-hardrip-write-review-native-v20158],[data-hardrip-write-review-native-v20165],[data-hardrip-write-review-shell-v20155],[data-hardrip-write-review-shell-v20165]').forEach(n=>{
      n.removeAttribute('data-hardrip-write-review-product-v20155');
      n.removeAttribute('data-hardrip-write-review-native-v20158');
      n.removeAttribute('data-hardrip-write-review-native-v20165');
      n.removeAttribute('data-hardrip-write-review-shell-v20155');
      n.removeAttribute('data-hardrip-write-review-shell-v20165');
      n.style?.removeProperty('--hardrip-write-review-fix-x-v20165');
      n.style?.removeProperty('--hardrip-write-review-fix-y-v20165');
    });
    document.querySelectorAll('[data-hardrip-write-review-containing-block-v20165="true"]').forEach(n=>n.removeAttribute('data-hardrip-write-review-containing-block-v20165'));
    document.body?.classList.remove('hardrip-write-review-open-v20158','hardrip-write-review-open-v20165');
  };

  const configureProductImage=(img,src)=>{
    if(!(img instanceof HTMLImageElement)||!src)return false;
    img.setAttribute('data-hardrip-write-review-native-v20165','true');
    img.setAttribute('data-hardrip-write-review-product-v20155','true');
    img.draggable=false;img.loading='eager';img.decoding='async';
    try{img.fetchPriority='high'}catch(_){ }
    img.removeAttribute('srcset');img.removeAttribute('sizes');img.removeAttribute('data-srcset');
    if(img.getAttribute('src')!==src)img.src=src;
    return true;
  };
  const ensureFormProductImage=async(ctx)=>{
    if(!ctx?.shell||!ctx.shell.isConnected)return false;
    const src=await productImageUrl();if(!src||!ctx.shell.isConnected)return false;

    /* Se Judge.me espone il suo slot prodotto ufficiale usiamo SOLO quello. */
    const nativeBox=ctx.shell.querySelector('.jdgm-write-review-modal__product-image');
    const nativeImg=nativeBox?.querySelector('img');
    if(nativeBox&&nativeImg){
      nativeBox.setAttribute('data-hardrip-write-review-product-v20155','true');
      return configureProductImage(nativeImg,src);
    }

    /* Altrimenti creiamo sempre il nostro slot deterministico. Non scegliamo più
       la prima <img> grande del modal: era ciò che su alcuni prodotti prendeva
       elementi sbagliati e impediva la foto vera (es. Reverse Spike). */
    let box=ctx.shell.querySelector('[data-hardrip-write-review-owned-v20165="true"]');
    let im=box?.querySelector('img');
    if(!box){
      box=document.createElement('div');
      box.className='hardrip-review-form-product-image-v20155';
      box.setAttribute('data-hardrip-write-review-owned-v20165','true');
      box.setAttribute('data-hardrip-write-review-product-v20155','true');
      im=document.createElement('img');im.alt='';box.appendChild(im);

      const title=ctx.shell.querySelector('.jdgm-write-review-modal__product-title');
      const rating=ctx.shell.querySelector('[role="radiogroup"],button[aria-label*="star" i],button[aria-label*="stella" i]');
      const ratingSection=rating?.closest('.jdgm-write-review-modal__section,section,fieldset');
      if(title?.parentElement&&ctx.shell.contains(title.parentElement))title.parentElement.insertBefore(box,title);
      else if(ratingSection?.parentElement&&ctx.shell.contains(ratingSection.parentElement))ratingSection.parentElement.insertBefore(box,ratingSection);
      else{
        const intro=ctx.heading.closest('.jdgm-write-review-modal__section')||ctx.heading.parentElement;
        if(intro?.parentElement&&ctx.shell.contains(intro.parentElement))intro.insertAdjacentElement('afterend',box);
        else ctx.content?.appendChild(box);
      }
    }
    return configureProductImage(im,src)&&box.isConnected;
  };

  let writeSession=null;
  const createsFixedContainingBlock=(node)=>{
    if(!(node instanceof Element))return false;
    const cs=getComputedStyle(node),backdrop=cs.backdropFilter||cs.webkitBackdropFilter||'none';
    return cs.transform!=='none'||cs.perspective!=='none'||cs.filter!=='none'||backdrop!=='none'||
      (cs.contain&&cs.contain!=='none')||cs.contentVisibility==='auto'||/transform|filter|perspective|contain/.test(cs.willChange||'');
  };
  const neutralizeContainingAncestors=(from)=>{
    let node=from instanceof Element?from.parentElement:null;
    while(node&&node!==document.body&&node!==document.documentElement){
      if(createsFixedContainingBlock(node))node.setAttribute('data-hardrip-write-review-containing-block-v20165','true');
      node=node.parentElement;
    }
  };
  const neutralizeKnownJudgeWrappers=()=>{
    /* Prima che Judge.me inserisca il modal marchiamo anche i wrapper app già
       presenti. Così un eventuale transform/contain del widget non può creare
       un containing block nel primissimo frame del nuovo __container. */
    document.querySelectorAll('[class*="jdgm"],[id*="jdgm"],[class*="judge"],[id*="judge"]').forEach(node=>{
      if(node instanceof Element&&createsFixedContainingBlock(node))
        node.setAttribute('data-hardrip-write-review-containing-block-v20165','true');
    });
  };
  const correctShellViewport=(ctx)=>{
    const shell=ctx?.shell,container=ctx?.container;
    if(!(shell instanceof Element)||!shell.isConnected)return;
    shell.setAttribute('data-hardrip-write-review-shell-v20165','true');
    if(container instanceof Element)container.setAttribute('data-hardrip-write-review-shell-v20165','true');
    /* CSS V20.165 fissa sia modal sia __container. Qui togliamo solamente
       eventuali inline transform residui dell'app. */
    for(const n of [shell,container].filter(Boolean)){
      n.style.setProperty('top','0px','important');n.style.setProperty('margin-top','0px','important');
      n.style.setProperty('transform','none','important');n.style.setProperty('translate','none','important');
    }
  };
  const resetFormScroll=(ctx)=>{
    if(!ctx?.shell)return;
    neutralizeContainingAncestors(ctx.shell);
    document.body?.classList.add('hardrip-write-review-open-v20165');
    correctShellViewport(ctx);
    const scrollNodes=new Set([ctx.shell,ctx.container,ctx.content,ctx.panel,...ancestors(ctx.heading)]);
    for(const n of scrollNodes){
      if(!(n instanceof Element)||!ctx.shell.contains(n)&&n!==ctx.shell)continue;
      try{n.scrollTop=0;n.scrollLeft=0}catch(_){ }
    }
    if(writeSession&&Number.isFinite(writeSession.savedY)&&Math.abs(window.scrollY-writeSession.savedY)>2){
      window.scrollTo(0,writeSession.savedY);
    }
    requestAnimationFrame(()=>{
      if(!ctx.shell?.isConnected)return;
      correctShellViewport(ctx);
      for(const n of [ctx.container,ctx.content,ctx.panel].filter(Boolean))try{n.scrollTop=0}catch(_){ }
    });
  };
  const stabilizeWriteForm=(savedY)=>{
    const ctx=findFormContext();if(!ctx)return false;
    if(!writeSession)writeSession={ctx:null,savedY,closing:false};
    writeSession.ctx=ctx;resetFormScroll(ctx);ensureFormProductImage(ctx);return true;
  };
  const isWriteControl=t=>{
    const e=t instanceof Element?t.closest('button,a,[role="button"]'):null;
    return!!e&&/^(?:scrivi una recensione|write a review)$/i.test(clean(e.textContent||e.getAttribute('aria-label')));
  };
  const isCloseControl=t=>{
    const e=t instanceof Element?t.closest('button,a,[role="button"]'):null;if(!e)return false;
    const label=lower(e.getAttribute('aria-label')||e.getAttribute('title')||e.textContent||'');
    return label==='×'||label==='x'||/^(?:close|chiudi)$/.test(label)||/close|chiudi/.test(label);
  };
  const finishWriteSession=()=>{
    const y=writeSession?.savedY;
    writeSession=null;
    clearLegacyReviewImageArtifacts();
    if(Number.isFinite(y)&&Math.abs(window.scrollY-y)>4)requestAnimationFrame(()=>window.scrollTo(0,y));
    [40,140,350].forEach(ms=>setTimeout(clearLegacyReviewImageArtifacts,ms));
  };
  const waitForNativeClose=()=>{
    if(!writeSession||writeSession.closing)return;
    writeSession.closing=true;
    const started=performance.now();
    const poll=()=>{
      if(!writeSession)return;
      const shell=writeSession.ctx?.shell;
      const ctx=findFormContext();
      const nativeClosed=!shellVisible(shell)||!ctx||ctx.shell!==shell;
      if(nativeClosed){finishWriteSession();return;}
      if(performance.now()-started>1100){
        /* Non forziamo mai la chiusura: restituiamo il controllo a Judge.me. */
        writeSession.closing=false;
        return;
      }
      requestAnimationFrame(poll);
    };
    requestAnimationFrame(poll);
  };

  clearLegacyReviewImageArtifacts();

  /* Apertura: possiamo prepararci al pointerdown, ma non fermiamo mai Judge.me. */
  document.addEventListener('pointerdown',e=>{
    if(!isWriteControl(e.target))return;
    const y=window.scrollY;
    clearLegacyReviewImageArtifacts();
    writeSession={ctx:null,savedY:y,closing:false};
    /* Capture pointerdown avviene prima del click Judge.me: neutralizziamo
       subito eventuali transform/contain del widget così il PRIMO paint del
       modal nasce già dal top del viewport, senza frame intermedio più in basso. */
    neutralizeContainingAncestors(e.target instanceof Element?e.target:null);
    neutralizeKnownJudgeWrappers();
    document.body?.classList.add('hardrip-write-review-open-v20165');
    cachedProductImagePromise=null;productImageUrl();
    [0,8,16,32,56,90,140,220,360,560,850,1250,1800].forEach(ms=>setTimeout(()=>{
      if(writeSession&&!writeSession.closing)stabilizeWriteForm(y);
    },ms));
    setTimeout(()=>{
      if(writeSession&&!writeSession.ctx&&!visibleHeading())finishWriteSession();
    },2400);
  },{capture:true,passive:true});

  /* Chiusura: niente pointerdown. Il click nativo Judge.me avviene per primo;
     noi osserviamo soltanto il risultato e ripuliamo dopo. */
  document.addEventListener('click',e=>{
    if(!writeSession||!isCloseControl(e.target))return;
    const shell=writeSession.ctx?.shell||findFormContext()?.shell;
    if(shell&&shell.contains(e.target))setTimeout(waitForNativeClose,0);
  },false);
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'&&writeSession)setTimeout(waitForNativeClose,0);
  },false);
  addEventListener('pagehide',clearLegacyReviewImageArtifacts,{passive:true});

  /* Le recensioni possono arrivare dopo AJAX: aggiorna solo i fix leggeri. */
  let scheduled=false;
  const refresh=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;tightenReviewGap();recoverAuthors();centerNewDrop();stabilizeProductRatingV20179();if(writeSession&&!writeSession.closing){const ctx=findFormContext();if(ctx){writeSession.ctx=ctx;resetFormScroll(ctx);ensureFormProductImage(ctx)}}});};
  const obs=new MutationObserver(ms=>{for(const m of ms)if(m.addedNodes?.length){refresh();break}});obs.observe(document.documentElement,{subtree:true,childList:true});
  addEventListener('resize',refresh,{passive:true});
  addEventListener('pageshow',refresh,{passive:true});
})();
/* HARDRIP V20.165 - WRITE REVIEW NATIVE CLOSE + BADGE COMPOSITOR + HOME RUNTIME LIVE SYNC + ORIGINAL MEDIA VIEWER END */
